import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import { makeStyles } from "@material-ui/core/styles";
import BajaMultiple from "../../BajaMultiple";
import GraficaPendientesTaller from "../Cortes/GraficaPendientesTaller";
import GraficaPorCortarCliente from "./GraficaPorCortarCliente";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ListadoOrdenesCorte() {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // L110-fix — catálogo completo de colores para el alta de talla/color
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // (2026-07) catálogo de tallas para ofrecer también las VARIANTES de las tallas del artículo
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  // Agregar Tela a Orden de Produccion
  const URL_TELAS_ORDENES_CORTE = process.env.REACT_APP_URL_TELAS_ORDENES_CORTE;
  // L12 (2026-06) — fallback de composición desde el catálogo de Telas
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_TELAS_ORDENES_CORTES_ACUMULADOS =
    process.env.REACT_APP_URL_TELAS_ORDENES_CORTES_ACUMULADOS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_ORDENES_CORTES =
    process.env.REACT_APP_URL_HABILITACION_ORDENES_CORTES;
  const URL_DETALLE_HABILITACION_ORDENES_CORTES =
    process.env.REACT_APP_URL_DETALLE_HABILITACION_ORDENES_CORTES;
  const URL_CONSUMO_TELAS = process.env.REACT_APP_URL_CONSUMO_TELAS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
  const [ordenesCorte, setOrdenesCorte] = useState([]);

  const [inventarios, setInventarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [articulos, setArticulos] = useState([]);
  // (2026-10) línea (subDepartamento) de cada artículo, para mostrarla junto
  // al modelo: "237 - SACO M/L" (tabla, PDF y Excel del listado). Sale del
  // catálogo que ya carga el filtro.
  const lineaPorArticulo = useMemo(() => {
    const m = {};
    (articulos || []).forEach((x) => {
      m[String(x._id)] = x.subDepartamentos?.[0]?.name || "";
    });
    return m;
  }, [articulos]);
  const modeloConLinea = (a) =>
    [a.articulo, lineaPorArticulo[String(a.idArticulo)] || ""]
      .filter((t) => t)
      .join(" - ");
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedCortado, setSelectedCortado] = useState("No");
  const [selectedAutorizacionMolde, setSelectedAutorizacionMolde] =
    useState("");
  // L121 (2026-06) — filtro Recibido: "Si" si alguien ya marcó recibido, "No" si
  // nadie; default "No"; "" = Todos
  const [selectedRecibido, setSelectedRecibido] = useState("Si");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  // (2026-10) fechas vigentes del filtro, para que la recarga después de
  // guardar (que corre en callbacks async) use las actuales y no las viejas
  const fechasFiltroRef = useRef({ inicio: startDate, fin: endDate });
  fechasFiltroRef.current = { inicio: selectedFechaInicio, fin: selectedFechaFin };
  // (2026-10) folio de la última carga del listado: si llegan dos respuestas
  // cruzadas (cambio de fechas + refresco) solo se pinta la más reciente
  const cargaOrdenesSeq = useRef(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [articulosEdit, setArticulosEdit] = useState([]);
  const [total_piezas, setTotalPiezas] = useState(0);
  // L110 (2026-06) — agregar talla/color del mismo artículo dentro del modal Editar
  const [agregarArticulo, setAgregarArticulo] = useState(""); // idArticulo elegido
  const [agregarTallas, setAgregarTallas] = useState([]); // catálogo de tallas del artículo
  const [agregarColores, setAgregarColores] = useState([]); // catálogo de colores del artículo
  const [agregarTalla, setAgregarTalla] = useState("");
  const [agregarColor, setAgregarColor] = useState("");
  const [agregarCantidad, setAgregarCantidad] = useState("");

  const classes = useStyles();

  const [validaBoton, setValidaBoton] = useState(true);

  const [fechaTelas, setFechaTelas] = useState(endDate);
  const [observacionesTelas, setObservacionesTelas] = useState("NA");
  const [responsableTelas, setResponsableTelas] = useState("NA");
  const [observacionesTelasPDF, setObservacionesTelasPDF] = useState("");
  const [responsableTelasPDF, setResponsableTelasPDF] = useState("");
  const [selectedOrdenCorte, setSelectedOrdenCorte] = useState("");
  const [selectedOrdenCorteNumero, setSelectedOrdenCorteNumero] = useState("");
  const [totalMetros, setTotalMetros] = useState("");
  const [totalKilos, setTotalKilos] = useState("");
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [rollosTotales, setRollosTotales] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalTelas, setModalTelas] = useState(false);
  const toggleTelas = () => setModalTelas(!modalTelas);

  const [explosion, setExplosion] = useState([]);
  const [idEdit, setIdEdit] = useState("");
  const [numero_pedido, setNumeroPedido] = useState("");
  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);

  const [telasDevolucion, setTelasDevolucion] = useState("");
  // L12 (2026-06) — catálogo de telas para fallback de composición
  const [telasCatalogo, setTelasCatalogo] = useState([]);
  const [idsInventario, setIdsInventario] = useState("");
  const [selectedOrdenCorteDev, setSelectedOrdenCorteDev] = useState("");
  const [selectedOrdenCorteNumeroDev, setSelectedOrdenCorteNumeroDev] =
    useState("");
  const [modalTelasDev, setModalTelasDev] = useState(false);
  const toggleTelasDev = () => setModalTelasDev(!modalTelasDev);
  const [rollosTotalesDev, setRollosTotalesDev] = useState(0);

  const [statusTelaEdit, setStatusTelaEdit] = useState("");
  const [observacionesStatusTelaEdit, setObservacionesStatusTelaEdit] =
    useState("");
  const [modalStatusEdit, setModalStatusEdit] = useState(false);
  const toggleStatusEdit = () => setModalStatusEdit(!modalStatusEdit);

  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [numeroInternoEdit, setNumeroInternoEdit] = useState("");
  // (2026-10) subárea de la orden (sale junto al cliente)
  const [subAreaEdit, setSubAreaEdit] = useState("NA");
  // (2026-10) fechas en Editar Orden: la de la orden y la de entrega (pedido)
  const [fechaOrdenEdit, setFechaOrdenEdit] = useState("");
  const [fechaEntregaEdit, setFechaEntregaEdit] = useState("");
  const [fechaEntregaOriginal, setFechaEntregaOriginal] = useState("");
  const [pedidoEdit, setPedidoEdit] = useState({ id: "", numero: "" });
  const [modalObservacionesEdit, setModalObservacionesEdit] = useState(false);
  const toggleObservacionesEdit = () =>
    setModalObservacionesEdit(!modalObservacionesEdit);

  const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
  const [habilitacion, setHabilitacion] = useState([]);

  const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
  const [idCorteHab, setIdCorteHab] = useState("");
  const [idPedidoHab, setIdPedidoHab] = useState("");
  const [idProveedorHab, setIdProveedorHab] = useState("");
  const [fechaHab, setFechaHab] = useState("");
  const [observacionesHab, setObservacionesHab] = useState("");

  const [modalHabilitacion, setModalHabilitacion] = useState(false);
  const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
  const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
    {
      id: uuidv4(),
      idHabilitacion: "",
      cantidad: 0,
    },
  ]);

  const [editHab, setEditHab] = useState([]);
  const [modalEditHab, setModalEditHab] = useState(false);
  const toggleEditHab = () => setModalEditHab(!modalEditHab);

  const [modalTelasConsumo, setModalTelasConsumo] = useState(false);
  const toggleTelasConsumo = () => setModalTelasConsumo(!modalTelasConsumo);
  const [inputFieldsAnteriorConsumo, setInputFieldsAnteriorConsumo] = useState(
    [],
  );
  //--- Pagination
  const [comments, setComments] = useState([]);
  // (2026-08) { idPedido: "AREA 1, AREA 2" } para buscar por área en el search
  const [areasPorPedido, setAreasPorPedido] = useState({});
  // (2026-08) recuadros de piezas pendientes de cortar y cortadas sin recibir
  // (2026-10) gráfica de un recuadro en modal: "porCortar" (por cliente) o
  // "enProceso" (por taller); el detalle se pide al abrirla para que salga
  // al día y cuadre con el recuadro
  const [graficaKpi, setGraficaKpi] = useState(null);
  const [detalleKpis, setDetalleKpis] = useState(null);
  const [cargandoDetalleKpis, setCargandoDetalleKpis] = useState(false);
  const [kpis, setKpis] = useState({
    ordenesPendientes: 0,
    piezasPendientesCortar: 0,
    cortesSinCerrar: 0,
    piezasCortadasSinRecibir: 0,
  });
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idInventarioTelas: "",
      telas: "",
      idTela: "",
      unidad: "",
      colores: "",
      idColor: "",
      cantidadOriginal: 0,
      cantidad: 0,
      idArticulo: "",
      compras: "",
      telasOC: "",
      telaCodigo: "",
      telaNombre: "",
      telaColor: "",
    },
  ]);

  const [inputFieldsAnterior, setInputFieldsAnterior] = useState([]);

  // (2026-10) Carga del listado, reutilizable: al montar / cambiar fechas y
  // después de cada guardado (antes se recargaba toda la página).
  function cargarOrdenes() {
    const { inicio, fin } = fechasFiltroRef.current;
    const seq = ++cargaOrdenesSeq.current;
    axios
      .get(
        `${URL_ORDENES_CORTE}Fechas/${inicio}/${fin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((response) => {
        if (seq !== cargaOrdenesSeq.current) return; // respuesta vieja
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenesCorte < b.idOrdenesCorte ? 1 : -1))
          .map((a) => {
            try {
              const ped = a.pedidos?.[0];
              const cli = ped?.clientes?.[0];
              const art = a.articulos?.[0];
              const mar = ped?.marcas?.[0];
              // (2026-08) El Monarch se captura en "Observaciones (Monarch)" del
              // pedido (campo observaciones). Los pedidos viejos que traían el
              // campo de marca lo siguen mostrando como respaldo.
              const obsMonarch = String(ped?.observaciones ?? "").trim();
              const obsMarca = String(ped?.observacionesMarca ?? "").trim();
              return {
                _id: a._id,
                numero: a.idOrdenesCorte,
                numeroInterno: (a.numero || "").trim(),
                fecha: a.fecha,
                pedido: ped?.idPedido ?? "",
                idPedidos: ped?._id ?? "",
                cortado: a.cortado,
                autorizacionMolde: a.autorizacionMolde,
                // (2026-08) Autorización de la orden (bloquea editar artículos)
                autorizacion: a.autorizacion || "No",
                autorizacionUser:
                  a.autorizacionUser?.nombre || a.autorizacionUser?.name || "",
                autorizacionFecha: a.autorizacionFecha || "",
                cliente: (() => {
                  // (2026-09) subcliente entre paréntesis, como en ListadoPedidos
                  // (2026-10) y la subárea de la orden, también entre paréntesis
                  const nombre = cli?.nombre_comercial ?? "";
                  const conDato = (v) => {
                    const t = String(v ?? "").trim();
                    return t && t.toUpperCase() !== "NA" ? t : "";
                  };
                  const sub = conDato(ped?.subCliente);
                  const subArea = conDato(a.subArea);
                  return [nombre, sub && `(${sub})`, subArea && `(${subArea})`]
                    .filter(Boolean)
                    .join(" ");
                })(),
                subArea: String(a.subArea ?? "").trim() || "NA",
                idCliente: cli?._id ?? "",
                articulo: art?.codigo ?? "",
                articuloCodigo: art?.codigo ?? "",
                articuloDescripcion: art?.descripcion ?? "",
                idArticulo: art?._id ?? "",
                fechaCancelacion: ped?.fecha_cancelacion ?? "",
                total_piezas: a.cantidad,
                observaciones: a.observaciones,
                observacionesPedido: ped?.observaciones ?? "",
                monarch:
                  obsMonarch && obsMonarch.toUpperCase() !== "NA"
                    ? obsMonarch
                    : obsMarca,
                // (2026-08) Tipo de entrega del pedido, para el PDFOC
                tipoEntrega: ped?.tipo ?? "",
                is_active: a.is_active,
                statusTela: a.statusTela,
                observacionesStatusTela: a.observacionesStatusTela,
                pedidoEditado: ped?.editado,
                corteExterno: a.corteExterno,
                marca: mar?.name ?? "",
                idMarca: mar?._id ?? "",
                // L43 (2026-06) — vendedor del pedido para los PDFs
                nombreFirma: ped?.nombreFirma ?? "",
                recibidos: Array.isArray(a.recibidos)
                  ? a.recibidos
                      .map((r) => {
                        const u = r?.user || {};
                        const uid = typeof u === "string" ? u : u?._id || "";
                        const nombre =
                          typeof u === "string"
                            ? ""
                            : `${u.nombre || ""} ${u.apellido || ""}`.trim() ||
                              u.email ||
                              "";
                        return {
                          userId: String(uid || ""),
                          nombre,
                          fecha: r?.fecha || "",
                        };
                      })
                      .filter((r) => r.userId)
                  : [],
                recibido:
                  Array.isArray(a.recibidos) && a.recibidos.length > 0
                    ? "Si"
                    : "No",
              };
            } catch (err) {
              console.warn(
                "OrdenCorte con datos incompletos, se omite:",
                a?._id,
                err
              );
              return null;
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setOrdenesCorte(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useMemo(() => {
    cargarOrdenes();
  }, [selectedFechaInicio, selectedFechaFin]);

  // (2026-08) Áreas dadas de alta en cada pedido, para poder buscarlas en el
  // search del listado. Se pide en bloques para no armar URLs enormes.
  useEffect(() => {
    const ids = [
      ...new Set(comments.map((c) => c.idPedidos).filter(Boolean)),
    ].map(String);

    if (!ids.length) {
      setAreasPorPedido({});
      return;
    }

    let cancelado = false;
    const bloques = [];
    for (let i = 0; i < ids.length; i += 60) bloques.push(ids.slice(i, i + 60));

    Promise.all(
      bloques.map((b) =>
        axios
          .get(`${URL_ARTICULOS_PEDIDO}/areasPedidos/${b.join(",")}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((r) => r.data || {})
          .catch((err) => {
            console.log("areasPedidos err:", err);
            return {};
          }),
      ),
    ).then((partes) => {
      if (cancelado) return;
      const mapa = {};
      partes.forEach((p) =>
        Object.keys(p).forEach((k) => {
          mapa[k] = (p[k] || []).join(", ");
        }),
      );
      setAreasPorPedido(mapa);
    });

    return () => {
      cancelado = true;
    };
  }, [comments]);

  // (2026-08) Indicadores de los recuadros de arriba
  // (2026-10) en función para volver a pedirlos después de guardar
  // (2026-10) clic en un taller de la gráfica: abre Procesos Pendientes con sus
  // salidas (contratos) de taller, desde la más antigua que sigue pendiente
  function verSalidasTaller(idTaller) {
    const suyas = (detalleKpis?.enProceso || []).filter(
      (x) => String(x.idMaquilero) === String(idTaller)
    );
    const desde = suyas
      .map((x) => String(x.fecha || "").slice(0, 10))
      .filter((f) => f)
      .sort()[0];
    const idProceso = suyas.find((x) => x.idProceso)?.idProceso || "";
    const params = new URLSearchParams({ taller: idTaller });
    if (idProceso) params.set("proceso", idProceso);
    if (desde) params.set("desde", desde);
    setGraficaKpi(null);
    history.push(`/CortesPendientesRecibir?${params.toString()}`);
  }

  function abrirGraficaKpi(tipo) {
    setGraficaKpi(tipo);
    setCargandoDetalleKpis(true);
    axios
      .get(`${URL_ORDENES_CORTE}KpisDetalle`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setDetalleKpis(res.data || null))
      .catch((err) => {
        console.log("detalle kpis ordenesCorte err:", err);
        Swal.fire("Error", "No se pudo cargar la gráfica", "error");
        setGraficaKpi(null);
      })
      .finally(() => setCargandoDetalleKpis(false));
  }

  function cargarKpis() {
    axios
      .get(`${URL_ORDENES_CORTE}Kpis`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setKpis((prev) => ({ ...prev, ...(res.data || {}) })))
      .catch((err) => console.log("kpis ordenesCorte err:", err));
  }

  useEffect(() => {
    cargarKpis();
  }, []);

  // (2026-10) Rollos en existencia (los usa BuscaRollo en la salida de tela).
  // Se vuelve a pedir después de una salida o devolución de tela.
  function cargarInventarios() {
    axios
      .get(`${URL_INVENTARIOS_TELAS}Existencia`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // (2026-10) Refresco en sitio después de guardar (sustituye al reload):
  // listado + KPIs; con { telas: true } también los rollos en existencia.
  function refrescarDatos({ telas = false } = {}) {
    cargarOrdenes();
    cargarKpis();
    if (telas) cargarInventarios();
  }

  // (2026-10) Deja limpia la captura de rollos (salida / devolución), como
  // quedaba con el reload: una fila vacía, totales en cero y datos default.
  function limpiaCapturaTelas() {
    setInputFields([
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        idColor: "",
        cantidadOriginal: 0,
        cantidad: 0,
        idArticulo: "",
        compras: "",
        telasOC: "",
        telaCodigo: "",
        telaNombre: "",
        telaColor: "",
      },
    ]);
    setCantidadAgrupado([]);
    setTotalMetros("");
    setTotalKilos("");
    setRollosTotales(0);
    setRollosTotalesDev(0);
    setFechaTelas(endDate);
    setObservacionesTelas("NA");
    setResponsableTelas("NA");
  }

  // L12 (2026-06) — cargar catálogo de Telas para fallback de composición en PDF
  useEffect(() => {
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setTelasCatalogo(res.data || []))
      .catch((err) => console.log("telasCatalogo err:", err));
  }, []);

  useEffect(() => {
    cargarInventarios();

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // (2026-09) PDF / Excel / mail con las mismas columnas y filtros que la tabla
  const columnasListado = [
    "# Articulo", "OP", "Fecha Creacion", "Cliente", "Modelo", "Marca",
    "Monarch", "Status Tela", "Obs. Tela", "Observaciones", "Fecha Entrega",
    "Cantidad", "Pedido Interno", "Cortado", "Aut. Molde", "Autorizada", "Recibido",
  ];
  const filaListado = (a) => [
    a.numero,
    a.numeroInterno,
    a.fecha,
    a.cliente,
    modeloConLinea(a),
    a.marca,
    a.monarch,
    a.statusTela,
    a.observacionesStatusTela,
    a.observaciones,
    a.fechaCancelacion,
    new Intl.NumberFormat("en-US").format(a.total_piezas || 0),
    a.pedido,
    a.cortado,
    a.autorizacionMolde,
    a.autorizacion === "Si" ? "Si" : "No",
    a.recibido,
  ];
  const docListadoPDF = () => {
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Produccion`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    const totalPiezas = ordenesFiltradas.reduce(
      (s, a) => s + Number(a.total_piezas || 0),
      0
    );
    doc.autoTable({
      head: [columnasListado],
      body: ordenesFiltradas.map(filaListado),
      foot: [[
        "TOTAL", "", "", "", "", "", "", "", "", "", "",
        new Intl.NumberFormat("en-US").format(totalPiezas), "", "", "", "", "",
      ]],
      startY: 45,
      styles: { fontSize: 6.5, cellPadding: 1 },
      headStyles: { fontSize: 6.5 },
      footStyles: { fontSize: 6.5, fontStyle: "bold" },
      columnStyles: { 9: { cellWidth: 40 }, 6: { cellWidth: 28 } },
    });
    return doc;
  };

  function PDFTabla() {
    if (!ordenesFiltradas.length) {
      return Swal.fire("Sin datos", "No hay órdenes con los filtros actuales", "warning");
    }
    const doc = docListadoPDF();
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    if (!ordenesFiltradas.length) {
      return Swal.fire("Sin datos", "No hay órdenes con los filtros actuales", "warning");
    }
    const claves = [
      "Articulo", "OP", "FechaCreacion", "Cliente", "Modelo", "Marca",
      "Monarch", "StatusTela", "ObsTela", "Observaciones", "FechaEntrega",
      "Cantidad", "PedidoInterno", "Cortado", "AutMolde", "Autorizada", "Recibido",
    ];
    const dataExcelLimpia = ordenesFiltradas.map((a) => ({
      Articulo: a.numero,
      OP: a.numeroInterno,
      FechaCreacion: a.fecha,
      Cliente: a.cliente,
      Modelo: modeloConLinea(a),
      Marca: a.marca,
      Monarch: a.monarch,
      StatusTela: a.statusTela,
      ObsTela: a.observacionesStatusTela,
      Observaciones: a.observaciones,
      FechaEntrega: a.fechaCancelacion,
      Cantidad: Number(a.total_piezas || 0),
      PedidoInterno: a.pedido,
      Cortado: a.cortado,
      AutMolde: a.autorizacionMolde,
      Autorizada: a.autorizacion === "Si" ? "Si" : "No",
      Recibido: a.recibido,
    }));

    var option = {};
    option.fileName = "ListadoOrdenesCorte";
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCorte",
        sheetFilter: claves,
        sheetHeader: columnasListado,
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    if (!ordenesFiltradas.length) {
      return Swal.fire("Sin datos", "No hay órdenes con los filtros actuales", "warning");
    }
    const doc = docListadoPDF();
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Corte",
          email: mailTo,
          fileName: "ListadoOrdenesCorte.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Produccion.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then(() => {
        // (2026-10) sin reload: el envío no cambia datos, solo se cierra el modal
        setModalMail(false);
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "# Articulo", field: "numero", sortable: true },
    { name: "OP", field: "numeroInterno", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: false },
    { name: "Cliente", field: "cliente", sortable: false },
    { name: "Modelo", field: "articulo", sortable: false },
    { name: "Marca", field: "marca", sortable: false },
    { name: "Monarch", field: "monarch", sortable: false },
    { name: "Status Tela", field: "statusTela", sortable: true },
    {
      name: "observaciones Tela",
      field: "observacionesStatusTela",
      sortable: true,
    },
    { name: "Observaciones", field: "observaciones", sortable: false },
    { name: "Fecha Entrega", field: "fechaCancelacion", sortable: false },
    { name: "Cantidad", field: "total_piezas", sortable: false },
    { name: "Pedido Interno", field: "pedido", sortable: true },
    { name: "Cortado", field: "cortado", sortable: true },
    { name: "Aut. Molde", field: "autorizacionMolde", sortable: true },
    { name: "Autorizada", field: "autorizacion", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Tela", field: "Tela", sortable: false },
    { name: "Recibido", field: "recibido", sortable: true },
    // { name: "Habilitacion", field: "Habilitacion", sortable: false },
  ];

  // (2026-09) Lista filtrada y ordenada SIN paginar: la usan la tabla (que
  // luego pagina) y el PDF / Excel / mail, para que salgan igual que la pantalla.
  const ordenesFiltradas = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          modeloConLinea(comment).toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusTela.toLowerCase().includes(search.toLowerCase()) ||
          comment.observacionesStatusTela
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.fechaCancelacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.cortado.toLowerCase().includes(search.toLowerCase()) ||
          comment.autorizacionMolde
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search) ||
          comment.total_piezas.toString().includes(search) ||
          comment.pedido.toString().includes(search) ||
          // (2026-08) áreas dadas de alta en el pedido
          String(areasPorPedido[comment.idPedidos] || "")
            .toLowerCase()
            .includes(search.toLowerCase()),
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio,
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin,
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente),
      );
    }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo),
      );
    }
    if (selectedCortado) {
      computedComments = computedComments.filter((e) =>
        e.cortado.includes(selectedCortado),
      );
    }
    if (selectedAutorizacionMolde) {
      computedComments = computedComments.filter((e) =>
        e.autorizacionMolde.includes(selectedAutorizacionMolde),
      );
    }
    // L121 — filtro Recibido ("" = Todos)
    if (selectedRecibido) {
      computedComments = computedComments.filter(
        (e) => e.recibido === selectedRecibido,
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_piezas" &&
      sorting.field != "numero" &&
      sorting.field != "pedido"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) =>
          reversed *
          String(a[sorting.field] ?? "").localeCompare(
            String(b[sorting.field] ?? "")
          ),
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    return computedComments;
  }, [
    comments,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    selectedArticulo,
    selectedCortado,
    selectedAutorizacionMolde,
    selectedRecibido,
    areasPorPedido,
    lineaPorArticulo,
  ]);

  const commentsData = useMemo(
    () =>
      ordenesFiltradas.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      ),
    [ordenesFiltradas, currentPage]
  );

  let totalCantidad = 0;
  let totalCortado = 0;
  let totalPendCortar = 0;

// ============================================================================
// COMPOSICIÓN DE LA TELA desde el catálogo de Telas.
// El renglón del pedido casi siempre trae la composición en "NA", así que se
// busca por nombre de tela. Los nombres no coinciden letra por letra: el pedido
// dice "TOKIO" y el catálogo "TOKIO MED ". Por eso, además del match exacto, se
// aceptan los nombres que se contienen entre sí (por palabra completa), pero
// sólo cuando todos los candidatos comparten la misma composición: con "BAMBOO"
// hay cuatro telas distintas y ahí no se adivina.
// ============================================================================
function buscaComposicionTela(nombreTela, telasCatalogo) {
  const norm = (v) =>
    String(v === null || v === undefined ? "" : v)
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();

  const objetivo = norm(nombreTela);
  if (objetivo.length < 3 || objetivo === "NA") return "";

  const lista = (Array.isArray(telasCatalogo) ? telasCatalogo : []).filter(
    (t) => norm(t?.nombre) && norm(t?.composicion) && norm(t?.composicion) !== "NA"
  );

  const exacto = lista.find((t) => norm(t.nombre) === objetivo);
  if (exacto) return String(exacto.composicion).trim();

  const escapa = (v) => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const contiene = (texto, parte) =>
    texto === parte || new RegExp(`(^| )${escapa(parte)}( |$)`).test(texto);

  const candidatos = lista.filter((t) => {
    const nombre = norm(t.nombre);
    return contiene(nombre, objetivo) || contiene(objetivo, nombre);
  });
  if (!candidatos.length) return "";

  const distintas = [...new Set(candidatos.map((t) => norm(t.composicion)))];
  if (distintas.length !== 1) return "";

  return String(candidatos[0].composicion).trim();
}

// ============================================================================
// FICHA TÉCNICA DE BORDADOS (estilo Word): banda + rejilla de celdas con borde
// (imagen arriba, observación debajo). Autocontenida: hace su propio addPage
// y su propia paginación. Reutilizable en los PDFs que imprimen bordados.
// ============================================================================
async function dibujarFichaBordados(doc, bordadosFinal, opts) {
  const {
    getCloudinaryUrl,
    loadImagePDF,
    pageWidth,
    marginLeft,
    marginTop = 15,
    brandColor,
    lightBg = [245, 247, 250],
    borderColor = [210, 216, 224],
    labelColor = [110, 120, 135],
    s = (v) => (v == null ? "" : String(v)),
  } = opts || {};

  if (!Array.isArray(bordadosFinal) || !bordadosFinal.length) return;

  const pageHeight = doc.internal.pageSize.getHeight();
  const marginBottom = 15;
  const usableW = pageWidth - marginLeft * 2;

  // Carga robusta: fetch → blob → dataURL (evita "tainted canvas" por CORS);
  // fallback al loader que pase el archivo.
  const cacheImagen = new Map();
  const cargarImagen = async (url) => {
    if (!url) return null;
    if (cacheImagen.has(url)) return cacheImagen.get(url);
    const data = await bajaImagen(url);
    cacheImagen.set(url, data);
    return data;
  };

  const bajaImagen = async (url) => {
    try {
      const resp = await fetch(url, { mode: "cors" });
      if (resp.ok) {
        const blob = await resp.blob();
        const dataUrl = await new Promise((res) => {
          const r = new FileReader();
          r.onloadend = () => res(r.result);
          r.onerror = () => res(null);
          r.readAsDataURL(blob);
        });
        if (dataUrl) return dataUrl;
      }
    } catch (e) {
      /* fallback abajo */
    }
    if (typeof loadImagePDF === "function") {
      return await loadImagePDF(url).catch(() => null);
    }
    return null;
  };

  // (2026-09) El mismo bordado se sube por separado en cada artículo (distinto
  // public_id y version), así que el logo salía repetido en varias fichas y en
  // producción lo reportaban como duplicado. Se juntan los artículos que traen
  // exactamente los mismos bordados —misma imagen y misma observación— para
  // imprimirlo una sola vez con los artículos en el encabezado.
  const hashTexto = (txt) => {
    let h = 5381;
    for (let i = 0; i < txt.length; i += 1) h = ((h * 33) ^ txt.charCodeAt(i)) >>> 0;
    return `${h}-${txt.length}`;
  };

  const claveBordado = async (b) => {
    const obs = s(b?.observacion).replace(/\s+/g, " ").trim().toUpperCase();
    const img = await cargarImagen(getCloudinaryUrl(b?.public_id));
    return `${obs}||${img ? hashTexto(String(img)) : s(b?.public_id)}`;
  };

  const porFirma = new Map();
  const grupos = [];
  for (const item of bordadosFinal) {
    const claves = [];
    for (const b of Array.isArray(item.bordados) ? item.bordados : []) {
      claves.push(await claveBordado(b));
    }
    const firma = `${s(item.area).trim().toUpperCase()}||${[...claves]
      .sort()
      .join("##")}`;

    const previo = porFirma.get(firma);
    if (previo) {
      if (!previo.articulos.includes(s(item.articulo))) {
        previo.articulos.push(s(item.articulo));
      }
      continue;
    }

    const nuevo = { ...item, articulos: [s(item.articulo)] };
    porFirma.set(firma, nuevo);
    grupos.push(nuevo);
  }

  doc.addPage();
  let y = marginTop;

  const room = (needed) => {
    if (y + needed > pageHeight - marginBottom) {
      doc.addPage();
      y = marginTop;
    }
  };

  // Banda "FICHA TÉCNICA DE BORDADOS"
  doc.setFillColor(...brandColor);
  doc.rect(marginLeft, y, usableW, 9, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont(undefined, "bold");
  doc.setFontSize(12.5);
  doc.text("FICHA TÉCNICA DE BORDADOS", pageWidth / 2, y + 6.3, {
    align: "center",
  });
  doc.setTextColor(0);
  doc.setFont(undefined, "normal");
  y += 14;

  const cols = 3;
  const cellGap = 6;
  const cellW = (usableW - cellGap * (cols - 1)) / cols;
  const cellPad = 3;
  const imgAreaH = 46;
  const capFont = 8.5;
  const capLineH = 4;

  for (const item of grupos) {
    // Encabezado del artículo (banda clara con borde). Cuando varios artículos
    // comparten el bordado se listan todos aquí.
    doc.setFont(undefined, "bold");
    doc.setFontSize(9.5);
    const titulo = `${(item.articulos && item.articulos.length
      ? item.articulos
      : [s(item.articulo)]
    ).join("   /   ")}   ·   Área: ${s(item.area)}`;
    const tituloLineas = doc.splitTextToSize(titulo, usableW - 6);
    const headH = Math.max(8, tituloLineas.length * 4.6 + 3);
    room(headH + imgAreaH + 16);
    doc.setFillColor(...lightBg);
    doc.setDrawColor(...borderColor);
    doc.setLineWidth(0.3);
    doc.rect(marginLeft, y, usableW, headH, "FD");
    doc.setDrawColor(0);
    doc.setTextColor(...brandColor);
    tituloLineas.forEach((linea, i) => {
      doc.text(linea, marginLeft + 3, y + 5.5 + i * 4.6);
    });
    doc.setTextColor(0);
    doc.setFont(undefined, "normal");
    y += headH + 3;

    const itemsB = Array.isArray(item.bordados) ? item.bordados : [];
    for (let i = 0; i < itemsB.length; i += cols) {
      const rowItems = itemsB.slice(i, i + cols);

      // preparar: cargar imagen + medir caption para nivelar el alto de la fila
      const prepared = [];
      let maxCapH = 0;
      for (const bordado of rowItems) {
        const imgData = await cargarImagen(getCloudinaryUrl(bordado.public_id));
        const capLines = bordado.observacion
          ? doc.splitTextToSize(String(bordado.observacion), cellW - cellPad * 2)
          : [];
        const capH = capLines.length * capLineH;
        if (capH > maxCapH) maxCapH = capH;
        prepared.push({ imgData, capLines });
      }

      const rowH = imgAreaH + (maxCapH > 0 ? maxCapH + 4 : 2) + cellPad;
      room(rowH + 4);

      let cx = marginLeft;
      for (const cell of prepared) {
        // borde de la celda
        doc.setDrawColor(...borderColor);
        doc.setLineWidth(0.3);
        doc.rect(cx, y, cellW, rowH);
        doc.setDrawColor(0);

        // imagen centrada en el área superior
        if (cell.imgData) {
          const props = doc.getImageProperties(cell.imgData);
          let w = cellW - cellPad * 2;
          let h = (props.height * w) / props.width;
          const maxH = imgAreaH - cellPad * 2;
          if (h > maxH) {
            h = maxH;
            w = (props.width * h) / props.height;
          }
          const ox = cx + (cellW - w) / 2;
          const oy = y + cellPad + (imgAreaH - cellPad * 2 - h) / 2;
          doc.addImage(cell.imgData, "PNG", ox, oy, w, h);
        } else {
          doc.setFontSize(7);
          doc.setTextColor(150);
          doc.text("Sin imagen", cx + cellW / 2, y + imgAreaH / 2, {
            align: "center",
          });
          doc.setTextColor(0);
        }

        // caption (observación) debajo de una línea divisoria
        if (cell.capLines.length) {
          doc.setDrawColor(...borderColor);
          doc.line(cx, y + imgAreaH, cx + cellW, y + imgAreaH);
          doc.setDrawColor(0);
          doc.setFont(undefined, "normal");
          doc.setFontSize(capFont);
          doc.setTextColor(...labelColor);
          doc.text(cell.capLines, cx + cellPad, y + imgAreaH + capLineH + 1);
          doc.setTextColor(0);
        }
        cx += cellW + cellGap;
      }
      y += rowH + cellGap;
    }
    y += 3;
  }
  doc.setLineWidth(0.2);
  return y;
}

async function PDFOC(
  numero,
  cliente,
  fecha,
  fechaCancelacion,
  pedido,
  idPedidos,
  articuloCodigo,
  articuloDescripcion,
  idArticulo,
  totalPiezas,
  observaciones,
  idPDFOC,
  marca,
  observacionesMarca,
  // L27 (2026-06) — resumido: junta cantidades de todas las áreas por modelo+tela
  resumido = false,
  // L43 (2026-06)
  nombreFirma = "",
  // L97 (2026-06) — número interno (igual que el PDF azul)
  numeroInterno = ""
) {
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstId = (arr) => s(arr?.[0]?._id);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDepto = (a) =>
    s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);

  const findApMatch = (a, articulosPedido = []) => {
    const pedidoId = s(a?.pedidos?.[0]?._id || a?.pedidos?.[0]);
    const articuloId = s(a?.articulos?.[0]?._id || a?.articulos?.[0]);
    const areaId = s(a?.areasClientes?.[0]?._id || a?.areasClientes?.[0]);
    // L26 (2026-06) — también emparejar por color para que la tela no se "comparta"
    // entre dos blusas del mismo pedido/articulo/area cuando son colores distintos.
    const colorId = s(a?.colores?.[0]?._id || a?.colores?.[0]);
    const exact = articulosPedido.find((x) => {
      const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
      const apColorId = s(x?.colores?.[0]?._id || x?.colores?.[0]);
      return (
        apPedidoId === pedidoId &&
        apArticuloId === articuloId &&
        apAreaId === areaId &&
        (colorId && apColorId ? apColorId === colorId : true)
      );
    });
    if (exact) return exact;
    // Fallback: si no hubo match con color (ej. articulosPedido sin color cargado),
    // caer al match original sin color para no perder la tela.
    return articulosPedido.find((x) => {
      const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
      return (
        apPedidoId === pedidoId &&
        apArticuloId === articuloId &&
        apAreaId === areaId
      );
    });
  };

  const getTelaName = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    return s(
      ap?.tela ||
        a?.articulosPedido?.[0]?.tela ||
        a?.tela ||
        ""
    );
  };

  const getComposicion = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    const directa = s(
      ap?.composicion ||
        a?.articulosPedido?.[0]?.composicion ||
        a?.composicion ||
        ""
    );
    if (directa) return directa;
    // L12 fallback: si el articulosPedido no trae composición, buscarla en el
    // catálogo de Telas matcheando por el nombre de tela.
    const telaName = s(
      ap?.tela ||
        a?.articulosPedido?.[0]?.tela ||
        a?.tela ||
        ""
    );
    if (!telaName) return "";
    return s(buscaComposicionTela(telaName, telasCatalogo));
  };

  const getTela = (a, articulosPedido = []) => {
    const tela = getTelaName(a, articulosPedido);
    const comp = getComposicion(a, articulosPedido);
    if (tela && comp) return `${tela} - ${comp}`;
    return tela || comp;
  };

  const getObservacionesArticulo = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    return s(
      ap?.observacionesArticulo ||
        a?.articulosPedido?.[0]?.observacionesArticulo ||
        a?.observacionesArticulo
    );
  };

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) {
      out.push(arr.slice(i, i + size));
    }
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  const getCloudinaryUrl = (publicId) => {
    const p = s(publicId).trim();
    if (!p) return "";
    if (p.startsWith("http")) return p;

    const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
      .replace(/\/$/, "")
      .replace(/\/image\/upload$/, "");

    return `${base}/image/upload/${p}`;
  };

  const loadImagePDF = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          resolve(null);
        }
      };

      img.onerror = () => resolve(null);
      img.src = src;
    });

const getBordados = (a, articulosPedido = []) => {
  const pedidoId = s(a?.pedidos?.[0]?._id || a?.pedidos?.[0]);
  const articuloId = s(a?.articulos?.[0]?._id || a?.articulos?.[0]);
  const areaId = s(a?.areasClientes?.[0]?._id || a?.areasClientes?.[0]);

  const ap = articulosPedido.find((x) => {
    const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
    const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
    const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);

    return (
      apPedidoId === pedidoId &&
      apArticuloId === articuloId &&
      apAreaId === areaId
    );
  });

  const bordados = ap?.bordados || [];

  if (!Array.isArray(bordados)) return [];

  return bordados
    .map((b) => ({
      observacion: s(b?.observacion || b?.observaciones || ""),
      public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
      version: s(b?.version || ""),
    }))
    .filter((b) => b.public_id || b.observacion);
};

  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const { data: allArticulosOrdenCorte } = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE}/orden/${idPDFOC}`,
      { headers }
    );

    const { data: allArticulosPedido } = await axios.get(
  `${URL_ARTICULOS_PEDIDO}/pedidos/${idPedidos}`,
  { headers }
);

    // L127 (2026-07) — Datos fiscales de la empresa propia (replica de ListadoPedidos).
    // La empresa viene poblada en el pedido de la orden: pedidos[0].empresas[0].
    // NOTA: requiere que el backend popule pedidos.empresas (ver resumen).
    const empresa =
      allArticulosOrdenCorte?.find((x) => x?.pedidos?.[0]?.empresas?.[0])
        ?.pedidos?.[0]?.empresas?.[0] || null;

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L43 (2026-06) — Paleta y helpers de diseño ===
    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    // ============ LOGO IZQUIERDA ============
    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      logo.onload = () => {
        const maxH = 18;
        const scale = maxH / logo.height;
        const w = logo.width * scale;
        const h = logo.height * scale;
        doc.addImage(logo, "PNG", marginLeft, 8, w, h);
        resolve();
      };
      logo.onerror = () => resolve();
    });

    // ============ TÍTULO + LÍNEA DIVISORIA ============
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`ORDEN PRODUCCIÓN # ${s(numero)}`, pageWidth - marginLeft, 18, { align: "right" });
    doc.setTextColor(0);

    // L127 (2026-07) — Datos fiscales de la empresa propia, debajo del folio
    if (empresa) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresa.razonSocial) || s(empresa.name) || "",
        pageWidth - marginLeft,
        23,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      const fiscalLine = [
        empresa.rfc ? `RFC: ${s(empresa.rfc)}` : "",
        empresa.regimenFiscal ? `Rég. Fiscal: ${s(empresa.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginLeft, 27, { align: "right" });
      }
      const direccionStr = [
        s(empresa.direccionFiscal),
        empresa.cp ? `C.P. ${s(empresa.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginLeft - (marginLeft + 60);
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginLeft, 31 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria (corro abajo si hay empresa para no encimar)
    const headerLineY = empresa ? 40 : 28;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ============ CARD 2 COLUMNAS DATOS ============
    const cardY = headerLineY + 3;
    const cardW = pageWidth - marginLeft * 2;

    // Columna derecha (se declara antes para poder medir el Monarch)
    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 26;

    // (2026-07) Monarch: si no cabe se parte en varios renglones (hasta 4)
    doc.setFont(undefined, "normal");
    doc.setFontSize(9.5);
    const monarchLines = doc
      .splitTextToSize(
        s(observacionesMarca).trim() || "—",
        pageWidth - marginLeft - valX_R,
      )
      .slice(0, 4);
    const cardH = 32 + (monarchLines.length - 1) * 4;

    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    // Columna izquierda
    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 28;
    const baseY = cardY + 6;
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Entrega:", fechaCancelacion, lblX_L, valX_L, baseY + 5);
    drawLabel("Cliente:", cliente, lblX_L, valX_L, baseY + 10);
    drawLabel("Pedido:", pedido, lblX_L, valX_L, baseY + 15);
    drawLabel("Marca:", marca, lblX_L, valX_L, baseY + 20);

    // L97 (2026-06) — mostrar Nº Interno (como el PDF azul) en vez de "OC:"
    drawLabel("Nº Interno:", numeroInterno, lblX_R, valX_R, baseY);
    drawLabel("Vendedor:", nombreFirma, lblX_R, valX_R, baseY + 5);
    drawLabel("Total Piezas:", sn(totalPiezas, 0), lblX_R, valX_R, baseY + 10);
    drawLabel("Monarch:", monarchLines[0], lblX_R, valX_R, baseY + 15);
    if (monarchLines.length > 1) {
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      monarchLines.slice(1).forEach((ln, i) => {
        doc.text(ln, valX_R, baseY + 19 + i * 4);
      });
    }

    currentY = cardY + cardH + 6;

    // ============ OBSERVACIONES — L43 caja con label band si hay texto ============
    const rawObs = String(observaciones ?? "")
      .trim()
      .replace(/\t/g, "  ")
      .replace(/\r/g, "")
      // quitar piezas "NA" (o vacías) unidas por " / "
      .split(" / ")
      .map((p) => p.trim())
      .filter((p) => p && p.toUpperCase() !== "NA")
      .join(" / ");
    if (rawObs) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("OBSERVACIONES", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const obsLines = doc.splitTextToSize(rawObs, pageWidth - marginLeft * 2 - 12);
      const blockH = obsLines.length * 4.2;
      ensureRoom(blockH + 6);
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(obsLines, marginLeft + 3, currentY + 4);
      currentY += blockH + 8;
    }

    let totalPiezasGlobal = 0;
    const bordadosMap = {};

    // =========================
    // Agrupar por Área / Artículo / Tela
    // =========================
    const grupoMap = {};

    allArticulosOrdenCorte.forEach((a) => {
      const areaSan =
        getFirstName(a.areasClientes) ||
        getFirstId(a.areasClientes) ||
        "Sin Área";

      const articuloSan =
        `${getArticuloCodigo(a)} ${getArticuloDepto(a)}`.trim() ||
        s(a?.articulos?.[0]?.descripcion) ||
        "Artículo sin nombre";

      const tela = getTelaName(a, allArticulosPedido) || "Sin Tela";

      const bordadosArticulo = getBordados(a, allArticulosPedido);

      if (bordadosArticulo.length > 0) {
        const bordadoKey = `${areaSan}||${articuloSan}`;

        if (!bordadosMap[bordadoKey]) {
          bordadosMap[bordadoKey] = {
            area: areaSan,
            articulo: articuloSan,
            bordados: [],
          };
        }

        bordadosArticulo.forEach((b) => {
          const existe = bordadosMap[bordadoKey].bordados.some(
            (x) =>
              x.public_id === b.public_id &&
              x.observacion === b.observacion &&
              x.version === b.version
          );

          if (!existe) {
            bordadosMap[bordadoKey].bordados.push(b);
          }
        });
      }

      // L27 (2026-06) — resumido: drop area del clave para juntar todas las áreas
      const clave = resumido
        ? `RESUMEN||${articuloSan}||${tela}`
        : `${areaSan}||${articuloSan}||${tela}`;

      if (!grupoMap[clave]) grupoMap[clave] = [];
      grupoMap[clave].push(a);
    });

    // =========================
    // Recorrer grupos
    // =========================
    for (const clave in grupoMap) {
      const grupo = grupoMap[clave];
      const [areaNombre, articuloNombre, telaNombre] = clave.split("||");

      const composicionGrupo = [
        ...new Set(
          grupo
            .map((a) => getComposicion(a, allArticulosPedido).trim())
            .filter((x) => x)
        ),
      ].join(" / ");

      const telaDisplay =
        composicionGrupo && s(telaNombre) && s(telaNombre) !== "Sin Tela"
          ? `${s(telaNombre)} - ${composicionGrupo}`
          : composicionGrupo || s(telaNombre) || "Sin Tela";

      const observacionesArticuloGrupo = [
        ...new Set(
          grupo
            .map((a) => getObservacionesArticulo(a, allArticulosPedido).trim())
            .filter((x) => x)
        ),
      ].join(" / ");

      // === L43 (2026-06) — Banda azul como header del grupo ===
      const bandH = 8;
      // L130 (2026-07) — Reservar banda + observaciones + encabezado y 1ª fila de la
      // tabla JUNTOS. Así la banda no queda huérfana al final de la hoja cuando la tabla
      // completa no cabe: la tabla arranca en la misma página y el resto fluye a la siguiente.
      doc.setFont(undefined, "italic");
      doc.setFontSize(9);
      const obsArticuloLines = observacionesArticuloGrupo
        ? doc.splitTextToSize(
            `Observaciones del artículo: ${observacionesArticuloGrupo}`,
            pageWidth - marginLeft * 2
          )
        : [];
      const obsArticuloHeight = obsArticuloLines.length * 4.2;
      doc.setFont(undefined, "normal");
      // Reservar SOLO banda + observaciones juntas (bloque chico). La tabla NO se
      // reserva: fluye justo debajo y autoTable la pagina/parte sola => sin huecos.
      ensureRoom(bandH + 3 + (obsArticuloHeight ? obsArticuloHeight + 3 : 1));
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      // L109 (2026-06) — DEPARTAMENTO del artículo (DAMA/CABALLERO) en el band
      const deptoGrupo = s(grupo[0]?.articulos?.[0]?.departamentos?.[0]?.name);
      const deptoTxt = deptoGrupo ? ` · DEPTO: ${deptoGrupo}` : "";
      // L123 (2026-06) — Orden de Producción (este PDF es de una sola orden = numero)
      const opTxt = s(numero) ? `# Articulo: ${s(numero)}` : "";
      const tituloGrupo = resumido
        ? `${opTxt} · Modelo: ${s(articuloNombre) || "Artículo sin nombre"}${deptoTxt} · Tela: ${telaDisplay}   (Resumen de todas las áreas)`
        : `${opTxt} · Área: ${s(areaNombre) || "Sin Área"}${deptoTxt} · Modelo: ${s(articuloNombre) || "Artículo sin nombre"} · Tela: ${telaDisplay}`;
      doc.text(tituloGrupo, marginLeft + 3, currentY + bandH - 2.5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 3;

      // ===== OBSERVACIONES DEL ARTÍCULO (italic negro) =====
      if (observacionesArticuloGrupo) {
        doc.setFont(undefined, "italic");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.text(obsArticuloLines, marginLeft + 2, currentY);
        currentY += obsArticuloHeight + 3;
        doc.setFont(undefined, "normal");
        doc.setTextColor(0);
      } else {
        currentY += 1;
      }

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // =========================
      // Agrupar por Color -> Variante -> Talla
      // =========================
      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      // L78 (2026-06) — ignorar combos con cantidad 0 en los PDFs
      grupo.filter((x) => Number(x?.cantidad || 0) > 0).forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";
        const varianteNameRaw = s(
          a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim()
        );
        const varianteName = varianteNameRaw ? varianteNameRaw : "Sin variante";
        const cantidad = sn(a?.cantidad, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) {
          data[color][varianteName][tallaName] = 0;
        }

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) {
          totalVariante[color][varianteName] = 0;
        }

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);
          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });

        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);

        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      let totalPiezasGrupo = 0;

      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      totalPiezasGlobal += totalPiezasGrupo;

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 30;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(
        1,
        Math.min(maxTallasPerRow, tallasOrdenadas.length)
      );

      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
                ? colorTxt
                : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row
                .slice(1, 1 + nTallas)
                .some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft, top: marginTop, bottom: marginBottom },
          tableWidth: usableWidth,
          // L43 (2026-06) — tabla profesional con zebra + color corporativo
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: [210, 216, 224],
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: [42, 90, 138],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [251, 252, 253],
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.halign = "left";

              const raw = hookData.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";

              if (txt && String(txt).includes("\n")) {
                hookData.cell.styles.fontStyle = "bold";
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // L43 (2026-06) — Total Prenda como chip
      ensureRoom(10);
      const chipTextG = `TOTAL PRENDA: ${totalPiezasGrupo}`;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "bold");
      const chipPad = 3;
      const chipW = doc.getTextWidth(chipTextG) + chipPad * 2;
      const chipH = 6;
      const chipX = pageWidth - marginLeft - chipW;
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(42, 90, 138);
      doc.setLineWidth(0.3);
      doc.roundedRect(chipX, currentY, chipW, chipH, 1.5, 1.5, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(42, 90, 138);
      doc.text(chipTextG, chipX + chipPad, currentY + chipH - 1.7);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setDrawColor(0);
      currentY += chipH + 4;

      // Divisor entre artículos: solo si cabe en la hoja actual (no forzar página
      // nueva para una rayita, evita hoja casi vacía antes de los bordados).
      if (currentY + 5 <= pageHeight - marginBottom) {
        doc.setDrawColor(210, 216, 224);
        doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
        doc.setDrawColor(0);
        currentY += 5;
      }
    }

    // =========================
    // Observaciones generales
    // =========================
    const observacionesTexto = s(observaciones).trim();

    if (observacionesTexto) {
      ensureRoom(10);

      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text("Observaciones Generales:", marginLeft, currentY);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      const maxWidthObs = pageWidth - marginLeft * 2;
      const obsLines = doc.splitTextToSize(observacionesTexto, maxWidthObs);
      const blockHeightObs = obsLines.length * 4.2;

      ensureRoom(blockHeightObs + 4);

      doc.text(obsLines, marginLeft, currentY, {
        maxWidth: maxWidthObs,
      });

      currentY += blockHeightObs + 8;
    }

    // =========================
    // Segunda hoja: bordados
    // =========================
    const bordadosFinal = Object.values(bordadosMap);

    if (bordadosFinal.length > 0) {
      await dibujarFichaBordados(doc, bordadosFinal, {
        getCloudinaryUrl,
        loadImagePDF,
        pageWidth,
        marginLeft,
        marginTop,
        brandColor,
        lightBg,
        borderColor,
        labelColor,
        s,
      });
    }

    // =========================
    // Tercera hoja: consumos
    // =========================
    // L123 (2026-06) — Hoja de Consumos del Pedido comentada a pedido del usuario
    if (false) {
    doc.addPage();
    currentY = 20;

    const [{ data: consumos }, { data: articulosPedido }] = await Promise.all([
      axios.get(`${URL_CONSUMO_TELAS}Pedido/${idPedidos}`, { headers }),
      axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedidos}`, {
        headers,
      }),
    ]);

    const idArticuloStr = String(idArticulo);
    let cantidadArticulo = 0;

    for (const ap of articulosPedido) {
      const arti = Array.isArray(ap.articulos) ? ap.articulos[0] : ap.articulos;
      const artiId = typeof arti === "object" ? arti?._id : arti;

      if (artiId && String(artiId) === idArticuloStr) {
        cantidadArticulo += Number(ap.cantidad || 0);
      }
    }

    const consumosFiltrados = (consumos || [])
      .filter((c) => Number(c.cantidad || 0) > 0)
      .map((c) => {
        const articuloRaw = Array.isArray(c.articulos)
          ? c.articulos[0]
          : c.articulos;

        const telaRaw = Array.isArray(c.telas) ? c.telas[0] : c.telas;

        const artiId =
          typeof articuloRaw === "object" ? articuloRaw?._id : articuloRaw;

        const matchesArticulo = artiId && String(artiId) === idArticuloStr;

        if (!matchesArticulo) return null;

        const articuloNombre =
          typeof articuloRaw === "object"
            ? `${articuloRaw.codigo || ""} ${articuloRaw.descripcion || ""}`.trim()
            : "";

        const telaNombre =
          typeof telaRaw === "object"
            ? telaRaw.nombre || "Sin nombre"
            : telaRaw || "Sin nombre";

        const ancho = typeof telaRaw === "object" ? telaRaw.ancho || "NA" : "NA";

        return {
          articuloNombre,
          tela: telaNombre,
          ancho,
          consumoUnitario: Number(c.cantidad || 0),
          observaciones: (c.observaciones || "").toString().trim() || "NA",
        };
      })
      .filter(Boolean);

    try {
      const logoLynqro = new Image();
      logoLynqro.src = process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png";

      await new Promise((resolve) => {
        logoLynqro.onload = () => {
          doc.addImage(logoLynqro, "PNG", pageWidth - 45, 10, 25, 7.5);
          resolve();
        };
        logoLynqro.onerror = () => resolve();
      });

      const logoInstitucion2 = new Image();
      logoInstitucion2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";

      await new Promise((resolve) => {
        logoInstitucion2.onload = () => {
          doc.addImage(logoInstitucion2, "PNG", pageWidth - 45, 18, 25, 14);
          resolve();
        };
        logoInstitucion2.onerror = () => resolve();
      });
    } catch (e) {
      console.warn("No se pudieron cargar logos de consumos");
    }

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(`Consumos del Pedido #${s(pedido)}`, marginLeft, currentY);
    currentY += 10;

    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    doc.text(`Cliente: ${s(cliente) || "NA"}`, marginLeft, currentY);
    currentY += 6;

    const nombreModelo =
      consumosFiltrados[0]?.articuloNombre ||
      `${s(articuloCodigo)} ${s(articuloDescripcion)}`.trim() ||
      "Modelo sin nombre";

    const modeloConsumoLines = doc.splitTextToSize(
      `Modelo: ${nombreModelo}`,
      pageWidth - 70
    );

    doc.setFont(undefined, "bold");
    doc.text(modeloConsumoLines, marginLeft, currentY);
    currentY += modeloConsumoLines.length * 5 + 4;

    if (!consumosFiltrados.length) {
      doc.setFontSize(11);
      doc.setFont(undefined, "normal");
      doc.text(
        "No hay consumos para este artículo en el pedido.",
        marginLeft,
        currentY
      );
      currentY += 8;
    } else {
      const body = consumosFiltrados.map((c) => {
        const totalConsumo = (c.consumoUnitario || 0) * (cantidadArticulo || 0);

        return [
          c.tela,
          c.ancho,
          Number(c.consumoUnitario || 0).toFixed(2),
          Number(cantidadArticulo || 0).toFixed(2),
          Number(totalConsumo || 0).toFixed(2),
          c.observaciones,
        ];
      });

      const totalArticulo = consumosFiltrados.reduce(
        (sum, c) => sum + (c.consumoUnitario || 0) * (cantidadArticulo || 0),
        0
      );

      body.push([
        {
          content: "Total",
          colSpan: 4,
          styles: { halign: "right", fontStyle: "bold" },
        },
        Number(totalArticulo || 0).toFixed(2),
        "",
      ]);

      doc.autoTable({
        head: [
          [
            "Tela",
            "Ancho",
            "Consumo Unitario",
            "Cantidad Artículo",
            "Total",
            "Observaciones",
          ],
        ],
        body,
        startY: currentY + 2,
        styles: {
          fontSize: 9,
          halign: "center",
          valign: "middle",
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [41, 128, 186],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 247, 250],
        },
        margin: { left: 20, right: 20 },
        columnStyles: {
          0: { halign: "left" },
          1: { halign: "center" },
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "left" },
        },
      });

      currentY = doc.autoTable.previous.finalY + 10;
    }
    } // L123 — fin Hoja de Consumos comentada

    // ============ FOOTER L43 — pie con paginación en cada página ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(110, 120, 135);
        // doc.text(
        //   `OC #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
        //   pageWidth / 2,
        //   pageHeight - 5,
        //   { align: "center" }
        // );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  async function PDFOCNumeroInterno(a, resumido = false) {
  // Si el número interno es "NA" o vacío, NO agrupamos — sólo la OC actual.
  // (varios OCs con numeroInterno="NA" no se deben juntar como si fueran del mismo lote)
  const numIntActual = String(a.numeroInterno || "").trim().toUpperCase();
  const esNA = numIntActual === "" || numIntActual === "NA";
  // (2026-10) los artículos dados de baja ya no salen en la OP; sólo si toda
  // la OP está dada de baja se imprime completa (para poder consultarla)
  const mismasOrdenes = esNA
    ? [a]
    : (() => {
        const todas = comments.filter(
          (oc) => String(oc.numeroInterno) === String(a.numeroInterno)
        );
        const activas = todas.filter((oc) => oc.is_active !== "No");
        return activas.length ? activas : todas;
      })();

  if (mismasOrdenes.length === 0) {
    Swal.fire("Error", "No se encontraron órdenes con ese número interno", "error");
    return;
  }

  const totalPiezas = mismasOrdenes.reduce(
    (sum, oc) => sum + Number(oc.total_piezas || 0),
    0
  );

  const pedidos = [
    ...new Set(mismasOrdenes.map((oc) => oc.pedido).filter(Boolean)),
  ].join(", ");

  const observaciones = [
    ...new Set(
      mismasOrdenes
        .map((oc) => String(oc.observaciones ?? "").trim())
        // omitir observaciones vacías o en "NA" antes de unirlas
        .filter((o) => o && o.toUpperCase() !== "NA")
    ),
  ].join(" / ");

  // L123 (2026-06) — marca y monarch (distintos) del lote, para mostrarlos como el rojo
  const marca = [
    ...new Set(mismasOrdenes.map((oc) => oc.marca).filter(Boolean)),
  ].join(", ");

  const monarch = [
    ...new Set(mismasOrdenes.map((oc) => oc.monarch).filter(Boolean)),
  ].join(" / ");

  // (2026-08) Tipo de entrega del pedido (Personalizado / Granel / Por definir)
  const tipoEntrega = [
    ...new Set(mismasOrdenes.map((oc) => oc.tipoEntrega).filter(Boolean)),
  ].join(" / ");

  const idsOrdenes = mismasOrdenes.map((oc) => oc._id);

  const ordenesCorteNumeros = [
    ...new Set(
      mismasOrdenes
        .map((oc) => oc.numero)
        .filter((n) => n !== null && n !== undefined && n !== "")
    ),
  ]
    .sort((x, y) => Number(x) - Number(y))
    .join(", ");

  await PDFOCNuevoNumeroInterno(
    a.numeroInterno,
    a.cliente,
    a.fecha,
    a.fechaCancelacion,
    pedidos,
    a.idPedidos,
    a.articuloCodigo,
    a.articuloDescripcion,
    a.idArticulo,
    totalPiezas,
    observaciones,
    idsOrdenes,
    ordenesCorteNumeros,
    resumido,
    // L43 (2026-06) — vendedor del pedido
    a.nombreFirma,
    // L123 (2026-06) — marca y monarch (como el rojo)
    marca,
    monarch,
    // (2026-08) tipo de entrega del pedido
    tipoEntrega
  );
}

// (2026-08) ORDEN DE PRODUCCIÓN — formato del cliente (hoja horizontal).
// Una sola tabla TELA / CONSUMO / A. TELA / COLOR / MODELO / PRENDA por tallas,
// agrupando por tela+color. Las variantes de talla (LM -1, LP +2...) salen en un
// renglón abajo del modelo, como en el PDF anterior.
async function PDFOrdenProduccion(a) {
  const numIntActual = String(a.numeroInterno || "").trim().toUpperCase();
  const esNA = numIntActual === "" || numIntActual === "NA";
  // (2026-10) los artículos dados de baja ya no salen en la OP; sólo si toda
  // la OP está dada de baja se imprime completa (para poder consultarla)
  const mismasOrdenes = esNA
    ? [a]
    : (() => {
        const todas = comments.filter(
          (oc) => String(oc.numeroInterno) === String(a.numeroInterno)
        );
        const activas = todas.filter((oc) => oc.is_active !== "No");
        return activas.length ? activas : todas;
      })();

  if (mismasOrdenes.length === 0) {
    Swal.fire("Error", "No se encontraron órdenes con ese número interno", "error");
    return;
  }

  // (2026-08) Se pregunta si se anexa la ficha técnica de bordados, igual que
  // en el PDF anterior.
  const rb = await Swal.fire({
    title: "¿Incluir bordados?",
    text: "Se anexa la ficha técnica de bordados al final de la orden.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, con bordados",
    cancelButtonText: "No",
    reverseButtons: true,
  });
  if (!rb.isConfirmed && rb.dismiss !== Swal.DismissReason.cancel) return;
  const incluirBordados = rb.isConfirmed === true;

  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);

  const MESES = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE",
  ];

  // "2025-09-04" -> "04 / SEPTIEMBRE / 2025"
  const fechaLarga = (v) => {
    const t = s(v).slice(0, 10);
    const m = t.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return t;
    return `${m[3]} / ${MESES[Number(m[2]) - 1] || m[2]} / ${m[1]}`;
  };

  const collatorES = new Intl.Collator("es", { sensitivity: "base", numeric: true });

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  // ---- bordados (mismos helpers que el PDF anterior) ----
  const getCloudinaryUrl = (publicId) => {
    const p = s(publicId).trim();
    if (!p) return "";
    if (p.startsWith("http")) return p;
    const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
      .replace(/\/$/, "")
      .replace(/\/image\/upload$/, "");
    return `${base}/image/upload/${p}`;
  };

  const loadImagePDF = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const getBordados = (x, filas = []) => {
    const pedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
    const articuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
    const areaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);

    const ap = filas.find((f) => {
      const fPedido = s(f?.pedidos?.[0]?._id || f?.pedidos?.[0]);
      const fArticulo = s(f?.articulos?.[0]?._id || f?.articulos?.[0]);
      const fArea = s(f?.areasClientes?.[0]?._id || f?.areasClientes?.[0]);
      return fPedido === pedidoId && fArticulo === articuloId && fArea === areaId;
    });

    const bordados = ap?.bordados || [];
    if (!Array.isArray(bordados)) return [];

    return bordados
      .map((b) => ({
        observacion: s(b?.observacion || b?.observaciones || ""),
        public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
        version: s(b?.version || ""),
      }))
      .filter((b) => b.public_id || b.observacion);
  };

  try {
    Swal.fire({
      title: "Generando la orden...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const idsOrdenes = mismasOrdenes.map((oc) => oc._id);

    const respuestas = await Promise.all(
      idsOrdenes.map((id) =>
        axios.get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, { headers })
      )
    );

    // (2026-09) Cada renglón se queda con el # de artículo (el consecutivo de
    // su orden de corte) para poder imprimirlo junto al modelo en la tabla.
    // (2026-10) y con las observaciones de su orden, para imprimirlas en la
    // hoja donde sale el modelo.
    const renglones = respuestas.flatMap((r, i) =>
      (r.data || []).map((x) => ({
        ...x,
        numeroArticuloOC: s(mismasOrdenes[i]?.numero),
        observacionesOC: mismasOrdenes[i]?.observaciones,
      }))
    );

    const empresa =
      renglones.find((x) => x?.pedidos?.[0]?.empresas?.[0])?.pedidos?.[0]
        ?.empresas?.[0] || null;

    const idsPedidos = [
      ...new Set(
        renglones
          .flatMap((x) => x.pedidos || [])
          .map((p) => String(p?._id || p))
          .filter(Boolean)
      ),
    ];

    const respArticulosPedido = await Promise.all(
      idsPedidos.map((id) =>
        axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${id}`, { headers })
      )
    );

    const articulosPedido = respArticulosPedido.flatMap((r) => r.data || []);

    // (2026-08) Bordados: se piden con el endpoint SIN el filtro de cantidad,
    // porque suelen quedar en renglones que terminaron en 0 al repartir tallas.
    let filasBordados = [];
    if (incluirBordados) {
      const respBordados = await Promise.all(
        idsPedidos.map((id) =>
          axios
            .get(`${URL_ARTICULOS_PEDIDO}/bordadosPedido/${id}`, { headers })
            .catch((e) => {
              console.warn("No se pudieron cargar los bordados:", e);
              return { data: [] };
            })
        )
      );
      filasBordados = respBordados.flatMap((r) => r.data || []);
    }

    // Tela / composición / observaciones se guardan en el renglón del pedido
    const findAp = (x) => {
      const pedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const articuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const areaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
      const colorId = s(x?.colores?.[0]?._id || x?.colores?.[0]);

      const mismo = (ap, conColor, conArea) => {
        const apPedido = s(ap?.pedidos?.[0]?._id || ap?.pedidos?.[0]);
        const apArticulo = s(ap?.articulos?.[0]?._id || ap?.articulos?.[0]);
        const apArea = s(ap?.areasClientes?.[0]?._id || ap?.areasClientes?.[0]);
        const apColor = s(ap?.colores?.[0]?._id || ap?.colores?.[0]);
        return (
          apPedido === pedidoId &&
          apArticulo === articuloId &&
          (conArea ? apArea === areaId : true) &&
          (conColor && colorId && apColor ? apColor === colorId : true)
        );
      };

      // (2026-09) De más a menos estricto. El área de la orden puede no
      // coincidir con la del pedido (el pedido se reparte por áreas después de
      // hacer la orden, o la orden se hizo con otra área), y la tela y las
      // observaciones son del artículo, no del área: si no hay renglón con la
      // misma área se toma el del mismo artículo (y color) en el pedido.
      return (
        articulosPedido.find((ap) => mismo(ap, true, true)) ||
        articulosPedido.find((ap) => mismo(ap, false, true)) ||
        articulosPedido.find((ap) => mismo(ap, true, false)) ||
        articulosPedido.find((ap) => mismo(ap, false, false))
      );
    };

    // (2026-08) La composición muchas veces viene en "NA" en el renglón del
    // pedido; en ese caso se busca en el catálogo de Telas por nombre de tela,
    // igual que en el PDF anterior.
    const getComposicionTela = (x) => {
      const ap = findAp(x);
      const directa = s(ap?.composicion || x?.composicion);
      if (directa) return directa;

      const nombreTela = s(ap?.tela || x?.tela);
      if (!nombreTela) return "";

      return buscaComposicionTela(nombreTela, telasCatalogo);
    };

    const getTelaTexto = (x) => {
      const ap = findAp(x);
      const tela = s(ap?.tela || x?.tela);
      const comp = getComposicionTela(x);
      if (tela && comp) return `${comp}\n${tela}`;
      return tela || comp || "";
    };

    const getObsArticulo = (x) => s(findAp(x)?.observacionesArticulo);

    // ==== AGRUPADO: área -> tela + color -> artículos -> variantes -> tallas ==
    // (2026-09) Antes se juntaban todas las áreas en una sola tabla y no se
    // distinguía a qué área iba cada prenda; ahora cada área lleva su propia
    // banda y sus renglones abajo.
    const grupos = {};
    const tallasSet = new Set();
    // (2026-08) observación por modelo, para imprimir en cada hoja sólo las de
    // los artículos que salieron en esa hoja.
    // (2026-09) Un mismo modelo puede venir con observaciones distintas (p. ej.
    // el chaleco en dos colores/telas, cada uno con su etiquetado). Antes se
    // guardaba una sola y se perdía la otra; ahora se guardan todas y cada una
    // recuerda de qué colores viene, para identificarla al imprimir.
    const obsPorModelo = {}; // modelo -> Map(observación -> Set(colores))
    // (2026-10) observaciones capturadas en la orden de producción, por modelo
    // (los renglones "NA" que trae del pedido no se imprimen)
    const obsOrdenPorModelo = {}; // modelo -> Set(observación)
    const limpiaObsOrden = (t) =>
      String(t || "")
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter((l) => l && l.toUpperCase() !== "NA")
        .join(" / ");

    renglones
      .filter((x) => sn(x?.cantidad, 0) > 0)
      .forEach((x) => {
        const tela = getTelaTexto(x) || "Sin tela";
        const color = getFirstName(x.colores) || "Sin color";
        const modelo = s(x?.articulos?.[0]?.codigo);
        const prenda =
          s(x?.articulos?.[0]?.subDepartamentos?.[0]?.name) ||
          s(x?.articulos?.[0]?.descripcion);
        const talla = s(x?.tallas?.[0]?.name).trim() || "Sin talla";
        const variante = s(x?.tallas?.[0]?.variantesTallas?.[0]?.name).trim();
        const cantidad = sn(x?.cantidad, 0);

        const obs = getObsArticulo(x);
        if (obs) {
          if (!obsPorModelo[modelo]) obsPorModelo[modelo] = new Map();
          const clave = obs.trim();
          if (!obsPorModelo[modelo].has(clave)) obsPorModelo[modelo].set(clave, new Set());
          obsPorModelo[modelo].get(clave).add(String(color).trim());
        }
        const obsOrden = limpiaObsOrden(x?.observacionesOC);
        if (obsOrden) {
          if (!obsOrdenPorModelo[modelo]) obsOrdenPorModelo[modelo] = new Set();
          obsOrdenPorModelo[modelo].add(obsOrden);
        }

        const area = getFirstName(x.areasClientes) || "Sin área";

        const gKey = `${area}||${tela}||${color}`;
        if (!grupos[gKey]) grupos[gKey] = { area, tela, color, articulos: {} };

        const aKey = `${modelo}||${prenda}`;
        if (!grupos[gKey].articulos[aKey]) {
          grupos[gKey].articulos[aKey] = {
            modelo,
            prenda,
            variantes: {},
            // # de artículo de la(s) orden(es) de corte de donde salió
            numerosArticulo: new Set(),
          };
        }

        const art = grupos[gKey].articulos[aKey];
        if (s(x?.numeroArticuloOC)) art.numerosArticulo.add(s(x.numeroArticuloOC));
        if (!art.variantes[variante]) art.variantes[variante] = {};
        art.variantes[variante][talla] =
          (art.variantes[variante][talla] || 0) + cantidad;

        tallasSet.add(talla);
      });

    if (!Object.keys(grupos).length) {
      Swal.close();
      return Swal.fire("Sin artículos", "La orden no tiene piezas que imprimir", "warning");
    }

    // ---- bordados agrupados por área + artículo (como en el PDF anterior)
    const bordadosMap = {};
    if (incluirBordados) {
      renglones.forEach((x) => {
        const bordados = getBordados(x, filasBordados);
        if (!bordados.length) return;

        const area = getFirstName(x.areasClientes) || "Sin Área";
        const articulo =
          [
            s(x?.articulos?.[0]?.codigo),
            s(x?.articulos?.[0]?.subDepartamentos?.[0]?.name),
          ]
            .filter((t) => t)
            .join(" ") ||
          s(x?.articulos?.[0]?.descripcion) ||
          "Artículo sin nombre";

        const key = `${area}||${articulo}`;
        if (!bordadosMap[key]) bordadosMap[key] = { area, articulo, bordados: [] };

        bordados.forEach((b) => {
          const existe = bordadosMap[key].bordados.some(
            (z) =>
              z.public_id === b.public_id &&
              z.observacion === b.observacion &&
              z.version === b.version
          );
          if (!existe) bordadosMap[key].bordados.push(b);
        });
      });
    }
    const bordadosFinal = Object.values(bordadosMap);

    const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

    const tallas = [...tallasSet].sort((x, y) => {
      const ix = ordenTallas.indexOf(x);
      const iy = ordenTallas.indexOf(y);
      return (ix === -1 ? Infinity : ix) - (iy === -1 ? Infinity : iy);
    });

    // ============ DOCUMENTO ============
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const ML = 10;
    const usableW = pageW - ML * 2;

    const negro = [0, 0, 0];
    const grisBanda = [90, 90, 90];
    const grisClaro = [217, 217, 217];
    const borde = [120, 120, 120];

    const cliente = s(a.cliente);
    const marca = s(a.marca);
    const monarch = s(a.monarch);
    // (2026-09) vendedor del pedido (el mismo que firma en el PDF anterior)
    const vendedor = s(a.nombreFirma);
    const numerosOC = [
      ...new Set(
        mismasOrdenes
          .map((oc) => oc.numero)
          .filter((n) => n !== null && n !== undefined && n !== "")
      ),
    ].sort((x, y) => Number(x) - Number(y));

    const anio = s(a.fecha).slice(0, 4);
    // Se imprime tal cual se capturó (el número interno ya trae su año)
    const numeroOrden = esNA ? numerosOC.join(", ") : s(a.numeroInterno);

    const empresaNombre =
      s(empresa?.razonSocial) ||
      s(empresa?.name) ||
      s(process.env.REACT_APP_NOMBRE_INSTITUCION) ||
      "";


    // (2026-08) El encabezado completo se repite en todas las hojas
    const dibujaEncabezado = () => {
      // ---- Fecha arriba a la derecha
      doc.setFont(undefined, "bold").setFontSize(11).setTextColor(0);
      doc.text(`FECHA: ${fechaLarga(a.fecha)}`, pageW - ML, 12, { align: "right" });

      // ---- Nombre de la empresa (centrado)
      doc.setFont(undefined, "bolditalic").setFontSize(22);
      doc.text(empresaNombre, pageW / 2, 22, { align: "center" });

      // ---- Banda ORDEN DE PRODUCCIÓN + número
      const bandaW = 80;
      const bandaX = pageW - ML - bandaW;
      doc.setFillColor(...grisBanda);
      doc.rect(bandaX, 26, bandaW, 7, "F");
      doc.setFont(undefined, "bold").setFontSize(11).setTextColor(255);
      doc.text("ORDEN DE PRODUCCIÓN", bandaX + bandaW / 2, 31.2, {
        align: "center",
      });
      doc.setTextColor(0);
      doc.setFont(undefined, "bold").setFontSize(18);
      doc.text(`No. ${numeroOrden}`, bandaX + bandaW / 2, 41, { align: "center" });

      // (2026-09) Vendedor del pedido, justo abajo del número de la orden
      doc.setFont(undefined, "bold").setFontSize(9);
      doc.text(
        doc.splitTextToSize(`VENDEDOR: ${vendedor || "—"}`, bandaW + 10)[0],
        bandaX + bandaW / 2,
        46,
        { align: "center" }
      );
      doc.setFont(undefined, "normal");

      // ---- Caja MARCA (al centro)
      const marcaW = 44;
      const marcaX = pageW / 2 - marcaW / 2;

      // ---- Cliente / fecha de entrega
      // (2026-09) El nombre del cliente se encimaba con la caja MARCA cuando
      // era largo: ahora se le limita el ancho hasta donde empieza la caja y,
      // si no cabe, baja el tamaño de letra antes que invadirla.
      // Va pegado al mismo margen izquierdo que la fecha de entrega.
      const xCliente = ML + 4;
      const anchoCliente = marcaX - xCliente - 4;
      const txtCliente = `CLIENTE: ${cliente}`;
      let tamCliente = 12;
      doc.setFont(undefined, "bold").setFontSize(tamCliente);
      while (tamCliente > 7 && doc.getTextWidth(txtCliente) > anchoCliente) {
        tamCliente -= 0.5;
        doc.setFontSize(tamCliente);
      }
      doc.text(doc.splitTextToSize(txtCliente, anchoCliente)[0], xCliente, 32);
      doc.setFontSize(11);
      doc.text(`FECHA DE ENTREGA:   ${fechaLarga(a.fechaCancelacion)}`, ML + 4, 39);

      doc.setFillColor(...negro);
      doc.rect(marcaX, 27, marcaW, 6.5, "F");
      doc.setFont(undefined, "bold").setFontSize(10).setTextColor(255);
      doc.text("MARCA", marcaX + marcaW / 2, 31.6, { align: "center" });
      doc.setTextColor(0);
      doc.setDrawColor(0).setLineWidth(0.3);
      doc.rect(marcaX, 33.5, marcaW, 7);
      doc.setFont(undefined, "italic").setFontSize(10);
      doc.text(marca || "—", marcaX + marcaW / 2, 38.4, { align: "center" });
      doc.setFont(undefined, "normal");

      // (2026-09) El renglón de arriba de la tabla queda para el área de la
      // hoja; se escribe hasta el final, cuando ya se sabe qué cayó en cada
      // una. El monarch sale en el cuadro de habilitación y el # de artículo
      // abajo del código del modelo.
    };

    dibujaEncabezado();
    const topTabla = 49;
    let currentY = topTabla;

    // ============ TABLA ============
    const wTela = 48;
    const wColor = 26;
    const wModelo = 18;
    const wPrenda = 26;
    const wTotal = 13;
    const fijas = wTela + wColor + wModelo + wPrenda + wTotal;
    const dispTallas = usableW - fijas;
    const minTallaW = 5.5;
    const maxTallas = Math.max(1, Math.floor(dispTallas / minTallaW));
    const bloquesTallas = chunk(tallas, Math.min(maxTallas, tallas.length || 1));

    let totalGeneral = 0;
    let finTabla = currentY;
    const paginaInicio = doc.internal.getCurrentPageInfo().pageNumber;
    // qué modelos y dónde termina la tabla en cada hoja
    const modelosPorPagina = {};
    const finPorPagina = {};

    bloquesTallas.forEach((tallasBloque, bi) => {
      const nT = tallasBloque.length;
      const wTalla = dispTallas / Math.max(1, nT);

      const gruposOrdenados = Object.values(grupos).sort(
        (g1, g2) =>
          collatorES.compare(g1.area, g2.area) ||
          collatorES.compare(g1.tela, g2.tela) ||
          collatorES.compare(g1.color, g2.color)
      );

      // (2026-09) Una tabla por área, con el área como primer renglón del
      // encabezado: así autoTable la vuelve a imprimir cuando el área se pasa
      // a la hoja siguiente.
      const areasOrdenadas = [
        ...new Set(gruposOrdenados.map((g) => g.area)),
      ];

      areasOrdenadas.forEach((areaActual) => {
        const head = [
          [
            {
              content: `ÁREA:  ${areaActual}`,
              colSpan: 5 + nT,
              styles: {
                fillColor: negro,
                textColor: [255, 255, 255],
                fontStyle: "bold",
                halign: "left",
                fontSize: 9,
              },
            },
          ],
          ["TELA", "COLOR", "MODELO", "PRENDA", ...tallasBloque, "TOTAL"],
        ];

        const body = [];
        // modelo que corresponde a cada renglón del body, para saber qué
        // observaciones van en cada hoja
        const modeloDeFila = [];

        gruposOrdenados
          .filter((g) => g.area === areaActual)
          .forEach((g) => {

            // renglones del grupo (uno por artículo + uno por variante)
            const filasGrupo = [];

            Object.values(g.articulos)
              .sort((x, y) => collatorES.compare(x.modelo, y.modelo))
              .forEach((art) => {
                const variantes = Object.keys(art.variantes).sort((v1, v2) => {
                  if (!v1) return -1;
                  if (!v2) return 1;
                  return collatorES.compare(v1, v2);
                });

                const desdeModelo = filasGrupo.length;
                // (2026-10) El código del modelo va en el primer renglón que se
                // imprima del artículo. Antes sólo salía en el renglón sin
                // variante y, cuando el artículo venía puro de variantes (p. ej.
                // OP 154/2026: 9285 sólo en "LP +4"), el modelo quedaba en blanco.
                let yaSalioModelo = false;

                variantes.forEach((v) => {
                  const porTalla = art.variantes[v] || {};
                  const totalFila = Object.values(porTalla).reduce(
                    (acc, n) => acc + sn(n, 0),
                    0
                  );
                  if (totalFila <= 0) return;

                  const celdasTallas = tallasBloque.map((t) =>
                    sn(porTalla[t], 0) > 0 ? String(sn(porTalla[t], 0)) : ""
                  );

                  // en el bloque de tallas partidas, sólo se imprime el renglón
                  // si trae algo de ese bloque
                  if (!celdasTallas.some((c) => c !== "")) return;

                  // el # de artículo va abajo del código del modelo
                  const numsArt = [...(art.numerosArticulo || [])]
                    .sort((n1, n2) => Number(n1) - Number(n2))
                    .join(", ");

                  const primeraDelModelo = !yaSalioModelo;
                  yaSalioModelo = true;
                  // variante sin renglón base arriba: lleva también el nombre
                  // de la prenda para que no se pierda
                  const prendaFila = !v
                    ? art.prenda
                    : primeraDelModelo
                      ? [art.prenda, `·  ${v}`].filter((t) => t).join("\n")
                      : `·  ${v}`;

                  filasGrupo.push({
                    modelo: primeraDelModelo
                      ? [art.modelo, numsArt ? `# ${numsArt}` : ""]
                          .filter((t) => t)
                          .join("\n")
                      : "",
                    modeloReal: art.modelo,
                    prenda: prendaFila,
                    esVariante: !!v && !primeraDelModelo,
                    celdas: celdasTallas,
                    total: totalFila,
                  });

                  if (bi === 0) totalGeneral += totalFila;
                });

                // (2026-08) Total del modelo cuando se abrió en varios renglones
                // por variantes; con un solo renglón el subtotal sobraría.
                const filasModelo = filasGrupo.slice(desdeModelo);
                if (filasModelo.length > 1) {
                  filasGrupo.push({
                    modelo: "",
                    modeloReal: art.modelo,
                    prenda: `TOTAL ${art.modelo}`,
                    esSubtotalModelo: true,
                    celdas: tallasBloque.map((t, i) => {
                      const suma = filasModelo.reduce(
                        (acc, f) => acc + sn(f.celdas[i], 0),
                        0
                      );
                      return suma > 0 ? String(suma) : "";
                    }),
                    total: filasModelo.reduce((acc, f) => acc + f.total, 0),
                  });
                }
              });

            if (!filasGrupo.length) return;

            // (2026-09) El subtotal por color salía sobrando: en producción sólo
            // usan el total por modelo, así que se quitó el renglón
            // "TOTAL <color>" (antes iba abajo de los artículos del color).
            const renglonesGrupo = filasGrupo.length;

            filasGrupo.forEach((f, idx) => {
              const fila = [];
              if (idx === 0) {
                fila.push(
                  { content: g.tela, rowSpan: renglonesGrupo },
                  { content: g.color, rowSpan: renglonesGrupo }
                );
              }
              const fondoModelo = f.esSubtotalModelo ? [242, 244, 247] : undefined;
              fila.push(
                {
                  content: f.modelo,
                  styles: { fontStyle: "bold", fillColor: fondoModelo },
                },
                {
                  content: f.prenda,
                  styles: {
                    halign: f.esSubtotalModelo ? "right" : "left",
                    fontStyle: f.esVariante
                      ? "italic"
                      : f.esSubtotalModelo
                        ? "bold"
                        : "normal",
                    fillColor: fondoModelo,
                  },
                },
                ...f.celdas.map((c) => ({
                  content: c,
                  styles: {
                    fillColor: fondoModelo,
                    fontStyle: f.esSubtotalModelo ? "bold" : "normal",
                  },
                })),
                {
                  content: String(f.total),
                  styles: { fontStyle: "bold", fillColor: fondoModelo },
                }
              );
              modeloDeFila[body.length] = f.modeloReal;
              body.push(fila);
            });
          });

        if (!body.length) return;

        const colStyles = {
          0: { cellWidth: wTela, halign: "center", fontSize: 7.5 },
          1: { cellWidth: wColor, fontStyle: "bold" },
          2: { cellWidth: wModelo },
          3: { cellWidth: wPrenda, halign: "left" },
          [4 + nT]: { cellWidth: wTotal, fontStyle: "bold" },
        };
        for (let i = 0; i < nT; i++) colStyles[4 + i] = { cellWidth: wTalla };

        doc.autoTable({
          head,
          body,
          startY: currentY,
          // el top deja lugar al encabezado y el bottom a las cajas de
          // observaciones / habilitación, que ahora van en todas las hojas
          margin: { left: ML, right: ML, top: topTabla, bottom: 44 },
          tableWidth: usableW,
          theme: "grid",
          styles: {
            fontSize: 8.5,
            cellPadding: 1.2,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borde,
            lineWidth: 0.2,
            textColor: 0,
          },
          headStyles: {
            fillColor: grisClaro,
            textColor: 0,
            fontStyle: "bold",
            fontSize: 9,
            lineColor: negro,
            lineWidth: 0.25,
          },
          columnStyles: colStyles,
          didParseCell: (h) => {
            // MODELO / PRENDA / TOTAL en negro con letra blanca (como el
            // original). El renglón 0 del encabezado es la banda del área.
            if (h.section === "head" && h.row.index === 1) {
              const i = h.column.index;
              if (i === 2 || i === 3 || i === 4 + nT) {
                h.cell.styles.fillColor = negro;
                h.cell.styles.textColor = [255, 255, 255];
              }
            }
          },
          // Se apunta en qué hoja cayó cada renglón, para las observaciones
          didDrawCell: (h) => {
            if (h.section !== "body") return;
            const p = doc.internal.getCurrentPageInfo().pageNumber;
            if (!modelosPorPagina[p]) modelosPorPagina[p] = new Set();
            const modelo = modeloDeFila[h.row.index];
            if (modelo) modelosPorPagina[p].add(modelo);
          },
          // El encabezado completo se repite en cada hoja
          didDrawPage: (h) => {
            const p = doc.internal.getCurrentPageInfo().pageNumber;
            if (p !== paginaInicio) dibujaEncabezado();
            finPorPagina[p] = h.cursor.y;
          },
        });

        currentY = doc.autoTable.previous.finalY;
        finTabla = currentY;
      });

      if (bloquesTallas.length > 1) {
        doc.setFont(undefined, "italic").setFontSize(8);
        doc.text(
          `Tallas ${bi + 1}/${bloquesTallas.length}`,
          pageW - ML,
          currentY + 3.5,
          { align: "right" }
        );
        doc.setFont(undefined, "normal");
        currentY += 5;
      }
    });

    // ---- Barra negra con el total general
    const barraH = 6.5;
    if (finTabla + barraH + 4 > pageH - 12) {
      doc.addPage();
      finTabla = 14;
    }
    doc.setFillColor(...negro);
    doc.rect(ML, finTabla + 1, usableW - wTotal, barraH, "F");
    doc.setDrawColor(0).setLineWidth(0.3);
    doc.rect(pageW - ML - wTotal, finTabla + 1, wTotal, barraH);
    doc.setFont(undefined, "bold").setFontSize(10).setTextColor(0);
    doc.text(
      String(totalGeneral),
      pageW - ML - wTotal / 2,
      finTabla + 1 + barraH - 1.8,
      { align: "center" }
    );
    let y = finTabla + 1 + barraH + 5;

    // ---- Leyenda
    doc.setFont(undefined, "bold").setFontSize(10);
    doc.text(
      "COTEJAR  BITÁCORA, MUESTRAS ORIGINALES y FICHAS TÉCNICAS.",
      pageW / 2,
      y,
      { align: "center" }
    );
    y += 3;

    // ---- Cajas de observaciones y habilitación/calidad
    // (2026-08) Las dos cajas se repiten en TODAS las hojas, con los artículos
    // que salieron en cada una: las observaciones a la izquierda y, a la
    // derecha, marca/monarch y el etiquetado (composición) artículo por artículo.
    const paginaFinal = doc.internal.getCurrentPageInfo().pageNumber;

    // (2026-09) Las observaciones del recuadro son las que se capturan por
    // artículo en el pedido, marcadas con su modelo y sólo en la hoja donde
    // salió ese modelo.
    // (2026-10) También van las observaciones de la orden de producción, pero
    // ya no repetidas en todas las hojas: cada una con el modelo de su orden y
    // sólo en la hoja donde sale ese modelo.

    const cajaHabW = 96;
    const cajaObsW = usableW - cajaHabW;

    const modelosDePagina = (p) =>
      [...(modelosPorPagina[p] || [])].sort((x, y) => collatorES.compare(x, y));

    const dibujaCajas = (pagina, yy) => {
      const modelos = modelosDePagina(pagina);

      // Si el modelo trae una sola observación va como siempre ("4360: ...");
      // si trae varias, cada una lleva entre paréntesis el color al que aplica
      // ("4360 (GRIS OXFORD): ..." / "4360 (AZUL ACERO): ...").
      const textosObs = modelos.flatMap((m) => {
        const variantes = [...(obsPorModelo[m] || new Map()).entries()];
        const delArticulo =
          variantes.length === 1
            ? [`${m}: ${variantes[0][0]}`]
            : variantes.map(
                ([obs, coloresSet]) => `${m} (${[...coloresSet].join(", ")}): ${obs}`
              );
        // las de la orden, sin repetir una que ya salió como del artículo
        const yaSalieron = new Set(variantes.map(([obs]) => obs.toUpperCase()));
        const deLaOrden = [...(obsOrdenPorModelo[m] || [])]
          .filter((obs) => !yaSalieron.has(obs.toUpperCase()))
          .map((obs) => `${m}: ${obs}`);
        return [...delArticulo, ...deLaOrden];
      });

      // (2026-09) El etiquetado (composición por artículo) se quitó de la caja
      // de habilitación: ya sale en la columna TELA de la tabla.
      // El monarch es largo ("NO LLEVARA RAZÓN SOCIAL SOLO COMPOSICIÓN...") y
      // salía cortado: se parte en varios renglones y la caja crece con él.
      doc.setFont(undefined, "bold").setFontSize(9);
      const anchoHab = cajaHabW - 6;
      const lineasMarca = doc.splitTextToSize(`MARCA : ${marca || "—"}`, anchoHab);
      const lineasMonarch = doc.splitTextToSize(
        `MONARCH: ${monarch || "—"}`,
        anchoHab
      );
      const renglonesHab = lineasMarca.length + lineasMonarch.length;
      const altoHab = 11 + (renglonesHab - 1) * 4.4 + 2;

      // (2026-09) Antes se cortaban a 7 renglones y se perdían observaciones.
      // Ahora se reparten en columnas y, si aun así no caben en lo que queda de
      // la hoja, se va bajando el tamaño de letra hasta que entren todas.
      const disponible = Math.max(26, pageH - 8 - yy);
      const formatos = [
        { fs: 9, lh: 4.4, cols: 1 },
        { fs: 9, lh: 4.4, cols: 2 },
        { fs: 8, lh: 4.0, cols: 2 },
        { fs: 7.5, lh: 3.7, cols: 2 },
        { fs: 7.5, lh: 3.7, cols: 3 },
        { fs: 7, lh: 3.4, cols: 3 },
      ];

      let plan = null;
      for (const f of formatos) {
        doc.setFont(undefined, "normal").setFontSize(f.fs);
        const anchoObs = (cajaObsW - 6 - (f.cols - 1) * 4) / f.cols;
        // cada observación se mantiene junta: no se parte a media frase entre
        // una columna y la siguiente
        const bloques = textosObs.map((t) => doc.splitTextToSize(t, anchoObs));
        const totalRenglones = bloques.reduce((n, b) => n + b.length, 0);
        const porColumna = Math.max(1, Math.ceil(totalRenglones / f.cols));

        const columnas = [];
        let actual = [];
        bloques.forEach((b) => {
          if (
            actual.length &&
            actual.length + b.length > porColumna &&
            columnas.length < f.cols - 1
          ) {
            columnas.push(actual);
            actual = [];
          }
          actual.push(...b);
        });
        columnas.push(actual);

        const filas = columnas.reduce((n, col) => Math.max(n, col.length), 0);
        plan = { ...f, anchoObs, columnas, altoTexto: filas * f.lh + 5 };
        if (plan.altoTexto <= disponible) break;
      }

      const alto = Math.max(26, plan.altoTexto, altoHab);

      // caja de observaciones
      doc.setDrawColor(0).setLineWidth(0.4);
      doc.rect(ML, yy, cajaObsW, alto);
      doc.setFont(undefined, "normal").setFontSize(plan.fs).setTextColor(0);
      plan.columnas.forEach((col, ci) => {
        const cx = ML + 3 + ci * (plan.anchoObs + 4);
        col.forEach((t, i) => doc.text(t, cx, yy + 5.5 + i * plan.lh));
      });

      // caja de habilitación / calidad
      doc.setDrawColor(0).setLineWidth(0.4);
      doc.rect(ML + cajaObsW, yy, cajaHabW, alto);
      doc.setFillColor(...grisClaro);
      doc.rect(ML + cajaObsW, yy, cajaHabW, 6, "F");
      doc.setFont(undefined, "bold").setFontSize(10).setTextColor(0);
      doc.text("HABILITACIÓN / CALIDAD", ML + cajaObsW + cajaHabW / 2, yy + 4.3, {
        align: "center",
      });

      doc.setFont(undefined, "bold").setFontSize(9);
      let yHab = yy + 11;
      [...lineasMarca, ...lineasMonarch].forEach((linea) => {
        doc.text(linea, ML + cajaObsW + 3, yHab);
        yHab += 4.4;
      });
      doc.setFont(undefined, "normal");

      return alto;
    };

    // última hoja: debajo de la leyenda
    const cajaH = dibujaCajas(paginaFinal, y);
    y += cajaH + 6;

    // hojas anteriores: debajo de la parte de tabla que le tocó a cada una
    Object.keys(finPorPagina)
      .map(Number)
      .filter((p) => p !== paginaFinal)
      .forEach((p) => {
        doc.setPage(p);
        const yy = Math.min(finPorPagina[p] + 4, pageH - 10 - 34);
        dibujaCajas(p, yy);
      });

    doc.setPage(paginaFinal);

    // (2026-08) Número de hoja abajo de la fecha ("1 de 2"). Se pone hasta el
    // final, que es cuando ya se sabe cuántas hojas salieron. Se numera antes de
    // la ficha de bordados: esa va como anexo, con su propia banda.
    const totalPaginas = doc.internal.getNumberOfPages();
    for (let p = 1; p <= totalPaginas; p++) {
      doc.setPage(p);
      doc.setFont(undefined, "bold").setFontSize(10).setTextColor(0);
      doc.text(`${p} de ${totalPaginas}`, pageW - ML, 17.5, { align: "right" });
    }

    doc.setPage(paginaFinal);

    // (2026-08) Ficha técnica de bordados, igual que en el PDF anterior
    if (bordadosFinal.length > 0) {
      await dibujarFichaBordados(doc, bordadosFinal, {
        getCloudinaryUrl,
        loadImagePDF,
        pageWidth: pageW,
        marginLeft: ML,
        marginTop: 14,
        brandColor: negro,
        lightBg: grisClaro,
        borderColor: borde,
        labelColor: grisBanda,
        s,
      });
    } else if (incluirBordados) {
      console.log("La orden no tiene bordados capturados");
    }

    /* (2026-08) Firmas comentadas a petición del cliente
    const etiquetasFila1 = [
      "DISEÑO", "TRAZO", "ALMACEN\nDE TELAS", "CORTE", "HABILITACIÓN", "C. CALIDAD",
    ];
    const etiquetasFila2 = [
      "GRADUACIÓN", "MAQUINA\nCORTADORA", "", "AUDITORIA\nCORTE", "", "ALMACEN",
    ];

    const nCajas = etiquetasFila1.length;
    const gap = 4;
    const cajaW = (usableW - gap * (nCajas - 1)) / nCajas;
    const cajaAltura = 13;

    if (y + cajaAltura * 2 + 22 > pageH - 8) {
      doc.addPage();
      y = 16;
    }

    const dibujaCaja = (texto, x, yy) => {
      if (!texto) return;
      doc.setDrawColor(190).setLineWidth(0.3);
      doc.roundedRect(x, yy, cajaW, cajaAltura, 2, 2, "S");
      doc.setFont(undefined, "normal").setFontSize(7.5).setTextColor(60);
      const lineas = texto.split("\n");
      lineas.forEach((t, i) =>
        doc.text(t, x + 3, yy + (lineas.length > 1 ? 6 : 8) + i * 3.4)
      );
      doc.setTextColor(0);
    };

    etiquetasFila1.forEach((t, i) => dibujaCaja(t, ML + i * (cajaW + gap), y));
    etiquetasFila2.forEach((t, i) =>
      dibujaCaja(t, ML + i * (cajaW + gap), y + cajaAltura + 3)
    );

    const yFirma = Math.min(y + cajaAltura * 2 + 16, pageH - 10);
    const firmas = ["SOLICITÓ", "ELABORÓ", "AUTORIZÓ"];
    const anchoFirma = 60;
    firmas.forEach((t, i) => {
      const cx = ML + usableW * ((i + 1) / (firmas.length + 1));
      doc.setDrawColor(0).setLineWidth(0.4);
      doc.line(cx - anchoFirma / 2, yFirma, cx + anchoFirma / 2, yFirma);
      doc.setFont(undefined, "normal").setFontSize(8.5);
      doc.text(t, cx, yFirma + 4, { align: "center" });
    });
    */

    Swal.close();
    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
    Swal.close();
    // (2026-09) Se muestra la causa real: casi siempre es que el back no
    // contestó (404/500) y así se distingue de un error del PDF.
    const d = err?.response?.data;
    const detalle = err?.response
      ? `El servidor respondió ${err.response.status}${
          typeof d === "string" ? `: ${d.replace(/<[^>]+>/g, " ").trim().slice(0, 120)}` : d?.message ? `: ${d.message}` : ""
        }`
      : err?.message || "";
    Swal.fire({
      icon: "error",
      title: "No se pudo generar la orden de producción",
      text: detalle,
    });
  }
}

async function PDFOCNuevoNumeroInterno(
  numero,
  cliente,
  fecha,
  fechaCancelacion,
  pedido,
  idPedidos,
  articuloCodigo,
  articuloDescripcion,
  idArticulo,
  totalPiezas,
  observaciones,
  idPDFOC,
  ordenesCorteNumeros,
  // L27 (2026-06)
  resumido = false,
  // L43 (2026-06)
  nombreFirma = "",
  // L123 (2026-06) — marca y monarch (como el rojo)
  marca = "",
  monarch = "",
  // (2026-08) tipo de entrega capturado en el pedido
  tipoEntrega = ""
) {
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstId = (arr) => s(arr?.[0]?._id);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDepto = (a) =>
    s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);
  const findApMatch = (a, articulosPedido = []) => {
    const pedidoId = s(a?.pedidos?.[0]?._id || a?.pedidos?.[0]);
    const articuloId = s(a?.articulos?.[0]?._id || a?.articulos?.[0]);
    const areaId = s(a?.areasClientes?.[0]?._id || a?.areasClientes?.[0]);
    // L26 (2026-06) — también emparejar por color para que la tela no se "comparta"
    // entre dos blusas del mismo pedido/articulo/area cuando son colores distintos.
    const colorId = s(a?.colores?.[0]?._id || a?.colores?.[0]);
    const exact = articulosPedido.find((x) => {
      const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
      const apColorId = s(x?.colores?.[0]?._id || x?.colores?.[0]);
      return (
        apPedidoId === pedidoId &&
        apArticuloId === articuloId &&
        apAreaId === areaId &&
        (colorId && apColorId ? apColorId === colorId : true)
      );
    });
    if (exact) return exact;
    // Fallback: si no hubo match con color (ej. articulosPedido sin color cargado),
    // caer al match original sin color para no perder la tela.
    return articulosPedido.find((x) => {
      const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
      return (
        apPedidoId === pedidoId &&
        apArticuloId === articuloId &&
        apAreaId === areaId
      );
    });
  };

  const getTelaName = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    return s(
      ap?.tela ||
        a?.articulosPedido?.[0]?.tela ||
        a?.tela ||
        ""
    );
  };

  const getComposicion = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    const directa = s(
      ap?.composicion ||
        a?.articulosPedido?.[0]?.composicion ||
        a?.composicion ||
        ""
    );
    if (directa) return directa;
    // L12 fallback: si el articulosPedido no trae composición, buscarla en el
    // catálogo de Telas matcheando por el nombre de tela.
    const telaName = s(
      ap?.tela ||
        a?.articulosPedido?.[0]?.tela ||
        a?.tela ||
        ""
    );
    if (!telaName) return "";
    return s(buscaComposicionTela(telaName, telasCatalogo));
  };

  const getTela = (a, articulosPedido = []) => {
    const tela = getTelaName(a, articulosPedido);
    const comp = getComposicion(a, articulosPedido);
    if (tela && comp) return `${tela} - ${comp}`;
    return tela || comp;
  };

  const getObservacionesArticulo = (a, articulosPedido = []) => {
    const ap = findApMatch(a, articulosPedido);
    return s(
      ap?.observacionesArticulo ||
        a?.articulosPedido?.[0]?.observacionesArticulo ||
        a?.observacionesArticulo
    );
  };

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) {
      out.push(arr.slice(i, i + size));
    }
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  const getCloudinaryUrl = (publicId) => {
    const p = s(publicId).trim();
    if (!p) return "";
    if (p.startsWith("http")) return p;

    const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
      .replace(/\/$/, "")
      .replace(/\/image\/upload$/, "");

    return `${base}/image/upload/${p}`;
  };

  const loadImagePDF = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          resolve(null);
        }
      };

      img.onerror = () => resolve(null);
      img.src = src;
    });

  const getBordados = (a, articulosPedido = []) => {
    const pedidoId = s(a?.pedidos?.[0]?._id || a?.pedidos?.[0]);
    const articuloId = s(a?.articulos?.[0]?._id || a?.articulos?.[0]);
    const areaId = s(a?.areasClientes?.[0]?._id || a?.areasClientes?.[0]);

    const ap = articulosPedido.find((x) => {
      const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
      const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
      const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);

      return (
        apPedidoId === pedidoId &&
        apArticuloId === articuloId &&
        apAreaId === areaId
      );
    });

    const bordados = ap?.bordados || [];

    if (!Array.isArray(bordados)) return [];

    return bordados
      .map((b) => ({
        observacion: s(b?.observacion || b?.observaciones || ""),
        public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
        version: s(b?.version || ""),
      }))
      .filter((b) => b.public_id || b.observacion);
  };

  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const idsPDFOC = Array.isArray(idPDFOC) ? idPDFOC : [idPDFOC];

    const respuestas = await Promise.all(
      idsPDFOC.map((id) =>
        axios.get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, { headers })
      )
    );

    const allArticulosOrdenCorte = respuestas.flatMap((r) => r.data || []);

    // L127 (2026-07) — Datos fiscales de la empresa propia (replica de ListadoPedidos).
    // La empresa viene poblada en el pedido de la orden: pedidos[0].empresas[0].
    // NOTA: requiere que el backend popule pedidos.empresas (ver resumen).
    const empresa =
      allArticulosOrdenCorte?.find((x) => x?.pedidos?.[0]?.empresas?.[0])
        ?.pedidos?.[0]?.empresas?.[0] || null;

    const idsPedidos = [
      ...new Set(
        allArticulosOrdenCorte
          .flatMap((x) => x.pedidos || [])
          .map((p) => String(p?._id || p))
          .filter(Boolean)
      ),
    ];

    const respuestasArticulosPedido = await Promise.all(
      idsPedidos.map((idPedido) =>
        axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`, { headers })
      )
    );

    const allArticulosPedido = respuestasArticulosPedido.flatMap(
      (r) => r.data || []
    );

    // L122 (2026-06) — mapa pedidoId → números de Orden de Compra (idOrdenCompra)
    // que se pidieron para ese pedido (vínculo OrdenesCompra.pedidos, L99).
    const ocPorPedido = {};
    try {
      const { data: todasOC } = await axios.get(
        process.env.REACT_APP_URL_ORDENES_COMPRA,
        { headers }
      );
      const setPedidos = new Set(idsPedidos.map(String));
      (todasOC || []).forEach((oc) => {
        const num = oc?.idOrdenCompra;
        if (num === null || num === undefined || num === "") return;
        (oc?.pedidos || []).forEach((p) => {
          const pid = String(p?._id || p);
          if (!setPedidos.has(pid)) return;
          if (!ocPorPedido[pid]) ocPorPedido[pid] = new Set();
          ocPorPedido[pid].add(num);
        });
      });
    } catch (e) {
      console.warn("No se pudieron cargar las Órdenes de Compra:", e);
    }
    // Junta las OC de todos los pedidos presentes en un grupo (por si hay mezcla)
    const getOCDeGrupo = (grupo) => {
      const nums = new Set();
      (grupo || []).forEach((a) => {
        const pid = String(a?.pedidos?.[0]?._id || a?.pedidos?.[0] || "");
        const set = ocPorPedido[pid];
        if (set) set.forEach((n) => nums.add(n));
      });
      if (nums.size === 0) return "";
      return [...nums].sort((a, b) => Number(a) - Number(b)).join(", ");
    };

    // L123 (2026-06) — Orden(es) de Producción (idOrdenesCorte) de los artículos del grupo
    const getOPDeGrupo = (grupo) => {
      const nums = new Set();
      (grupo || []).forEach((a) => {
        const op = a?.ordenesCorte?.[0]?.idOrdenesCorte;
        if (op !== null && op !== undefined && op !== "") nums.add(op);
      });
      if (nums.size === 0) return "";
      return [...nums].sort((a, b) => Number(a) - Number(b)).join(", ");
    };

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L43 (2026-06) — Paleta y helpers de diseño ===
    // TG6 — color/logo por empresa (morado Donnatela si es Uniformes Innovación)
    const esDonnatela = /uniformes\s*innovacion/i.test(
      String(empresa?.razonSocial || empresa?.name || "")
        .normalize("NFD")
        .replace(/[^a-zA-Z0-9 ]/g, "")
    );
    const logoInstFile = esDonnatela
      ? "logoInstitucionDonnatela.png"
      : "logoInstitucion.png";
    const brandColor = esDonnatela ? [120, 88, 168] : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    // ============ LOGO IZQUIERDA + TÍTULO ============
    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "/" + logoInstFile;
    await new Promise((resolve) => {
      logo.onload = () => {
        const maxH = 18;
        const scale = maxH / logo.height;
        const w = logo.width * scale;
        const h = logo.height * scale;
        doc.addImage(logo, "PNG", marginLeft, 8, w, h);
        resolve();
      };
      logo.onerror = () => resolve();
    });

    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`OP # ${s(numero)}`, pageWidth - marginLeft, 18, { align: "right" });
    doc.setTextColor(0);

    // L127 (2026-07) — Datos fiscales de la empresa propia, debajo del folio
    if (empresa) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresa.razonSocial) || s(empresa.name) || "",
        pageWidth - marginLeft,
        23,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      const fiscalLine = [
        empresa.rfc ? `RFC: ${s(empresa.rfc)}` : "",
        empresa.regimenFiscal ? `Rég. Fiscal: ${s(empresa.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginLeft, 27, { align: "right" });
      }
      const direccionStr = [
        s(empresa.direccionFiscal),
        empresa.cp ? `C.P. ${s(empresa.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginLeft - (marginLeft + 60);
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginLeft, 31 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria (corro abajo si hay empresa para no encimar)
    const headerLineY = empresa ? 40 : 28;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ============ CARD 2 COLUMNAS DATOS ============
    const cardY = headerLineY + 3;
    const cardW = pageWidth - marginLeft * 2;
    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 30;

    // (2026-07) Monarch: si no cabe se parte en varios renglones (hasta 4)
    // (2026-08) El texto viene de "Observaciones (Monarch)" del pedido, que suele
    // traer tabs y saltos de línea pegados de otro lado: se normalizan.
    doc.setFont(undefined, "normal");
    doc.setFontSize(9.5);
    const monarchTexto = s(monarch)
      .replace(/\t/g, " ")
      .replace(/\r/g, "")
      .replace(/[ ]{2,}/g, " ")
      .split("\n")
      .map((l) => l.trim())
      .filter((l) => l)
      .join(" · ");
    const monarchLines = doc
      .splitTextToSize(
        monarchTexto || "—",
        pageWidth - marginLeft - valX_R,
      )
      .slice(0, 4);
    const extraMonarch = (monarchLines.length - 1) * 4;
    const cardH = 32 + extraMonarch;

    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 28;
    const baseY_card = cardY + 6;
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY_card);
    drawLabel("Entrega:", fechaCancelacion, lblX_L, valX_L, baseY_card + 5);
    drawLabel("Cliente:", cliente, lblX_L, valX_L, baseY_card + 10);
    drawLabel("Pedido:", pedido, lblX_L, valX_L, baseY_card + 15);
    drawLabel("Total Piezas:", sn(totalPiezas, 0), lblX_L, valX_L, baseY_card + 20);
    // L123 (2026-06) — Marca (como el rojo)

    drawLabel("Vendedor:", nombreFirma, lblX_R, valX_R, baseY_card);
    // L123 (2026-06) — Monarch (como el rojo)
    drawLabel("Monarch:", monarchLines[0], lblX_R, valX_R, baseY_card + 5);
    if (monarchLines.length > 1) {
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      monarchLines.slice(1).forEach((ln, i) => {
        doc.text(ln, valX_R, baseY_card + 9 + i * 4);
      });
    }
    drawLabel(
      "Marca:",
      marca,
      lblX_R,
      valX_R,
      baseY_card + 10 + extraMonarch,
    );
    // (2026-08) Tipo de entrega del pedido, justo abajo de la marca
    drawLabel(
      "Tipo Entrega:",
      tipoEntrega,
      lblX_R,
      valX_R,
      baseY_card + 15 + extraMonarch,
    );

    currentY = cardY + cardH + 6;

    // ============ Línea de Órdenes de Producción agrupadas (multilínea si hay varias) ============
    let baseY = currentY;
    if (s(ordenesCorteNumeros).trim()) {
      doc.setFont(undefined, "italic");
      doc.setTextColor(...labelColor);
      doc.setFontSize(9);
      const ocLines = doc.splitTextToSize(
        `Articulos agrupados: ${s(ordenesCorteNumeros)}`,
        pageWidth - marginLeft * 2
      );
      doc.text(ocLines, marginLeft, baseY);
      baseY += ocLines.length * 4 + 2;
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
    }
    currentY = baseY + 3;

    // ============ OBSERVACIONES — L43 caja con label band ============
    const rawObsNI = String(observaciones ?? "")
      .trim()
      .replace(/\t/g, "  ")
      .replace(/\r/g, "")
      // quitar piezas "NA" (o vacías) unidas por " / "
      .split(" / ")
      .map((p) => p.trim())
      .filter((p) => p && p.toUpperCase() !== "NA")
      .join(" / ");
    if (rawObsNI) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("OBSERVACIONES", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const obsLines = doc.splitTextToSize(rawObsNI, pageWidth - marginLeft * 2 - 12);
      const blockH = obsLines.length * 4.2;
      ensureRoom(blockH + 6);
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(obsLines, marginLeft + 3, currentY + 4);
      currentY += blockH + 8;
    }

    let totalPiezasGlobal = 0;
    const bordadosMap = {};

    const grupoMap = {};

    allArticulosOrdenCorte.forEach((a) => {
      const areaSan =
        getFirstName(a.areasClientes) ||
        getFirstId(a.areasClientes) ||
        "Sin Área";

      const articuloSan =
        `${getArticuloCodigo(a)} ${getArticuloDepto(a)}`.trim() ||
        s(a?.articulos?.[0]?.descripcion) ||
        "Artículo sin nombre";

      const tela = getTelaName(a, allArticulosPedido) || "Sin Tela";

      const bordadosArticulo = getBordados(a, allArticulosPedido);

      if (bordadosArticulo.length > 0) {
        const bordadoKey = `${areaSan}||${articuloSan}`;

        if (!bordadosMap[bordadoKey]) {
          bordadosMap[bordadoKey] = {
            area: areaSan,
            articulo: articuloSan,
            bordados: [],
          };
        }

        bordadosArticulo.forEach((b) => {
          const existe = bordadosMap[bordadoKey].bordados.some(
            (x) =>
              x.public_id === b.public_id &&
              x.observacion === b.observacion &&
              x.version === b.version
          );

          if (!existe) {
            bordadosMap[bordadoKey].bordados.push(b);
          }
        });
      }

      // L27 (2026-06) — resumido: drop area del clave para juntar todas las áreas
      const clave = resumido
        ? `RESUMEN||${articuloSan}||${tela}`
        : `${areaSan}||${articuloSan}||${tela}`;

      if (!grupoMap[clave]) grupoMap[clave] = [];
      grupoMap[clave].push(a);
    });

    for (const clave in grupoMap) {
      const grupo = grupoMap[clave];
      const [areaNombre, articuloNombre, telaNombre] = clave.split("||");

      const composicionGrupo = [
        ...new Set(
          grupo
            .map((a) => getComposicion(a, allArticulosPedido).trim())
            .filter((x) => x)
        ),
      ].join(" / ");

      const telaDisplay =
        composicionGrupo && s(telaNombre) && s(telaNombre) !== "Sin Tela"
          ? `${s(telaNombre)} - ${composicionGrupo}`
          : composicionGrupo || s(telaNombre) || "Sin Tela";

      const observacionesArticuloGrupo = [
        ...new Set(
          grupo
            .map((a) => getObservacionesArticulo(a, allArticulosPedido).trim())
            .filter((x) => x)
        ),
      ].join(" / ");

      // === L43 (2026-06) — Banda azul como header del grupo ===
      const bandH = 8;
      // L130 (2026-07) — Reservar banda + observaciones + encabezado y 1ª fila de la
      // tabla JUNTOS. Así la banda no queda huérfana al final de la hoja cuando la tabla
      // completa no cabe: la tabla arranca en la misma página y el resto fluye a la siguiente.
      doc.setFont(undefined, "italic");
      doc.setFontSize(9);
      const obsArticuloLines = observacionesArticuloGrupo
        ? doc.splitTextToSize(
            `Observaciones del artículo: ${observacionesArticuloGrupo}`,
            pageWidth - marginLeft * 2
          )
        : [];
      const obsArticuloHeight = obsArticuloLines.length * 4.2;
      doc.setFont(undefined, "normal");
      // Reservar SOLO banda + observaciones juntas (bloque chico). La tabla NO se
      // reserva: fluye justo debajo y autoTable la pagina/parte sola => sin huecos.
      ensureRoom(bandH + 3 + (obsArticuloHeight ? obsArticuloHeight + 3 : 1));
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      // L109 (2026-06) — DEPARTAMENTO del artículo (DAMA/CABALLERO) en el band
      const deptoGrupo = s(grupo[0]?.articulos?.[0]?.departamentos?.[0]?.name);
      const deptoTxt = deptoGrupo ? ` · DEPTO: ${deptoGrupo}` : "";
      // L122/L123 (2026-06) — Orden(es) de Producción y de Compra del grupo
      const opGrupo = getOPDeGrupo(grupo);
      const opTxt = opGrupo ? `# Articulo: ${opGrupo}` : "";
      const ocGrupo = getOCDeGrupo(grupo);
      // const ocTxt = ocGrupo ? `   ·   O.C.: ${ocGrupo}` : "";
      const tituloGrupo = resumido
        ? `${opTxt} · Modelo: ${s(articuloNombre) || "Artículo sin nombre"}${deptoTxt} · Tela: ${telaDisplay}   (Resumen de todas las áreas)`
        : `${opTxt} · Área: ${s(areaNombre) || "Sin Área"}${deptoTxt} · Modelo: ${s(articuloNombre) || "Artículo sin nombre"} · Tela: ${telaDisplay}`;
      // TG5 (v2) — Tela DENTRO del band; si no cabe, reducir la letra (no truncar, no moverla)
      const anchoTitulo = pageWidth - marginLeft * 2 - 6;
      let tituloSize = 10.5;
      doc.setFontSize(tituloSize);
      while (doc.getTextWidth(tituloGrupo) > anchoTitulo && tituloSize > 5.5) {
        tituloSize -= 0.5;
        doc.setFontSize(tituloSize);
      }
      doc.text(tituloGrupo, marginLeft + 3, currentY + bandH - 2.5);
      doc.setFontSize(10.5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 3;

      // Observaciones del artículo (italic negro)
      if (observacionesArticuloGrupo) {
        doc.setFont(undefined, "italic");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.text(obsArticuloLines, marginLeft + 2, currentY);
        currentY += obsArticuloHeight + 3;
        doc.setFont(undefined, "normal");
        doc.setTextColor(0);
      } else {
        currentY += 1;
      }

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      // L78 (2026-06) — ignorar combos con cantidad 0 en los PDFs
      grupo.filter((x) => Number(x?.cantidad || 0) > 0).forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";
        const varianteNameRaw = s(
          a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim()
        );
        const varianteName = varianteNameRaw ? varianteNameRaw : "Sin variante";
        const cantidad = sn(a?.cantidad, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) {
          data[color][varianteName][tallaName] = 0;
        }

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) {
          totalVariante[color][varianteName] = 0;
        }

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);
          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });

        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);

        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      let totalPiezasGrupo = 0;

      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      totalPiezasGlobal += totalPiezasGrupo;

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 30;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(
        1,
        Math.min(maxTallasPerRow, tallasOrdenadas.length)
      );

      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
                ? colorTxt
                : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row
                .slice(1, 1 + nTallas)
                .some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft, top: marginTop, bottom: marginBottom },
          tableWidth: usableWidth,
          // L43 (2026-06) — tabla profesional con zebra + color corporativo
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: [210, 216, 224],
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [251, 252, 253],
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.halign = "left";

              const raw = hookData.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";

              if (txt && String(txt).includes("\n")) {
                hookData.cell.styles.fontStyle = "bold";
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // L8 (2026-06) — Total por prenda (este grupo/modelo) en PDFOC agrupado
      ensureRoom(8);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...brandColor);
      doc.text(
        `Total Prenda: ${totalPiezasGrupo}`,
        pageWidth - marginLeft,
        currentY,
        { align: "right" }
      );
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += 5;

      // Divisor entre artículos: solo si cabe en la hoja actual. No forzamos página
      // nueva para una rayita (eso dejaba una hoja casi vacía antes de los bordados).
      if (currentY + 6 <= pageHeight - marginBottom) {
        doc.setDrawColor(220);
        doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
        doc.setDrawColor(0);
        currentY += 6;
      }
    }

    const observacionesTexto = s(observaciones).trim();

    const bordadosFinal = Object.values(bordadosMap);

    if (bordadosFinal.length > 0) {
      await dibujarFichaBordados(doc, bordadosFinal, {
        getCloudinaryUrl,
        loadImagePDF,
        pageWidth,
        marginLeft,
        marginTop,
        brandColor,
        lightBg,
        borderColor,
        labelColor,
        s,
      });
    }

    // L123 (2026-06) — Hoja de Consumos del Pedido comentada a pedido del usuario
    if (false) {
    doc.addPage();
    currentY = 20;

    const [{ data: consumos }, { data: articulosPedido }] = await Promise.all([
      axios.get(`${URL_CONSUMO_TELAS}Pedido/${idPedidos}`, { headers }),
      axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedidos}`, {
        headers,
      }),
    ]);

    const idArticuloStr = String(idArticulo);
    let cantidadArticulo = 0;

    for (const ap of articulosPedido) {
      const arti = Array.isArray(ap.articulos) ? ap.articulos[0] : ap.articulos;
      const artiId = typeof arti === "object" ? arti?._id : arti;

      if (artiId && String(artiId) === idArticuloStr) {
        cantidadArticulo += Number(ap.cantidad || 0);
      }
    }

    const consumosFiltrados = (consumos || [])
      .filter((c) => Number(c.cantidad || 0) > 0)
      .map((c) => {
        const articuloRaw = Array.isArray(c.articulos)
          ? c.articulos[0]
          : c.articulos;

        const telaRaw = Array.isArray(c.telas) ? c.telas[0] : c.telas;

        const artiId =
          typeof articuloRaw === "object" ? articuloRaw?._id : articuloRaw;

        const matchesArticulo = artiId && String(artiId) === idArticuloStr;

        if (!matchesArticulo) return null;

        const articuloNombre =
          typeof articuloRaw === "object"
            ? `${articuloRaw.codigo || ""} ${articuloRaw.descripcion || ""}`.trim()
            : "";

        const telaNombre =
          typeof telaRaw === "object"
            ? telaRaw.nombre || "Sin nombre"
            : telaRaw || "Sin nombre";

        const ancho = typeof telaRaw === "object" ? telaRaw.ancho || "NA" : "NA";

        return {
          articuloNombre,
          tela: telaNombre,
          ancho,
          consumoUnitario: Number(c.cantidad || 0),
          observaciones: (c.observaciones || "").toString().trim() || "NA",
        };
      })
      .filter(Boolean);

    try {
      const logoLynqro = new Image();
      logoLynqro.src = process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png";

      await new Promise((resolve) => {
        logoLynqro.onload = () => {
          doc.addImage(logoLynqro, "PNG", pageWidth - 45, 10, 25, 7.5);
          resolve();
        };
        logoLynqro.onerror = () => resolve();
      });

      const logoInstitucion2 = new Image();
      logoInstitucion2.src = process.env.PUBLIC_URL + "/" + logoInstFile;

      await new Promise((resolve) => {
        logoInstitucion2.onload = () => {
          doc.addImage(logoInstitucion2, "PNG", pageWidth - 45, 18, 25, 14);
          resolve();
        };
        logoInstitucion2.onerror = () => resolve();
      });
    } catch (e) {
      console.warn("No se pudieron cargar logos de consumos");
    }

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(`Consumos del Pedido #${s(pedido)}`, marginLeft, currentY);
    currentY += 10;

    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    doc.text(`Cliente: ${s(cliente) || "NA"}`, marginLeft, currentY);
    currentY += 6;

    const nombreModelo =
      consumosFiltrados[0]?.articuloNombre ||
      `${s(articuloCodigo)} ${s(articuloDescripcion)}`.trim() ||
      "Modelo sin nombre";

    const modeloConsumoLines = doc.splitTextToSize(
      `Modelo: ${nombreModelo}`,
      pageWidth - 70
    );

    doc.setFont(undefined, "bold");
    doc.text(modeloConsumoLines, marginLeft, currentY);
    currentY += modeloConsumoLines.length * 5 + 4;

    if (!consumosFiltrados.length) {
      doc.setFontSize(11);
      doc.setFont(undefined, "normal");
      doc.text(
        "No hay consumos para este artículo en el pedido.",
        marginLeft,
        currentY
      );
      currentY += 8;
    } else {
      const body = consumosFiltrados.map((c) => {
        const totalConsumo = (c.consumoUnitario || 0) * (cantidadArticulo || 0);

        return [
          c.tela,
          c.ancho,
          Number(c.consumoUnitario || 0).toFixed(2),
          Number(cantidadArticulo || 0).toFixed(2),
          Number(totalConsumo || 0).toFixed(2),
          c.observaciones,
        ];
      });

      const totalArticulo = consumosFiltrados.reduce(
        (sum, c) => sum + (c.consumoUnitario || 0) * (cantidadArticulo || 0),
        0
      );

      body.push([
        {
          content: "Total",
          colSpan: 4,
          styles: { halign: "right", fontStyle: "bold" },
        },
        Number(totalArticulo || 0).toFixed(2),
        "",
      ]);

      doc.autoTable({
        head: [
          [
            "Tela",
            "Ancho",
            "Consumo Unitario",
            "Cantidad Artículo",
            "Total",
            "Observaciones",
          ],
        ],
        body,
        startY: currentY + 2,
        styles: {
          fontSize: 9,
          halign: "center",
          valign: "middle",
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [41, 128, 186],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 247, 250],
        },
        margin: { left: 20, right: 20 },
        columnStyles: {
          0: { halign: "left" },
          1: { halign: "center" },
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "left" },
        },
      });

      currentY = doc.autoTable.previous.finalY + 10;
    }
    } // L123 — fin Hoja de Consumos comentada

    // ============ FOOTER L43 — pie con paginación en cada página ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(110, 120, 135);
        // doc.text(
        //   `OC #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
        //   pageWidth / 2,
        //   pageHeight - 5,
        //   { align: "center" }
        // );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  // (2026-10) fila = renglón del listado, para editar también las fechas
  function editOrden(id, observaciones, numeroInterno, subArea, fila = {}) {
    setIdEdit(id);
    setObservacionesEdit(observaciones);
    setNumeroInternoEdit(numeroInterno || "");
    setSubAreaEdit(subArea || "NA");
    setFechaOrdenEdit(String(fila.fecha || "").slice(0, 10));
    const entrega = String(fila.fechaCancelacion || "").slice(0, 10);
    setFechaEntregaEdit(entrega);
    setFechaEntregaOriginal(entrega);
    setPedidoEdit({ id: fila.idPedidos || "", numero: fila.pedido || "" });
    toggleObservacionesEdit();
  }
  async function saveObservacionesEdit(event) {
    event.preventDefault();
    const numeroInternoLimpio = (numeroInternoEdit || "").trim();
    const headers = {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    };
    try {
      await axios.patch(
        `${URL_ORDENES_CORTE}/${idEdit}`,
        {
          observaciones: observacionesEdit,
          numero: numeroInternoLimpio,
          subArea: String(subAreaEdit || "").trim() || "NA",
          ...(fechaOrdenEdit ? { fecha: fechaOrdenEdit } : {}),
        },
        headers
      );
      // (2026-10) la fecha de entrega es la fecha de cancelación del pedido:
      // si la cambiaron, se actualiza en el pedido (aplica a todas sus órdenes)
      if (fechaEntregaEdit && fechaEntregaEdit !== fechaEntregaOriginal && pedidoEdit.id) {
        await axios.patch(
          `${process.env.REACT_APP_URL_PEDIDOS}/${pedidoEdit.id}`,
          { fecha_cancelacion: fechaEntregaEdit },
          headers
        );
        axios
          .post(
            URL_LOGS,
            {
              tipo: "Fecha Cancelacion Pedido",
              detalle: `Pedido ${pedidoEdit.numero}: ${fechaEntregaOriginal} → ${fechaEntregaEdit} (desde Editar Orden)`,
              user: user.id,
            },
            headers
          )
          .catch((err) => console.log(err));
      }
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Observaciones",
          detalle: `Corte ${idEdit}`,
          user: user.id,
        },
        headers
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Listo",
        showConfirmButton: false,
        timer: 2000,
      });
      // (2026-10) sin reload: cerrar el modal y refrescar el listado
      setModalObservacionesEdit(false);
      refrescarDatos();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? error.response.data?.message || error.response.data : error}`,
      });
      console.log(error);
    }
  }

  function statusEdit(id, statusTela, observacionesStatusTela) {
    setIdEdit(id);
    setStatusTelaEdit(statusTela);
    setObservacionesStatusTelaEdit(observacionesStatusTela);
    toggleStatusEdit();
  }
  function saveStatusEdit(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_ORDENES_CORTE}/${idEdit}`,
        {
          statusTela: statusTelaEdit,
          observacionesStatusTela: observacionesStatusTelaEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((response) => {
        axios
          .post(
            URL_LOGS,
            {
              tipo: "Editar Status",
              detalle: `Corte ${idEdit}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Listo",
              showConfirmButton: false,
              timer: 2000,
            });
            // (2026-10) sin reload: cerrar el modal y refrescar el listado
            setModalStatusEdit(false);
            refrescarDatos();
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

async function requisicion(id, numero) {
  try {
    setExplosion([]);
    toggleProgreso();
    setIdEdit(id);
    setNumeroPedido(numero);

    const { data: allArticulosPedido } = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const arrayTabla = allArticulosPedido
      .map((a) => {
        const articulo = a.articulos?.[0];
        const color = a.colores?.[0];

        if (!articulo) return null;

        return {
          id: a._id,
          activo: a.is_active,
          articulos: articulo._id,
          articulosCodigo: `${articulo.codigo || ""} / ${articulo.codigoCliente || ""}`,
          colores: color?._id || "NA",
          coloresName: color?.name || "NA",
          cantidad: Number(a.cantidad || 0),
          cortado: Number(a.cortado || 0),
          pendiente_cortar: Number(a.pendiente_cortar || 0),
        };
      })
      .filter((el) => el != null);

    const data = Object.values(arrayTabla);

    const agrupado = data.reduce((groups, item) => {
      const val = String(item.articulos);

      if (!groups[val]) {
        groups[val] = {
          articulos: item.articulos,
          articulosCodigo: item.articulosCodigo,
          cantidad: 0,
        };
      }

      groups[val].cantidad += Number(item.cantidad || 0);
      return groups;
    }, {});

    const dataFinal = Object.values(agrupado);

    const agrupadoColores = data.reduce((groups, item) => {
      const val = `${item.articulos}_${item.colores}`;

      if (!groups[val]) {
        groups[val] = {
          articulos: item.articulos,
          articulosCodigo: item.articulosCodigo,
          colores: item.colores,
          coloresName: item.coloresName,
          cantidad: 0,
        };
      }

      groups[val].cantidad += Number(item.cantidad || 0);
      return groups;
    }, {});

    const dataFinalColores = Object.values(agrupadoColores);

    const temp2 = [];

    await Promise.all(
      dataFinal.map(async (a) => {
        try {
          const { data: allExplosion } = await axios.get(
            `${URL_EXPLOSION}Articulo/${a.articulos}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          allExplosion.forEach((b) => {
            if (b.habilitacion && b.habilitacion.length > 0) {
              temp2.push({
                articulos: a.articulos,
                articulosCodigo: a.articulosCodigo,
                material: `${b.habilitacion[0].nombre || ""} ${
                  b.habilitacion[0].descripcion || ""
                }`.trim(),
                cantidadTotal: Number(b.cantidad || 0) * Number(a.cantidad || 0),
                cantidad: Number(b.cantidad || 0),
                colores: "NA",
                coloresName: "NA",
                tipo: "Habilitacion",
              });
            }
          });
        } catch (err) {
          console.log(err);
        }
      })
    );

    await Promise.all(
      dataFinalColores.map(async (a) => {
        try {
          const { data: allExplosion } = await axios.get(
            `${URL_EXPLOSION}Articulo/${a.articulos}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          allExplosion.forEach((b) => {
            if (b.telas && b.telas.length > 0) {
              temp2.push({
                articulos: a.articulos,
                articulosCodigo: a.articulosCodigo,
                material: b.telas[0].nombre || "",
                cantidadTotal: Number(b.cantidad || 0) * Number(a.cantidad || 0),
                cantidad: Number(b.cantidad || 0),
                colores: a.colores,
                coloresName: a.coloresName,
                tipo: "Tela",
              });
            }
          });
        } catch (err) {
          console.log(err);
        }
      })
    );

    setExplosion(temp2);
    setModalProgreso(false);
    toggleExplosion();
  } catch (err) {
    console.log(err);
    setModalProgreso(false);
  }
}

  function telasCortes(id, numero) {
    toggleProgreso();
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            articulo:
              a.articulos[0].codigo +
              " / " +
              a.articulos[0].codigoCliente +
              " / " +
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre:
              a.telas[0].codigo +
              " / " +
              a.telas[0].nombre +
              " / " +
              a.colores[0].name,
          };
        });
        let dataFinal = Object.values(tablaTelas);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["tela"] + item["color"];
          groups[val] = groups[val] || {
            tela: item.tela,
            color: item.color,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].tela = item.tela;
          groups[val].unidad = item.unidad;
          groups[val].color = item.color;
          groups[val].articulo = item.articulo;
          groups[val].telaNombre = item.telaNombre;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        setInputFieldsAnterior(agrupadoValues);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            totalCantidad = totalCantidad + a.cantidad;
            totalCortado = totalCortado + a.cortado;
            totalPendCortar = totalPendCortar + a.pendiente_cortar;
            return {
              id: a._id,
              articuloNombre:
                a.articulos[0].codigo + " / " + a.articulos[0].descripcion,
              idArticulo: a.articulos[0]._id,
              cantidad: a.cantidad,
              cortado: a.cortado,
              pendiente_cortar: a.pendiente_cortar,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosOrden(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelas();
      setModalProgreso(false);
    }, 2000);
  }

  function telasCortesDev(id, numero) {
    setIdsInventario([]);
    axios
      .get(`${URL_INVENTARIOS_TELAS}/cortesDevolucion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelasDevolucion = res.data;
        setTelasDevolucion(allTelasDevolucion);
        let result = allTelasDevolucion.map(({ _id }) => _id);
        setIdsInventario(result);
      })
      .catch((err) => {
        console.log(err);
      });
    setSelectedOrdenCorteDev(id);
    setSelectedOrdenCorteNumeroDev(numero);
    toggleTelasDev();
  }

  function BuscaRolloDev(id, event) {
    if (event.target.value.length >= 24) {
      if (idsInventario.includes(event.target.value)) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          telasDevolucion.map((a) => {
            if (a._id == event.target.value) {
              let telasDevolucion = a._id;
              let tela = a.tela;
              let idTela = a.idTela;
              let unidadTela = a.unidadTela;
              let color = a.color;
              let cantidadOriginal = a.cantidad;
              let cantidad = a.cantidad;
              let compras = a.compras;
              let telasOC = a.telasOC;
              let telaCodigo = a.telaCodigo;
              let telaNombre = a.telaNombre;
              let telaColor = a.telaColor;
              handleChangeInputArticuloDev(
                id,
                telasDevolucion,
                tela,
                idTela,
                unidadTela,
                color,
                cantidad,
                cantidadOriginal,
                compras,
                telasOC,
                telaCodigo,
                telaNombre,
                telaColor,
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo no pertenece al pedido o fue devuelto previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputArticuloDev = (
    id,
    telasDevolucion,
    tela,
    idTela,
    unidadTela,
    color,
    cantidad,
    cantidadOriginal,
    compras,
    telasOC,
    telaCodigo,
    telaNombre,
    telaColor,
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = telasDevolucion;
        i.telas = tela;
        i.idTela = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.cantidad = cantidad;
        i.cantidadOriginal = cantidadOriginal;
        i.compras = compras;
        i.telasOC = telasOC;
        i.telaCodigo = telaCodigo;
        i.telaNombre = telaNombre;
        i.telaColor = telaColor;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
    handleAddFields();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
  };

  function ActualizaTotalesDev() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["colores"] + item["idTela"];
      groups[val] = groups[val] || {
        colores: item.colores,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].id = item.id;
      groups[val].cantidad += item.cantidad;
      groups[val].colores = item.colores;
      groups[val].idTela = item.idTela;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);

    let tr = 0;
    inputFields.map((a) => {
      if (a.idTela != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotalesDev(tr);
  }

  const saveTelasDev = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    // (2026-10) sin reload: al terminar se cierran los modales, se limpia la
    // captura y se refrescan listado + rollos en existencia
    const terminaDevolucion = () => {
      setModalTelasDev(false);
      setModalProgreso(false);
      setValidaBoton(true);
      limpiaCapturaTelas();
      refrescarDatos({ telas: true });
    };

    let totalRollos = inputFields.length + cantidadAgrupado.length;

    try {
      inputFields.map((a) => {
        if (a.idInventarioTelas != "") {
          if (a.cantidad != a.cantidadOriginal) {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/${a.idInventarioTelas}`,
                {
                  cantidad:
                    parseFloat(a.cantidadOriginal) - parseFloat(a.cantidad),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                axios
                  .post(
                    `${URL_INVENTARIOS_TELAS}`,
                    {
                      cantidad: a.cantidad,
                      captura: 1,
                      produccion: "No",
                      telas: a.idTela,
                      colores: a.colores,
                      compras: a.compras,
                      telasOC: a.telasOC,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then((data) => {
                    totalRollos = totalRollos - 1;
                    QRGen(
                      data.data._id,
                      a.telaCodigo,
                      a.telaNombre,
                      a.telaColor,
                      a.cantidad,
                      a.unidad,
                      a.composicion
                    );
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Devolucion",
                            detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token",
                              )}`,
                            },
                          },
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          terminaDevolucion();
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/devolucionCorte/${a.idInventarioTelas}`,
                {},
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Devolucion",
                        detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      terminaDevolucion();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                terminaDevolucion();
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Pegamos a Devoluciones Acumulado

      cantidadAgrupado.map((w) => {
        if (w.idTela != "") {
          axios
            .patch(
              `${URL_INVENTARIOS_TELAS}DevolucionCorte2`,
              {
                ordenesCorte: selectedOrdenCorteDev,
                total_cantidad: w.cantidad,
                idColor: w.colores,
                idTela: w.idTela,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              },
            )
            .then(() => {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Devolucion",
                      detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    terminaDevolucion();
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                terminaDevolucion();
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Terminamos de post a devoluciones acumulado
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

function QRGen(id, codigo, nombre, color, cantidad, unidad, composicion) {
  const doc = new jsPDF("l", "mm", [100, 50]);

  const M = 4;
  const PAGE_H = 50;
  const LEFT_COL_W = 60;
  const RIGHT_COL_X = M + LEFT_COL_W + 2;

  // --- Logos ---
  try {
    const logo1 = new Image();
    logo1.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
    doc.addImage(logo1, "PNG", M, M, 22, 6);
  } catch (_) {}

  try {
    const logo2 = new Image();
    logo2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(logo2, "PNG", M, M + 7.5, 22, 8);
  } catch (_) {}

  // --- QR ---
  const base64 = qrcode.toDataURL(String(id ?? ""));
  doc.addImage(base64, "PNG", RIGHT_COL_X, M, 30, 30);

  // --- Texto dinámico ---
  const wrap = (txt) => doc.splitTextToSize(String(txt ?? ""), LEFT_COL_W);

  const addTextBlock = (text, y) => {
    const lines = wrap(text);
    doc.text(lines, M, y);
    const h = doc.getTextDimensions(lines).h;
    return y + h + 1;
  };

  let y = M + 11;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  y = addTextBlock(`Cod: ${codigo}`, y);
  y = addTextBlock(`Mod: ${nombre}`, y);
  y = addTextBlock(`Color: ${color}`, y);
  y = addTextBlock(`Comp: ${composicion}`, y); // 👈 AQUÍ
  y = addTextBlock(`ID: ${id}`, y);

  // Cantidad: debajo del QR (derecha), negrita, sin "Cant." (como ListadoCompras)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  const cantTxt = `${cantidad ?? ""} ${unidad ?? ""}`.trim();
  const qrCenterX = RIGHT_COL_X + 15;
  const cantY = M + 30 + 7;
  doc.text(cantTxt, qrCenterX, cantY, { align: "center" });

  window.open(doc.output("bloburl"), "_blank");
}

  let totalCantidadMt = 0;
  let totalCantidadKg = 0;
  async function PDFTelas(
    numero,
    fecha,
    pedido,
    id,
    total_piezas,
    cliente,
    articulo,
    observacionesStatusTela,
  ) {
    let temp2 = [];
    await axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosOrdenCorte = response.data;
        // Alias que NO se sombrea dentro del .then de InventariosTelas (donde se
        // vuelve a declarar allArticulosOrdenCorte con los rollos). Trae los pedidos.
        const allArticulosOrdenCorteRaw = response.data;
        let colorTallaCantidad = {};
        // (2026-07) Piezas por Artículo+Color y nombres, para el consumo exacto
        const piezasArtColor = {};
        const artNombreMap = {};
        const colNombreMap = {};

        allArticulosOrdenCorte.forEach((a) => {
          const color = a.colores[0].name;
          const talla = a.tallas[0].name;
          const cantidad = a.cantidad;

          if (!colorTallaCantidad[talla]) {
            colorTallaCantidad[talla] = {};
          }
          if (!colorTallaCantidad[talla][color]) {
            colorTallaCantidad[talla][color] = 0;
          }
          colorTallaCantidad[talla][color] += cantidad;

          // Piezas por artículo+color (para dividir la tela y sacar el consumo)
          const artId = a.articulos?.[0]?._id || "";
          const colId = a.colores?.[0]?._id || "";
          const keyAC = `${artId}||${colId}`;
          piezasArtColor[keyAC] = (piezasArtColor[keyAC] || 0) + Number(cantidad || 0);
          // (2026-07) Del artículo solo Código / Línea (subDepartamento)
          if (artId)
            artNombreMap[artId] = [
              a.articulos[0].codigo || "",
              a.articulos[0].subDepartamentos?.[0]?.name || "",
            ]
              .filter((x) => x)
              .join(" / ");
          if (colId) colNombreMap[colId] = a.colores[0].name || "";
        });

        const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
          const indexA = ordenTallas.indexOf(a);
          const indexB = ordenTallas.indexOf(b);

          // Si alguna talla no está en el orden definido, coloca al final
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });
        const colores = [
          ...new Set(allArticulosOrdenCorte.map((a) => a.colores[0].name)),
        ].sort();

        await axios
          .get(`${URL_INVENTARIOS_TELAS}/ordenCorte/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(async (response) => {
            let allArticulosOrdenCorte = response.data;
            let arrayTabla = allArticulosOrdenCorte
              .map((a) => {
                if (a.unidad == "Metros") {
                  totalCantidadMt = totalCantidadMt + a.cantidad;
                } else {
                  totalCantidadKg = totalCantidadKg + a.cantidad;
                }
                return {
                  id: a._id,
                  articulo: a.articulo,
                  proveedor: a.proveedor,
                  factura: a.factura,
                  cantidad: a.cantidad,
                  cantidadSobrante: a.cantidadSobrante,
                  unidad: a.unidad,
                  idTela: a.idTela,
                  telaNombre: a.articulo,
                  colorNombre: a.colorNombre,
                  idColor: a.idColor,
                  cantidadString: a.cantidadString,
                  precio: a.precio,
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            let mts = dataFinal.filter((e) => e.unidad == "Metros");
            let totalMts = mts.map((c) => parseFloat(c.cantidad));
            let TM = totalMts.reduce((t, total, index) => t + total, 0);

            let KG = dataFinal.filter((e) => e.unidad == "Kilos");
            let totalKG = KG.map((c) => parseFloat(c.cantidad));
            let TK = totalKG.reduce((t, total, index) => t + total, 0);

            const data = dataFinal
              .sort((a, b) => (a.colorNombre < b.colorNombre ? 1 : -1))
              // L65 (2026-06) — no mostrar renglones con cantidad 0
              .filter((a) => Number(a.cantidad) > 0)
              .map((a) => {
                return [
                  a.proveedor,
                  a.articulo,
                  a.colorNombre,
                  // "$" + new Intl.NumberFormat("en-US").format(a.precio),
                  // a.factura,
                  new Intl.NumberFormat("en-US").format(a.cantidad) +
                    " " +
                    a.unidad,
                  new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
                  a.cantidadString,
                ];
              });
            const dataPDF = Object.values(data);
            const dataPDFLimpia = dataPDF.filter(function (el) {
              return el != null;
            });
            // Observaciones de telas
            let obsText = "";
            let responsableText = "";

            try {
              const respObs = await axios.get(
                `${URL_TELAS_ORDENES_CORTE}/ordenCorte/${id}`,
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                },
              );

              const items = (respObs.data || [])
                // si NO existe "nombre" en esos docs, quita este sort o cambia la clave
                .sort((a, b) =>
                  String(a?.nombre || "") > String(b?.nombre || "") ? 1 : -1,
                )
                .map((a) => ({
                  observaciones: a?.observaciones || "",
                  responsable: a?.responsable || "",
                }));

              const first = items[0] || {};
              obsText = first.observaciones || "";
              responsableText = first.responsable || "";

              // si además quieres tenerlos en la UI:
              try {
                setObservacionesTelasPDF(obsText);
              } catch (_) {}
              try {
                setResponsableTelasPDF(responsableText);
              } catch (_) {}
            } catch (e) {
              console.log("Observaciones telas error:", e);
              obsText = "";
              responsableText = "";
            }

            // (2026-07) CONSUMOS POR ARTÍCULO Y COLOR
            // Regla (según el usuario):
            //   - Base: los ARTÍCULOS + COLORES DE PRENDA del corte (ArticulosOrdenesCorte)
            //     con sus piezas.
            //   - Se cruza cada tela ENTREGADA (rollos reales) con los CONSUMOS
            //     registrados en el pedido (ConsumoTelas: artículo + color de prenda +
            //     tela). Si la tela está en los consumos, la tela entregada se reparte
            //     entre esos artículos+colores (peso = consumo unitario × piezas).
            //   - Las telas ENTREGADAS que NO están en los consumos se PROMEDIAN entre
            //     todas las piezas del corte (consumo = entregado / total piezas).
            //   El match tela↔consumo es por NOMBRE de tela (robusto).
            let consumoRows = [];
            try {
              const normTela = (s) =>
                String(s || "").split("/").pop().trim().toLowerCase();

              // Combos del corte (artículo + color de prenda) con piezas
              const combos = Object.keys(piezasArtColor)
                .map((k) => {
                  const [artId, garId] = k.split("||");
                  return { artId, garId, piezas: piezasArtColor[k] };
                })
                .filter((c) => c.piezas > 0);
              const totalPiezasCorte = combos.reduce((s, c) => s + c.piezas, 0);

              // Piezas por NOMBRE de color de prenda (total de ese color, sumando
              // artículos/tallas). Sirve para empatar el color de la tela con el
              // color de prenda y usar las piezas de ESE color (no las del corte).
              const normColor = (s) => String(s || "").trim().toLowerCase();
              const piezasPorColor = {};
              combos.forEach((c) => {
                const cn = colNombreMap[c.garId] || "";
                const nk = normColor(cn);
                if (!nk) return;
                if (!piezasPorColor[nk]) {
                  piezasPorColor[nk] = {
                    piezas: 0,
                    colorNombre: cn,
                    artNombre: artNombreMap[c.artId] || "—",
                  };
                }
                piezasPorColor[nk].piezas += c.piezas;
              });

              // Consumos registrados del/los pedido(s), indexados por NOMBRE de tela
              const pedidoIds = [
                ...new Set(
                  allArticulosOrdenCorteRaw
                    .map((a) => a?.pedidos?.[0]?._id || a?.pedidos?.[0] || "")
                    .filter((x) => x)
                    .map(String),
                ),
              ];
              let consumos = [];
              for (const pid of pedidoIds) {
                const { data } = await axios.get(
                  `${URL_CONSUMO_TELAS}Pedido/${pid}`,
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token",
                      )}`,
                    },
                  },
                );
                consumos = consumos.concat(data || []);
              }
              const consumoPorTela = {}; // normTela -> [{artId, garId, unit}]
              (consumos || []).forEach((c) => {
                const artId = c.articulos?.[0]?._id || "";
                const garId = c.colores?.[0]?._id || "";
                const unit = Number(c.cantidad || 0);
                const telaNombre = c.telas?.[0]?.nombre || "";
                if (!artId || !garId || !telaNombre || unit <= 0) return;
                const nm = normTela(telaNombre);
                if (!consumoPorTela[nm]) consumoPorTela[nm] = [];
                consumoPorTela[nm].push({ artId, garId, unit });
              });

              // Tela REALMENTE entregada = rollos (dataFinal) por tela + color de tela
              const entregado = {};
              (dataFinal || []).forEach((r) => {
                const qty = Number(r.cantidad || 0);
                const nm = normTela(r.telaNombre);
                if (!nm || qty <= 0) return;
                const k = `${nm}||${r.idColor || r.colorNombre || ""}`;
                if (!entregado[k]) {
                  entregado[k] = {
                    nm,
                    telaNombre: r.telaNombre || "—",
                    fabName: r.colorNombre || "",
                    qty: 0,
                  };
                }
                entregado[k].qty += qty;
              });

              const out = [];
              Object.values(entregado).forEach((e) => {
                const reg = (consumoPorTela[e.nm] || [])
                  .map((g) => ({
                    ...g,
                    piezas: piezasArtColor[`${g.artId}||${g.garId}`] || 0,
                  }))
                  .filter((g) => g.piezas > 0);
                const totalW = reg.reduce((s, g) => s + g.unit * g.piezas, 0);

                if (reg.length && totalW > 0) {
                  // Está en los consumos → reparte lo entregado por artículo+color
                  reg.forEach((g) => {
                    const entregada = e.qty * ((g.unit * g.piezas) / totalW);
                    out.push({
                      artNombre: artNombreMap[g.artId] || "—",
                      colNombre: colNombreMap[g.garId] || "—",
                      fabName: e.fabName || "—",
                      telaNombre: e.telaNombre,
                      piezas: g.piezas,
                      entregada,
                      consumo: g.piezas ? entregada / g.piezas : 0,
                    });
                  });
                } else {
                  // NO está en los consumos → piezas = TOTAL DE ESE COLOR (empata el
                  // color de la tela con el color de prenda por nombre). Si no empata
                  // ningún color, cae al total del corte.
                  const match = piezasPorColor[normColor(e.fabName)];
                  const piezas = match ? match.piezas : totalPiezasCorte;
                  const rate = piezas > 0 ? e.qty / piezas : 0;
                  out.push({
                    artNombre: match ? match.artNombre : "PROMEDIO",
                    colNombre: match ? match.colorNombre : "TODOS",
                    fabName: e.fabName || "—",
                    telaNombre: e.telaNombre,
                    piezas,
                    entregada: e.qty,
                    consumo: rate,
                  });
                }
              });

              consumoRows = out
                .filter((r) => r.entregada > 0)
                .sort(
                  (a, b) =>
                    String(a.artNombre).localeCompare(String(b.artNombre), "es") ||
                    String(a.colNombre).localeCompare(String(b.colNombre), "es") ||
                    String(a.telaNombre).localeCompare(String(b.telaNombre), "es"),
                )
                .map((r) => [
                  r.artNombre,
                  r.colNombre,
                  r.fabName || "—",
                  r.telaNombre,
                  r.consumo ? r.consumo.toFixed(3) : "—",
                  new Intl.NumberFormat("en-US").format(r.piezas),
                  r.entregada ? r.entregada.toFixed(2) : "—",
                ]);
            } catch (eCons) {
              console.log("Consumos por artículo/color error:", eCons);
              consumoRows = [];
            }

            // === L51 (2026-06) — Formato corporativo ===
            const doc = new jsPDF("landscape");
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const marginLeft = 15;
            const marginRight = 15;

            const brandColor = [42, 90, 138];
            const lightBg = [245, 247, 250];
            const borderColor = [210, 216, 224];
            const labelColor = [110, 120, 135];
            const stripeBg = [251, 252, 253];

            const drawLabel = (label, value, lblX, valX, y) => {
              doc.setFont(undefined, "bold");
              doc.setTextColor(...labelColor);
              doc.setFontSize(8.5);
              doc.text(label, lblX, y);
              doc.setFont(undefined, "normal");
              doc.setTextColor(0);
              doc.setFontSize(9.5);
              const txt = String(value ?? "").trim();
              doc.text(txt || "—", valX, y);
            };

            // Logo izquierda
            const img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            try {
              doc.addImage(img2, "png", marginLeft, 8, 32, 14);
            } catch (e) {}

            // Título derecha + línea azul
            doc.setFont(undefined, "bold");
            doc.setFontSize(16);
            doc.setTextColor(...brandColor);
            doc.text(`SALIDA TELA OP # ${numero}`, pageWidth - marginRight, 18, { align: "right" });
            doc.setTextColor(0);
            doc.setDrawColor(...brandColor);
            doc.setLineWidth(0.6);
            doc.line(marginLeft, 28, pageWidth - marginRight, 28);
            doc.setLineWidth(0.2);
            doc.setDrawColor(0);

            // Card 2 columnas
            const cardY = 31;
            const cardW = pageWidth - marginLeft - marginRight;
            const cardH = 28;
            doc.setDrawColor(...borderColor);
            doc.setFillColor(...lightBg);
            doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
            doc.setDrawColor(0);

            const lblX_L = marginLeft + 3;
            const valX_L = marginLeft + 30;
            const baseY = cardY + 6;
            drawLabel("Fecha OC:", fecha, lblX_L, valX_L, baseY);
            drawLabel("Modelo:", articulo, lblX_L, valX_L, baseY + 5);
            drawLabel(
              "Cantidad:",
              `${totalCantidadMt.toFixed(2)} Mts ${totalCantidadKg.toFixed(2)} Kgs`,
              lblX_L, valX_L, baseY + 10
            );
            drawLabel("Observaciones:", obsText, lblX_L, valX_L, baseY + 15);
            drawLabel("Responsable:", responsableText, lblX_L, valX_L, baseY + 20);

            const colRightX = pageWidth / 2 + 5;
            const lblX_R = colRightX;
            const valX_R = colRightX + 26;
            drawLabel("Pedido:", pedido, lblX_R, valX_R, baseY);
            drawLabel("Cliente:", cliente, lblX_R, valX_R, baseY + 5);
            drawLabel("Piezas:", total_piezas, lblX_R, valX_R, baseY + 10);

            // Crear una variable para almacenar todas las filas de datos
            const bodyData = [];

            // Iterar sobre las tallas
            tallas.forEach((talla) => {
              let rowData = [talla];
              let totalTalla = 0;

              // Iterar sobre los colores
              colores.forEach((color) => {
                const cantidad = colorTallaCantidad[talla][color] || 0;
                rowData.push(cantidad);
                totalTalla += cantidad;
              });

              // Agregar el total por talla al final de la fila
              rowData.push(totalTalla);

              // Agregar la fila de datos al conjunto de datos del cuerpo
              bodyData.push(rowData);
            });

            // Calcular y agregar totales por color en una fila al final de la tabla
            const totalesColorRow = ["Total"];
            let totalGeneral = 0; // Inicializar el total general
            colores.forEach((color) => {
              let totalColor = 0;
              tallas.forEach((talla) => {
                totalColor += colorTallaCantidad[talla][color] || 0;
              });
              totalesColorRow.push(totalColor);
              totalGeneral += totalColor; // Sumar al total general
            });

            // Agregar el total general al final de la fila de totales
            totalesColorRow.push(totalGeneral);

            // Agregar totalesColorRow al final de bodyData
            bodyData.push(totalesColorRow);

            // L51 (2026-06) — Tabla principal con paleta corporativa
            doc.autoTable({
              head: [["Tallas", ...colores, "Total"]],
              body: bodyData,
              startY: cardY + cardH + 5,
              margin: { left: marginLeft, right: marginRight },
              theme: "grid",
              styles: {
                fontSize: 9.5,
                cellPadding: 1,
                valign: "middle",
                halign: "center",
                lineColor: borderColor,
                lineWidth: 0.15,
              },
              headStyles: {
                fillColor: brandColor,
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 10,
                halign: "center",
              },
              alternateRowStyles: {
                fillColor: stripeBg,
              },
            });

            doc.autoTable({
              head: [
                [
                  "Proveedor",
                  "Articulo",
                  "Color",
                  "Cantidad",
                  "Sobrante",
                  "Rollos",
                ],
              ],
              body: dataPDFLimpia,
              startY: doc.autoTable.previous.finalY + 8,
              margin: { left: marginLeft, right: marginRight },
              foot: [[]],
              showFoot: "lastPage",
              theme: "grid",
              styles: {
                fontSize: 9,
                cellPadding: 1,
                valign: "middle",
                halign: "center",
                lineColor: borderColor,
                lineWidth: 0.15,
              },
              headStyles: {
                fillColor: brandColor,
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 9.5,
                halign: "center",
              },
              alternateRowStyles: {
                fillColor: stripeBg,
              },
            });

            // (2026-07) Tabla CONSUMOS POR ARTÍCULO Y COLOR (según la explosión)
            if (consumoRows.length) {
              let cY = doc.autoTable.previous.finalY + 8;
              doc.setFillColor(...brandColor);
              doc.rect(marginLeft, cY, cardW, 6, "F");
              doc.setTextColor(255, 255, 255);
              doc.setFont(undefined, "bold");
              doc.setFontSize(9.5);
              doc.text("CONSUMOS POR ARTÍCULO Y COLOR", marginLeft + 3, cY + 4.2);
              doc.setTextColor(0);
              cY += 6;
              doc.autoTable({
                head: [
                  [
                    "Artículo",
                    "Color",
                    "Color Tela",
                    "Tela",
                    "Consumo x Pza",
                    "Piezas",
                    "Tela Entregada",
                  ],
                ],
                body: consumoRows,
                startY: cY,
                margin: { left: marginLeft, right: marginRight },
                theme: "grid",
                styles: {
                  fontSize: 9,
                  cellPadding: 1,
                  valign: "middle",
                  halign: "center",
                  lineColor: borderColor,
                  lineWidth: 0.15,
                },
                headStyles: {
                  fillColor: brandColor,
                  textColor: [255, 255, 255],
                  fontStyle: "bold",
                  fontSize: 9.5,
                  halign: "center",
                },
                alternateRowStyles: { fillColor: stripeBg },
              });
            }

            // === Observaciones finales de telas — L51 caja con label band ===
            const observacionesFinal = String(observacionesStatusTela || "").trim().replace(/\t/g, "  ").replace(/\r/g, "");
            let finalY = doc.autoTable.previous.finalY + 6;
            if (observacionesFinal) {
              doc.setFillColor(...brandColor);
              doc.rect(marginLeft, finalY, cardW, 6, "F");
              doc.setTextColor(255, 255, 255);
              doc.setFont(undefined, "bold");
              doc.setFontSize(9.5);
              doc.text("OBSERVACIONES TELAS", marginLeft + 3, finalY + 4.2);
              doc.setTextColor(0);
              finalY += 6;
              doc.setFont(undefined, "normal");
              doc.setFontSize(9);
              const splitText = doc.splitTextToSize(observacionesFinal, cardW - 12);
              const blockHObs = splitText.length * 4.2;
              doc.setFillColor(...lightBg);
              doc.setDrawColor(...borderColor);
              doc.rect(marginLeft, finalY, cardW, blockHObs + 5, "FD");
              doc.setDrawColor(0);
              doc.text(splitText, marginLeft + 3, finalY + 4);
              finalY += blockHObs + 7;
            }

            // ============ FOOTER L51 — paginación ============
            try {
              const pageCount = doc.internal.getNumberOfPages();
              for (let p = 1; p <= pageCount; p++) {
                doc.setPage(p);
                doc.setFontSize(8);
                doc.setTextColor(...labelColor);
                doc.text(
                  `Salida Tela OP #${numero}  ·  ${cliente}  ·  Página ${p} de ${pageCount}`,
                  pageWidth / 2,
                  pageHeight - 5,
                  { align: "center" }
                );
                doc.setTextColor(0);
              }
            } catch (errFooter) {
              console.warn("No se pudo dibujar footer:", errFooter);
            }

            window.open(doc.output("bloburl"), "_blank");
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

async function PDFTelasDetalles(
  numero,
  fecha,
  pedido,
  id,
  total_piezas,
  cliente,
  articulo,
) {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1) Detalle de inventarios de telas
    const { data: allArticulosSurtido } = await axios.get(
      `${URL_INVENTARIOS_TELAS}/ordenCorteDetalle/${id}`,
      { headers },
    );

    const arrayTabla = (allArticulosSurtido || [])
      .map((a) => ({
        id: a?._id,
        articulo: a?.articulo,
        proveedor: a?.proveedor,
        factura: a?.factura,
        cantidad: Number(a?.cantidad || 0),
        cantidadSobrante: Number(a?.cantidadSobrante || 0),
        unidad: a?.unidad || "",
        idTela: a?.idTela,
        telaNombre: a?.articulo,
        colorNombre: a?.colorNombre,
        idColor: a?.idColor,
        cantidadString: a?.cant || "",
      }))
      .filter(Boolean);

    const dataFinal = Object.values(arrayTabla);

    // 🔥 Totales
    let totalCantidadMt = 0;
    let totalCantidadKg = 0;
    let totalCantidadGeneral = 0; // 👈 NUEVO

    for (const r of dataFinal) {
      totalCantidadGeneral += r.cantidad; // 👈 SUMA GENERAL

      if (String(r.unidad).toLowerCase().startsWith("metro"))
        totalCantidadMt += r.cantidad;
      else if (String(r.unidad).toLowerCase().startsWith("kilo"))
        totalCantidadKg += r.cantidad;
    }

    // 2) Observaciones y responsable
    let obsText = "";
    let responsableText = "";
    try {
      const { data: obsResp } = await axios.get(
        `${URL_TELAS_ORDENES_CORTE}/ordenCorte/${id}`,
        { headers },
      );

      const items = (obsResp || [])
        .sort((a, b) =>
          String(a?.nombre || "") > String(b?.nombre || "") ? 1 : -1,
        )
        .map((a) => ({
          observaciones: a?.observaciones || "",
          responsable: a?.responsable || "",
        }));

      const first = items[0] || {};
      obsText = first.observaciones || "";
      responsableText = first.responsable || "";
    } catch (e) {
      console.log("Error obteniendo observaciones/responsable:", e);
    }

    // 3) Tabla
    const dataPDFLimpia = dataFinal.map((a) => [
      a.id,
      a.telaNombre,
      a.colorNombre,
      `${new Intl.NumberFormat("en-US").format(a.cantidad)} ${a.unidad}`,
    ]);

    // === L51 (2026-06) — Formato corporativo ===
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginRight = 15;

    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = String(value ?? "").trim();
      doc.text(txt || "—", valX, y);
    };

    // Logo izq
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    try { doc.addImage(img2, "png", marginLeft, 8, 32, 14); } catch (e) {}

    // Título der + línea azul
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`SALIDA TELA (ROLLOS) OC # ${numero}`, pageWidth - marginRight, 18, { align: "right" });
    doc.setTextColor(0);
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, 28, pageWidth - marginRight, 28);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // Card 2 cols
    const cardY = 31;
    const cardW = pageWidth - marginLeft - marginRight;
    const cardH = 32;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 30;
    const baseY = cardY + 6;
    drawLabel("Fecha OC:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Modelo:", articulo, lblX_L, valX_L, baseY + 5);
    drawLabel(
      "Cantidad:",
      `${totalCantidadMt.toFixed(2)} Mts ${totalCantidadKg.toFixed(2)} Kgs`,
      lblX_L, valX_L, baseY + 10
    );
    drawLabel(
      "Total General:",
      new Intl.NumberFormat("en-US").format(totalCantidadGeneral),
      lblX_L, valX_L, baseY + 15
    );
    drawLabel("Observaciones:", obsText, lblX_L, valX_L, baseY + 20);
    drawLabel("Responsable:", responsableText, lblX_L, valX_L, baseY + 25);

    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 26;
    drawLabel("Pedido:", pedido, lblX_R, valX_R, baseY);
    drawLabel("Cliente:", cliente, lblX_R, valX_R, baseY + 5);
    drawLabel("Piezas:", total_piezas, lblX_R, valX_R, baseY + 10);

    doc.autoTable({
      head: [["id", "Tela", "Color", "Cantidad"]],
      body: dataPDFLimpia,
      startY: cardY + cardH + 5,
      margin: { left: marginLeft, right: marginRight },
      showFoot: "lastPage",
      foot: [
        [
          "",
          "",
          "TOTAL",
          new Intl.NumberFormat("en-US").format(totalCantidadGeneral),
        ],
      ],
      // L51 (2026-06)
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 1,
        valign: "middle",
        halign: "center",
        lineColor: borderColor,
        lineWidth: 0.15,
      },
      headStyles: {
        fillColor: brandColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 9.5,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: stripeBg,
      },
      // L51 — foot solo coloreamos las 2 últimas columnas (TOTAL + monto)
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [255, 255, 255],
        lineWidth: 0,
      },
      didParseCell: (h) => {
        if (h.section === "foot") {
          const isLastTwo = h.column.index === 2 || h.column.index === 3;
          if (isLastTwo) {
            h.cell.styles.fillColor = brandColor;
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.fontStyle = "bold";
            h.cell.styles.lineColor = brandColor;
            h.cell.styles.lineWidth = 0.15;
          } else {
            h.cell.styles.fillColor = [255, 255, 255];
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.lineColor = [255, 255, 255];
            h.cell.styles.lineWidth = 0;
          }
        }
      },
    });

    // ============ FOOTER L51 — paginación ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Salida Tela (Rollos) OP #${numero}  ·  ${cliente}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
  }
}

  function BuscaRollo(id, event) {
    if (event.target.value.length >= 24) {
      if (inventarios.filter((e) => e._id == event.target.value).length > 0) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          inventarios.map((a) => {
            if (a._id == event.target.value) {
              let idInventarioTelas = a._id;
              let telas = a.telas[0].nombre;
              let idTela = a.telas[0]._id;
              let unidad = a.telas[0].unidad;
              let color = a.colores[0].name;
              let idColor = a.colores[0]._id;
              let cantidad = a.cantidad;
              let telaNombre = a.telas[0].nombre + " / " + a.colores[0].name;

              handleChangeInputTelas(
                id,
                idInventarioTelas,
                telas,
                idTela,
                unidad,
                color,
                idColor,
                cantidad,
                telaNombre,
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo ya fue cortado previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputTelas = (
    id,
    idInventarioTelas,
    telas,
    idTela,
    unidad,
    color,
    idColor,
    cantidad,
    telaNombre,
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = idInventarioTelas;
        i.telas = telas;
        i.idTela = idTela;
        i.unidad = unidad;
        i.colores = color;
        i.idColor = idColor;
        i.cantidad = cantidad;
        i.telaNombre = telaNombre;
      }
      return i;
    });

    ActualizaTotalesSurt();
    setInputFields(newInputFields);
    handleAddFields();
  };

  function ActualizaTotalesSurt() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idColor"] + item["idTela"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        idColor: item.idColor,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].telas = item.telas;
      groups[val].idTela = item.idTela;
      groups[val].idArticulo = item.idArticulo;
      groups[val].unidad = item.unidad;
      groups[val].idColor = item.idColor;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
    let tr = 0;
    inputFields.map((a) => {
      if (a.idArticulo != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotales(tr);
  }

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        idColor: "",
        cantidad: 0,
        idArticulo: ultimo.idArticulo,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
  };

  const handleChangeInputArticulo = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const saveTelas = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();
      // (2026-10) sin reload: al terminar se cierran los modales, se limpia la
      // captura y se refrescan listado + rollos en existencia (los rollos que
      // salieron ya no deben poder escanearse otra vez)
      const terminaSalidaTelas = () => {
        setModalTelas(false);
        setModalProgreso(false);
        setValidaBoton(true);
        limpiaCapturaTelas();
        refrescarDatos({ telas: true });
      };

      let totalRollos = inputFields.length + cantidadAgrupado.length;
      try {
        await axios
          .post(
            URL_TELAS_ORDENES_CORTE,
            {
              fecha: fechaTelas,
              ordenesCorte: selectedOrdenCorte,
              observaciones: observacionesTelas,
              responsable: responsableTelas,
              totalMetros,
              totalKilos,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then((data) => {
            inputFields.map((a) => {
              if (a.idTela != "") {
                axios
                  .patch(
                    `${URL_INVENTARIOS_TELAS}/ordenesCorte/${a.idInventarioTelas}`,
                    {
                      ordenesCorte: selectedOrdenCorte,
                      fechaCorte: fechaTelas,
                      produccion: "Si",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Telas Ordenes Corte",
                            detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token",
                              )}`,
                            },
                          },
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          terminaSalidaTelas();
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Telas Ordenes Corte",
                        detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      terminaSalidaTelas();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });

            // Pegamos a Apartados Acumulado

            cantidadAgrupado.map((w) => {
              axios
                .post(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}`,
                  {
                    telasOrdenesCorte: data.data._id,
                    articulos: w.idArticulo,
                    telas: w.idTela,
                    colores: w.idColor,
                    cantidad: w.cantidad,
                    ordenesCorte: selectedOrdenCorte,
                    fecha: fechaTelas,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token",
                      )}`,
                    },
                  },
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Telas Ordenes Corte",
                          detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token",
                            )}`,
                          },
                        },
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        terminaSalidaTelas();
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Terminamos de post a apartados acumulado
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function cortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "Si";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Cerró",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function noCortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como no cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "No";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Abrió",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  // (2026-08) Autorización de la orden. Autorizada = ya no se pueden tocar los
  // artículos (cantidades, alta de talla/color) desde este listado.
  const estaAutorizada = (a) => String(a?.autorizacion || "No") === "Si";

  async function toggleAutorizacion(a) {
    const autorizar = !estaAutorizada(a);
    const res = await Swal.fire({
      title: autorizar ? "¿Autorizar la orden?" : "¿Quitar la autorización?",
      text: autorizar
        ? "Una vez autorizada ya no se podrán modificar sus artículos."
        : "Se volverán a poder modificar los artículos.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: autorizar ? "Sí, autorizar" : "Sí, quitar",
      cancelButtonText: "Cancelar",
    });
    if (!res.isConfirmed) return;

    try {
      await axios.patch(
        `${URL_ORDENES_CORTE}/${a._id}`,
        {
          autorizacion: autorizar ? "Si" : "No",
          // autorizacionUser es ObjectId: al quitar la autorización va null
          // ("" truena con CastError en Mongoose).
          ...(autorizar
            ? { autorizacionUser: user.id, autorizacionFecha: moment().format("YYYY-MM-DD") }
            : { autorizacionUser: null, autorizacionFecha: "" }),
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      setComments((prev) =>
        (prev || []).map((i) =>
          i._id === a._id
            ? {
                ...i,
                autorizacion: autorizar ? "Si" : "No",
                autorizacionUser: autorizar ? user.nombre || user.name || "" : "",
                autorizacionFecha: autorizar ? moment().format("YYYY-MM-DD") : "",
              }
            : i
        )
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: autorizar ? "Orden autorizada" : "Autorización retirada",
        showConfirmButton: false,
        timer: 1200,
      });
    } catch (error) {
      const d = error?.response?.data;
      Swal.fire(
        "Error",
        typeof d === "string"
          ? d
          : d?.message || JSON.stringify(d || {}) || "No se pudo actualizar",
        "error"
      );
    }
  }

  function autorizacionMolde(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como autorizacion molde!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              autorizacionMolde: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.autorizacionMolde = "Si";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Cerró",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function noAutorizacionMolde(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como no autorizacion molde!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              autorizacionMolde: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.autorizacionMolde = "No";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Abrió",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  // L110 (2026-06) — carga (o recarga) las filas del modal Editar para una orden
  async function cargarArticulosEdit(id) {
    const { data: allArticulos } = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    const array = allArticulos.map((a) => ({
      _id: a._id,
      cantidad: a.cantidad,
      cortado: a.cortado,
      pendiente_cortar: a.pendiente_cortar,
      articulo: a.articulos[0].codigo + " " + a.articulos[0].descripcion,
      idArticulo: a.articulos[0]._id,
      color: a.colores[0].name,
      idColor: a.colores[0]._id,
      talla:
        a.tallas[0].name +
        (a.tallas[0].variantesTallas?.[0]?.name
          ? " " + a.tallas[0].variantesTallas[0].name
          : ""),
      idTalla: a.tallas[0]._id,
      // L110 — área y pedido para heredar al agregar nuevas combinaciones
      idArea: a.areasClientes?.[0]?._id || a.areasClientes?.[0] || "",
      idPedido: a.pedidos?.[0]?._id || a.pedidos?.[0] || "",
    }));
    setArticulosEdit(array);
    const TM = array.reduce((t, c) => t + parseFloat(c.cantidad || 0), 0);
    setTotalPiezas(TM);
    return array;
  }

  async function jalaEdit(id, numero) {
    // (2026-08) Candado: si la orden ya está autorizada no se tocan los artículos
    const orden = (comments || []).find((x) => x._id === id);
    if (estaAutorizada(orden)) {
      return Swal.fire(
        "Orden autorizada",
        "No se pueden modificar los artículos de una orden autorizada.",
        "warning"
      );
    }
    setIdEdit(id);
    // L110 — limpiar formulario de "agregar"
    setAgregarArticulo("");
    setAgregarTallas([]);
    setAgregarColores([]);
    setAgregarTalla("");
    setAgregarColor("");
    setAgregarCantidad("");
    try {
      await cargarTodosColores(); // L110-fix — todos los colores del catálogo
      const array = await cargarArticulosEdit(id);
      // Si solo hay un artículo en la orden, preseleccionarlo y cargar su catálogo
      const unicos = [...new Set(array.map((r) => r.idArticulo))];
      if (unicos.length === 1) {
        await cargaCatalogoArticuloAgregar(unicos[0]);
      }
      toggleEdit();
    } catch (err) {
      console.log(err);
    }
  }

  // L110 — al elegir artículo, traer su catálogo de tallas y colores
  async function cargaCatalogoArticuloAgregar(idArticulo) {
    setAgregarArticulo(idArticulo);
    setAgregarTalla("");
    setAgregarColor("");
    if (!idArticulo) {
      setAgregarTallas([]);
      // no limpiar colores: el catálogo completo se mantiene (L110-fix)
      return;
    }
    try {
      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };
      const { data } = await axios.get(`${URL_ARTICULOS}/${idArticulo}`, {
        headers,
      });
      const tallasArticulo = Array.isArray(data?.tallas) ? data.tallas : [];

      // (2026-07) También ofrecer las VARIANTES de esas tallas. En el catálogo global
      // existen por separado la talla base (ej. "35") y la que trae variante (ej.
      // "35 LP -1"). El artículo tiene asignadas las base, así que agregamos sus
      // hermanas con variante (mismo nombre base) para poder elegir la variante.
      let catalogoTallas = [];
      try {
        const resCat = await axios.get(URL_TALLAS, { headers });
        catalogoTallas = Array.isArray(resCat.data) ? resCat.data : [];
      } catch (eCat) {
        console.log("No se pudo cargar catálogo de tallas:", eCat);
      }

      const norm = (x) => String(x || "").trim().toUpperCase();
      const nombresArticulo = new Set(tallasArticulo.map((t) => norm(t.name)));
      const variantesDeEsasTallas = catalogoTallas.filter(
        (t) =>
          nombresArticulo.has(norm(t.name)) &&
          Array.isArray(t.variantesTallas) &&
          t.variantesTallas.length > 0
      );

      // merge (base del artículo + variantes) sin duplicar por _id
      const porId = new Map();
      [...tallasArticulo, ...variantesDeEsasTallas].forEach((t) => {
        if (t && t._id) porId.set(String(t._id), t);
      });
      const merged = [...porId.values()];

      // ordenar: por nombre de talla y, dentro del mismo, base antes que variante
      merged.sort((a, b) => {
        const na = norm(a.name);
        const nb = norm(b.name);
        if (na !== nb)
          return na.localeCompare(nb, "es", { numeric: true, sensitivity: "base" });
        const va = a.variantesTallas?.[0]?.name || "";
        const vb = b.variantesTallas?.[0]?.name || "";
        return va.localeCompare(vb, "es", { sensitivity: "base" });
      });

      setAgregarTallas(merged);
    } catch (e) {
      console.log(e);
    }
  }

  // L110-fix — cargar TODO el catálogo de colores (no solo los del artículo)
  async function cargarTodosColores() {
    try {
      const { data } = await axios.get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      const colores = Array.isArray(data) ? [...data] : [];
      // L110-fix — ordenar colores alfabéticamente
      colores.sort((a, b) =>
        (a?.name || "").localeCompare(b?.name || "", "es", {
          sensitivity: "base",
        })
      );
      setAgregarColores(colores);
    } catch (e) {
      console.log(e);
    }
  }

  // (2026-10) Cambiar el color de una línea de la orden. El back también pasa
  // esas piezas al color nuevo en el pedido, para que la línea siga con su
  // renglón del pedido (se encuentran por pedido + artículo + área + color + talla).
  async function cambiaColorEdit(fila, idColorNuevo) {
    if (!idColorNuevo || String(idColorNuevo) === String(fila.idColor)) return;
    const nuevo = agregarColores.find((c) => String(c._id) === String(idColorNuevo));
    const res = await Swal.fire({
      title: "¿Cambiar el color?",
      html: `${fila.articulo} · talla ${fila.talla} · ${fila.cantidad} pzs<br/><b>${fila.color}</b> → <b>${
        nuevo?.name || ""
      }</b><br/><small>También se cambia en el pedido.</small>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "No",
    });
    if (!res.isConfirmed) return;
    try {
      await axios.patch(
        `${URL_ARTICULOS_ORDENES_CORTE}/color/${fila._id}`,
        { colores: idColorNuevo },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      await cargarArticulosEdit(idEdit);
      Swal.fire({
        icon: "success",
        title: "Color cambiado",
        text: "Se cambió en la orden y en el pedido.",
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (err) {
      console.log(err);
      Swal.fire(
        "No se pudo cambiar",
        err?.response?.data?.message || "Intenta de nuevo",
        "error"
      );
    }
  }

  // L110 — agregar una combinación talla/color del mismo artículo a la orden
  async function agregarTallaColorEdit() {
    const cant = parseFloat(agregarCantidad);
    if (!agregarArticulo || !agregarTalla || !agregarColor || !(cant > 0)) {
      Swal.fire(
        "Faltan datos",
        "Selecciona artículo, talla, color y una cantidad mayor a 0.",
        "warning"
      );
      return;
    }
    // Heredar área y pedido de una fila existente del mismo artículo
    const base = articulosEdit.find(
      (r) => String(r.idArticulo) === String(agregarArticulo)
    );
    if (!base || !base.idArea || !base.idPedido) {
      Swal.fire(
        "Error",
        "No se pudo heredar el área/pedido del artículo.",
        "error"
      );
      return;
    }
    // Evitar duplicar una combinación que ya existe
    const dup = articulosEdit.some(
      (r) =>
        String(r.idArticulo) === String(agregarArticulo) &&
        String(r.idTalla) === String(agregarTalla) &&
        String(r.idColor) === String(agregarColor)
    );
    if (dup) {
      Swal.fire(
        "Ya existe",
        "Esa combinación talla/color ya está en la orden. Edita su cantidad arriba.",
        "warning"
      );
      return;
    }
    try {
      await axios.post(
        URL_ARTICULOS_ORDENES_CORTE,
        {
          ordenesCorte: idEdit,
          pedidos: base.idPedido,
          articulos: agregarArticulo,
          colores: agregarColor,
          tallas: agregarTalla,
          areasClientes: base.idArea,
          cantidad: cant,
          cortado: 0,
          pendiente_cortar: cant,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // Recalcular totales del header de la orden
      await axios.patch(
        `${URL_ORDENES_CORTE}/${idEdit}/recalcular`,
        {},
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const arr = await cargarArticulosEdit(idEdit);
      // (2026-07) Sin refresh de página: actualizar en vivo la Cantidad de la
      // orden en la tabla principal (columna total_piezas) desde el nuevo total.
      const nuevoTotal = (arr || []).reduce(
        (t, c) => t + parseFloat(c.cantidad || 0),
        0
      );
      setComments((prev) =>
        prev.map((r) =>
          String(r._id) === String(idEdit)
            ? { ...r, total_piezas: nuevoTotal }
            : r
        )
      );
      setAgregarTalla("");
      setAgregarColor("");
      setAgregarCantidad("");
      Swal.fire({
        icon: "success",
        title: "Agregado",
        text: "Talla/color agregado a la orden.",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo agregar la talla/color.",
        footer: `${err?.response?.data?.error || ""}`,
      });
    }
  }

  // L110 — artículos únicos de la orden (para que solo se puedan agregar tallas/colores
  // de un artículo que YA está en la orden, no uno nuevo)
  const articulosUnicosEdit = [
    ...new Map(
      articulosEdit.map((r) => [r.idArticulo, { id: r.idArticulo, nombre: r.articulo }])
    ).values(),
  ];

  const sortedArticulosEdit = [...articulosEdit].sort((a, b) => {
    // Primero ordenar por color
    if (a.color > b.color) return 1;
    if (a.color < b.color) return -1;

    // Si los color son iguales, ordenar por el orden de tallas
    const indexA = ordenTallas.indexOf(a.talla);
    const indexB = ordenTallas.indexOf(b.talla);

    // Si ambas tallas están en el orden definido
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // Si alguna talla no está en el orden definido, ponerla al final
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return 0;
  });

  const handleChangeInputCantidadEdit = (id, event) => {
    const newArticulosEdit = articulosEdit.map((i) => {
      if (id === i._id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosEdit(newArticulosEdit);

    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalMts = articulosEdit.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  }

  async function saveEdit() {
    // L66 (2026-06) — Editar primero los detalles, luego llamar al endpoint
    // /recalcular para que cantidad y articulos del header queden alineados
    // con los ArticulosOrdenesCorte reales.
    try {
      await Promise.all(
        articulosEdit.map((a) =>
          axios.patch(
            `${URL_ARTICULOS_ORDENES_CORTE}/${a._id}`,
            { cantidad: a.cantidad,
              pendiente_cortar: a.cantidad - (a.cortado || 0)
             },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        )
      );

      await axios.patch(
        `${URL_ORDENES_CORTE}/${idEdit}/recalcular`,
        {},
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      Swal.fire("Good job!", "Creado con exito", "success");
      // (2026-10) sin reload: cerrar Editar y refrescar listado + KPIs
      // (cantidad de la orden y piezas por cortar)
      setModalEdit(false);
      setValidaBoton(true);
      refrescarDatos();
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo guardar el corte.",
      });
    }
  }

  function jalaHabilitacion(id, idArticulo, idPedido, idCorte) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);

    axios
      .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: uuidv4(),
              idHabilitacion: a.habilitacion[0]._id,
              // nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
              // cantidadAnterior: a.cantidad,
              cantidad: 0,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setInputFieldsHabilitacion(data);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleHabilitacion();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    // (2026-10) sin reload: cerrar el modal, limpiar la fecha y refrescar
    const terminaHabilitacion = () => {
      setModalHabilitacion(false);
      setValidaBoton(true);
      setFechaHab("");
      refrescarDatos();
    };
    axios
      .post(
        URL_HABILITACION_ORDENES_CORTES,
        {
          ordenesCorte: idCorteHab,
          pedidos: idPedidoHab,
          fecha: fechaHab,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_ORDENES_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionOrdenesCortes: data2.data._id,
                  ordenesCorte: idCorteHab,
                  pedidos: idPedidoHab,
                  habilitacion: a.idHabilitacion,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      terminaHabilitacion();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token",
                      )}`,
                    },
                  },
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  terminaHabilitacion();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  const handleChangeInputHabilitacion = (id, event) => {
    const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHabilitacion(newInputFieldsHabilitacion);
  };

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
  };

  function jalaHabilitacionEdit(id) {
    axios
      .get(`${URL_DETALLE_HABILITACION_ORDENES_CORTES}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              idHabilitacion: a.habilitacion[0]._id,
              nombre:
                a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
              cantidadAnterior: a.cantidad,
              cantidad: a.cantidad,
              observaciones: a.habilitacionOrdenesCortes[0].observaciones,
            };
          })
          .filter((el) => el != null);

        const data = Object.values(arrayTabla);
        setEditHab(data);

        if (data.length > 0) {
          setObservacionesHab(data[0].observaciones);
        }

        toggleEditHab();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
    // (2026-10) sin reload: cerrar el modal y refrescar
    const terminaHabilitacionEdit = () => {
      setModalEditHab(false);
      setValidaBoton(true);
      refrescarDatos();
    };
    editHab.map((a) => {
      axios
        .patch(
          `${URL_DETALLE_HABILITACION_ORDENES_CORTES}/${a.id}`,
          {
            habilitacion: a.idHabilitacion,
            cantidad: a.cantidad,
            cantidadAnterior: a.cantidadAnterior,
            observaciones: observacionesHab,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          },
        )
        .then(() => {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Editar Salida de Habilitacion",
                  detalle: `Pedido`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                terminaHabilitacionEdit();
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        });
    });
  }

  async function PDFOCHab(
    numero,
    cliente,
    fecha,
    pedido,
    idPedidos,
    articuloCodigo,
    articuloDescripcion,
    idArticulo,
    totalPiezas,
    observaciones,
    idPDFOC,
  ) {
    const getImageAsDataURL = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png"));
          } catch (e) {
            reject(e);
          }
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    try {
      const { data: allArticulosOrdenCorte } = await axios.get(
        `${URL_ARTICULOS_ORDENES_CORTE}/orden/${idPDFOC}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );

      // L127 (2026-07) — Datos fiscales de la empresa propia (replica de ListadoPedidos).
      // La empresa viene poblada en el pedido: pedidos[0].empresas[0].
      // NOTA: requiere que el backend popule pedidos.empresas (ver resumen).
      const sHab = (x) => String(x || "").trim();
      const empresa =
        (allArticulosOrdenCorte || []).find(
          (x) => x?.pedidos?.[0]?.empresas?.[0]
        )?.pedidos?.[0]?.empresas?.[0] || null;

      // === L51 (2026-06) — Formato corporativo (portrait) ===
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 14;
      const marginRight = 14;

      const brandColor = [42, 90, 138];
      const lightBg = [245, 247, 250];
      const borderColor = [210, 216, 224];
      const labelColor = [110, 120, 135];
      const stripeBg = [251, 252, 253];

      const drawLabel = (label, value, lblX, valX, y) => {
        doc.setFont(undefined, "bold");
        doc.setTextColor(...labelColor);
        doc.setFontSize(8);
        doc.text(label, lblX, y);
        doc.setFont(undefined, "normal");
        doc.setTextColor(0);
        doc.setFontSize(9);
        const txt = String(value ?? "").trim();
        doc.text(txt || "—", valX, y);
      };

      // Logo izq
      const logo = new Image();
      logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      await new Promise((resolve) => {
        logo.onload = () => {
          const maxH = 14;
          const scale = maxH / logo.height;
          doc.addImage(logo, "png", marginLeft, 8, logo.width * scale, maxH);
          resolve();
        };
        logo.onerror = () => resolve();
      });

      // Título der + línea azul
      doc.setFont(undefined, "bold");
      doc.setFontSize(14);
      doc.setTextColor(...brandColor);
      doc.text(`ORDEN PRODUCCIÓN # ${numero}`, pageWidth - marginRight, 16, { align: "right" });
      doc.setTextColor(0);

      // L127 (2026-07) — Datos fiscales de la empresa propia, debajo del folio
      if (empresa) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(8.5);
        doc.setTextColor(60, 60, 60);
        doc.text(
          sHab(empresa.razonSocial) || sHab(empresa.name) || "",
          pageWidth - marginRight,
          21,
          { align: "right" }
        );
        doc.setFont(undefined, "normal");
        doc.setFontSize(7.5);
        doc.setTextColor(...labelColor);
        const fiscalLine = [
          empresa.rfc ? `RFC: ${sHab(empresa.rfc)}` : "",
          empresa.regimenFiscal ? `Rég. Fiscal: ${sHab(empresa.regimenFiscal)}` : "",
        ]
          .filter((x) => x)
          .join("   ·   ");
        if (fiscalLine) {
          doc.text(fiscalLine, pageWidth - marginRight, 25, { align: "right" });
        }
        const direccionStr = [
          sHab(empresa.direccionFiscal),
          empresa.cp ? `C.P. ${sHab(empresa.cp)}` : "",
        ]
          .filter((x) => x)
          .join(", ");
        if (direccionStr) {
          const dirAvailW = pageWidth - marginRight - (marginLeft + 45);
          const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
          dirLines.forEach((line, i) => {
            doc.text(line, pageWidth - marginRight, 29 + i * 3.6, { align: "right" });
          });
        }
        doc.setTextColor(0);
      }

      // Línea azul (corro abajo si hay empresa para no encimar)
      const headerLineY = empresa ? 38 : 25;
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.5);
      doc.line(marginLeft, headerLineY, pageWidth - marginRight, headerLineY);
      doc.setLineWidth(0.2);
      doc.setDrawColor(0);

      // Card 2 cols
      const cardY = headerLineY + 3;
      const cardW = pageWidth - marginLeft - marginRight;
      const cardH = 28;
      doc.setDrawColor(...borderColor);
      doc.setFillColor(...lightBg);
      doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const lblX_L = marginLeft + 2;
      const valX_L = marginLeft + 24;
      const baseY = cardY + 6;
      drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
      drawLabel("Cliente:", cliente, lblX_L, valX_L, baseY + 5);
      drawLabel("Pedido:", pedido, lblX_L, valX_L, baseY + 10);
      drawLabel("Total Piezas:", totalPiezas, lblX_L, valX_L, baseY + 15);

      const colRightX = pageWidth / 2 + 5;
      const lblX_R = colRightX;
      const valX_R = colRightX + 28;
      drawLabel("Modelo:", `${articuloCodigo} ${articuloDescripcion}`.trim(), lblX_R, valX_R, baseY);
      drawLabel("Obs:", observaciones, lblX_R, valX_R, baseY + 5);

      let currentY = cardY + cardH + 6;

      const grupoPorSucursalAreaArticulo = {};
      allArticulosOrdenCorte.forEach((a) => {
        const sucursal = a.sucursales?.[0]?.alias || "Sin Sucursal";
        const area = a.areasClientes?.[0]?.name || "Sin Área";
        const articulo = a.articulos?.[0]?.descripcion || "Sin Artículo";
        const clave = `${sucursal}||${area}||${articulo}`;
        if (!grupoPorSucursalAreaArticulo[clave])
          grupoPorSucursalAreaArticulo[clave] = [];
        grupoPorSucursalAreaArticulo[clave].push(a);
      });

      for (const clave in grupoPorSucursalAreaArticulo) {
        const grupo = grupoPorSucursalAreaArticulo[clave];
        const [sucursal, area, articulo] = clave.split("||");

        // L51 (2026-06) — Banda azul como header del grupo
        const bandH = 8;
        doc.setFillColor(...brandColor);
        doc.rect(marginLeft, currentY, cardW, bandH, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        doc.text(
          `${sucursal}   ·   Área: ${area}   ·   Modelo: ${articulo}`,
          marginLeft + 3,
          currentY + bandH - 2.5
        );
        doc.setTextColor(0);
        doc.setFont(undefined, "normal");
        currentY += bandH + 3;

        const agrupadoPorColor = {};
        const tallasSet = new Set();

        // L78 (2026-06) — ignorar combos con cantidad 0
        grupo.filter((x) => Number(x?.cantidad || 0) > 0).forEach((a) => {
          const color = a.colores?.[0]?.name || "Sin Color";
          const talla = a.tallas?.[0]?.name?.trim() || "Sin Talla";
          const variante =
            a.tallas?.[0]?.variantesTallas[0]?.name?.trim() || "";
          const key = talla;
          const detalle = variante ? `(${variante})` : "";

          if (!agrupadoPorColor[color]) agrupadoPorColor[color] = {};
          if (!agrupadoPorColor[color][key]) agrupadoPorColor[color][key] = [];
          agrupadoPorColor[color][key].push({ cantidad: a.cantidad, detalle });
          tallasSet.add(key);
        });

        const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
        const tallas = Array.from(tallasSet).sort((a, b) => {
          const indexA = ordenTallas.indexOf(a);
          const indexB = ordenTallas.indexOf(b);
          return (
            (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
          );
        });

        const head = [["Color", ...tallas, "Total"]];
        const body = [];

        for (const color of Object.keys(agrupadoPorColor)) {
          let totalColor = 0;
          const row = [color];
          for (const talla of tallas) {
            const celdas = agrupadoPorColor[color][talla] || [];
            let celdaTexto = "";
            let subtotal = 0;
            celdas.forEach(({ cantidad, detalle }) => {
              celdaTexto += `${cantidad} ${detalle}\n`;
              subtotal += cantidad;
            });
            row.push(celdaTexto.trim());
            totalColor += subtotal;
          }
          row.push(totalColor);
          body.push(row);
        }

        doc.autoTable({
          head,
          body,
          startY: currentY,
          margin: { left: marginLeft, right: marginRight },
          // L51 (2026-06) — tabla profesional con zebra + brand color
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            cellWidth: "wrap",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
        });

        currentY = doc.autoTable.previous.finalY + 8;

        // Mostrar bordados agrupados por articuloPedido (no repetidos por talla/color)
        const bordadosMap = new Map();

        grupo.forEach((a) => {
          const ap = a.articulosPedido?.[0];
          if (
            ap &&
            ap._id &&
            ap.bordados?.length > 0 &&
            !bordadosMap.has(ap._id)
          ) {
            bordadosMap.set(ap._id, ap.bordados);
          }
        });

        // Mostrar bordados una sola vez por grupo (no repetir por talla/color)
        const primer = grupo.find(
          (a) => a.articulosPedido?.[0]?.bordados?.length > 0,
        );
        const bordados = primer?.articulosPedido?.[0]?.bordados || [];

        if (bordados.length) {
          doc.setFont(undefined, "bold");
          doc.setFontSize(10);
          doc.text("Bordados:", 20, currentY);
          currentY += 5;

          let currentX = 20;
          let maxYInRow = 0;
          const imageMargin = 5;
          // x3: bordados 3 veces más grandes (2026-06)
          const maxImageHeight = 10 * 3;
          const maxImageWidth = 15 * 3;

          for (const b of bordados) {
            try {
              const url = `https://res.cloudinary.com/lynqro/image/upload/${b.public_id}`;
              const dataUrl = await getImageAsDataURL(url);

              const img = new Image();
              img.src = dataUrl;
              await new Promise((resolve) => {
                img.onload = () => {
                  const ratio = Math.min(
                    maxImageWidth / img.width,
                    maxImageHeight / img.height,
                  );
                  const imgW = img.width * ratio;
                  const imgH = img.height * ratio;

                  if (currentX + imgW > doc.internal.pageSize.getWidth() - 20) {
                    currentX = 20;
                    currentY += maxYInRow + 15;
                    maxYInRow = 0;
                  }

                  doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);
                  doc.setFont(undefined, "normal");
                  doc.setFontSize(8);
                  doc.text(b.observacion || "", currentX, currentY + imgH + 4, {
                    maxWidth: imgW,
                  });

                  maxYInRow = Math.max(maxYInRow, imgH + 10);
                  currentX += imgW + imageMargin;
                  resolve();
                };
              });
            } catch (err) {
              console.warn("No se pudo cargar bordado:", b.public_id);
            }
          }

          currentY += maxYInRow + 10;
        }

        if (currentY > 270) {
          doc.addPage();
          currentY = 20;
        }
      }

      // ============ FOOTER L51 — paginación ============
      try {
        const pageCount = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pageCount; p++) {
          doc.setPage(p);
          doc.setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(
            `Orden Producción #${numero}  ·  ${cliente}  ·  Página ${p} de ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: "center" }
          );
          doc.setTextColor(0);
        }
      } catch (errFooter) {
        console.warn("No se pudo dibujar footer:", errFooter);
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.error("Error generando PDF:", err);
      Swal.fire("Error", "No se pudo generar el PDF", "error");
    }
  }

  const saveTelasConsumo = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();
      // (2026-10) sin reload: cerrar los modales y refrescar
      const terminaConsumo = () => {
        setModalTelasConsumo(false);
        setModalProgreso(false);
        setValidaBoton(true);
        refrescarDatos();
      };

      let totalRollos = inputFieldsAnteriorConsumo.length;
      try {
        inputFieldsAnteriorConsumo.map((w) => {
          axios
            .patch(
              `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/${w.id}`,
              {
                consumo: w.consumo,
                piezas: w.piezas,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              },
            )
            .then(() => {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Agregar Consumo y Piezas",
                      detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    terminaConsumo();
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };
  function telasCortesConsumo(id, numero) {
    toggleProgreso();
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            id: a._id,
            articulo:
              a.articulos[0].codigo + " / " + a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre:
              a.telas[0].codigo +
              " / " +
              a.telas[0].nombre +
              " / " +
              a.colores[0].name,
            consumo: a.consumo,
            piezas: a.piezas,
          };
        });
        let dataFinal = Object.values(tablaTelas);

        setInputFieldsAnteriorConsumo(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelasConsumo();
      setModalProgreso(false);
    }, 1000);
  }

  const handleChangeInput = (id, event) => {
    const newInventarios = inputFieldsAnteriorConsumo.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFieldsAnteriorConsumo(newInventarios);
    ActualizaTotales();
  };

  async function toggleRecibido(id, recibidosActuales) {
    try {
      const lista = Array.isArray(recibidosActuales) ? recibidosActuales : [];
      const yaMarcado = lista.some(
        (r) => String(r.userId || "") === String(user.id)
      );
      const hoy = moment().format("YYYY-MM-DD HH:mm");

      let nuevosRecibidos;
      if (yaMarcado) {
        // Quitar SOLO el del user actual
        nuevosRecibidos = lista
          .filter((r) => String(r.userId || "") !== String(user.id))
          .map((r) => ({ user: r.userId, fecha: r.fecha || "" }));
      } else {
        // Agregar al user actual
        nuevosRecibidos = [
          ...lista.map((r) => ({ user: r.userId, fecha: r.fecha || "" })),
          { user: user.id, fecha: hoy },
        ];
      }

      await axios.patch(
        `${URL_ORDENES_CORTE}/${id}`,
        { recibidos: nuevosRecibidos },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: yaMarcado ? "Quitar Recibido OP" : "Recibir Orden Produccion",
          detalle: `Orden ${id}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // L38 (2026-06) — actualizar state local en vez de hacer reload completo
      setComments((prev) =>
        prev.map((c) => {
          if (String(c._id) !== String(id)) return c;
          const updatedRecibidos = nuevosRecibidos.map((r) => {
            const existente = (c.recibidos || []).find(
              (x) => String(x.userId) === String(r.user)
            );
            if (existente) return { ...existente, fecha: r.fecha };
            if (String(r.user) === String(user.id)) {
              return {
                userId: String(user.id),
                nombre: `${user.nombre || ""} ${user.apellido || ""}`.trim(),
                fecha: r.fecha,
              };
            }
            return { userId: String(r.user), nombre: "", fecha: r.fecha };
          });
          return {
            ...c,
            recibidos: updatedRecibidos,
            recibido: updatedRecibidos.length > 0 ? "Si" : "No",
          };
        })
      );

      Swal.fire({
        icon: "success",
        title: yaMarcado ? "Quitaste tu recibido" : "Marcado como recibido",
        timer: 1000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al actualizar recibido:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar el recibido.",
      });
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.menu_produccion ? (
                <>
                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/OrdenesCorteCreate"
                  >
                    Nueva Orden
                  </Button>
                  {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteExternoCreate"
                >
                  Nueva Compra
                </Button> */}
                </>
              ) : (
                <>
                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    Nueva Orden
                  </Button>
                  {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteExternoCreate"
                >
                  Nueva Compra
                </Button> */}
                </>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {user.ocp_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.ocp_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.ocp_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Produccion</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Produccion</h3>

          {/* (2026-08) Indicadores de trabajo pendiente, en panel compacto.
              Van sobre todo lo activo, no sobre el rango de fechas del listado. */}
          <div
            className="mb-3"
            style={{
              display: "inline-block",
              background: "#fff",
              border: "1px solid #e6e8ec",
              borderRadius: 12,
              boxShadow: "0 2px 10px rgba(16,24,40,.08)",
              padding: "14px 16px",
            }}
          >
            <div
              style={{
                fontWeight: 700,
                fontSize: 17,
                color: "#1f2937",
                marginBottom: 10,
              }}
            >
              KPIs de Producción
            </div>

            {/* (2026-09) Tres recuadros: total de prendas activas (= por cortar +
                en proceso de confección), por cortar y en proceso de confección */}
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "stretch" }}>
              {(() => {
                const porCortar = Number(kpis.piezasPendientesCortar || 0);
                const enProceso = Number(kpis.piezasCortadasSinRecibir || 0);
                const fmt = (n) => new Intl.NumberFormat("en-US").format(n);
                return [
                  {
                    etiqueta: "Total de Prendas Activas",
                    valor: porCortar + enProceso,
                    pie: "",
                    icono: "fas fa-tshirt",
                    fondo: "#E9EBF3",
                    borde: "#C9CEE0",
                    color: "#4b5563",
                    grande: true,
                  },
                  {
                    etiqueta: "Por Cortar",
                    valor: porCortar,
                    pie: `${kpis.ordenesPendientes || 0} órdenes sin cortar`,
                    grafica: "porCortar",
                    icono: "fas fa-cut",
                    fondo: "#FDF6E3",
                    borde: "#F0E2B6",
                    color: "#8a6d1f",
                  },
                  {
                    etiqueta: "En Proceso de Confección",
                    valor: enProceso,
                    pie: "",
                    grafica: "enProceso",
                    icono: "fas fa-sync-alt",
                    fondo: "#F3E9C9",
                    borde: "#E2CF95",
                    color: "#8a6d1f",
                  },
                ].map((k) =>
                  k.grande ? (
                    <div
                      key={k.etiqueta}
                      style={{
                        background: k.fondo,
                        border: `1px solid ${k.borde}`,
                        borderRadius: 10,
                        padding: "12px 22px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 300,
                      }}
                    >
                      <i
                        className={k.icono}
                        style={{ fontSize: 22, color: k.color, opacity: 0.8, marginBottom: 4 }}
                      ></i>
                      <div style={{ fontSize: 17, fontWeight: 700, color: "#1f2937" }}>
                        {k.etiqueta}
                      </div>
                      <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
                        <span style={{ fontSize: 30, fontWeight: 800, color: "#111827" }}>
                          {fmt(k.valor)}
                        </span>
                        <span style={{ fontSize: 13, color: "#4b5563" }}>pzs</span>
                      </div>
                    </div>
                  ) : (
                    // (2026-10) al picarle se abre su gráfica en un modal
                    <div
                      key={k.etiqueta}
                      role="button"
                      tabIndex={0}
                      title="Ver gráfica"
                      onClick={() => abrirGraficaKpi(k.grafica)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          abrirGraficaKpi(k.grafica);
                        }
                      }}
                      style={{
                        background: k.fondo,
                        border: `1px solid ${k.borde}`,
                        borderRadius: 10,
                        padding: "12px 18px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 240,
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}>
                        {k.etiqueta}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <i
                          className={k.icono}
                          style={{ fontSize: 24, color: k.color, opacity: 0.85 }}
                        ></i>
                        <span style={{ fontSize: 30, fontWeight: 800, color: "#111827" }}>
                          {fmt(k.valor)}
                        </span>
                        <span style={{ fontSize: 13, color: "#4b5563" }}>pzs</span>
                      </div>
                      {k.pie ? (
                        <div style={{ fontSize: 12, color: "#4b5563" }}>{k.pie}</div>
                      ) : null}
                      <div style={{ fontSize: 11.5, color: "#2a78d6", marginTop: 2 }}>
                        <i className="fas fa-chart-bar" style={{ marginRight: 4 }}></i>
                        Ver gráfica
                      </div>
                    </div>
                  )
                );
              })()}
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <div className="table-wrapper">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <TableHeader
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      })}
                  </Input>
                </td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedArticulo}
                    onChange={(e) => {
                      setSelectedArticulo(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) =>
                        (a.codigo || "") >
                        (b.codigo || "")
                          ? 1
                          : -1,
                      )
                      .map((a) => {
                        return (
                          // TF8 — solo subdepartamento (línea) y código
                          <option value={a._id}>
                            {(a.codigo || "") +
                             " / " +
                              (a.subDepartamentos?.[0]?.name || "")}
                          </option>
                        );
                      })}
                  </Input>
                </td>

                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCortado}
                    onChange={(e) => {
                      setSelectedCortado(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedAutorizacionMolde}
                    onChange={(e) => {
                      setSelectedAutorizacionMolde(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </td>
                {/* Acciones */}
                <td></td>
                {/* Tela */}
                <td></td>
                <td></td>
                {/* L121 — filtro Recibido */}
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedRecibido}
                    onChange={(e) => {
                      setSelectedRecibido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Todos</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </td>
              </tr>

              <tbody>
                {commentsData.map((a) => {
                  {
                    return (
                      <tr
                        style={
                          a.is_active == "No"
                            ? { backgroundColor: "#ed8c8c" }
                            // : a.pedidoEditado == "Si"
                            //   ? { backgroundColor: "#ffff00" }
                              : undefined
                        }
                      >
                        <td>{a.numero}</td>
                        <td>{a.numeroInterno}</td>
                        <td>{a.fecha}</td>
                        <td>{a.cliente}</td>
                        <td>{modeloConLinea(a)}</td>
                        <td>{a.marca}</td>
                        <td>{a.monarch}</td>
                        <td>{a.statusTela}</td>
                        <td>{a.observacionesStatusTela}</td>
                        <td>{a.observaciones}</td>
                        <td>{a.fechaCancelacion}</td>
                        <td>{a.total_piezas}</td>
                        {/* (2026-08) el tooltip muestra las áreas del pedido, que
                            ahora también se pueden buscar en el search */}
                        <td title={areasPorPedido[a.idPedidos] || ""}>
                          {a.pedido}
                        </td>
                        <td>{a.cortado}</td>
                        <td>{a.autorizacionMolde}</td>
                        <td
                          title={
                            a.autorizacion === "Si" && a.autorizacionUser
                              ? `Autorizó ${a.autorizacionUser} ${a.autorizacionFecha}`
                              : ""
                          }
                        >
                          {a.autorizacion === "Si" ? (
                            <span className="badge bg-success">Autorizada</span>
                          ) : (
                            <span className="badge bg-secondary">No</span>
                          )}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <>
                              {/* {user.ocp_pdf && (
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={async (e) => {
                                  // L27 (2026-06) — preguntar si va resumido (junta áreas) o detallado
                                  const r = await Swal.fire({
                                    title: "¿PDF resumido?",
                                    text: "Sí = junta cantidades por talla y color de todas las áreas. No = sale detallado por área.",
                                    icon: "question",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, resumido",
                                    cancelButtonText: "No, detallado",
                                    reverseButtons: true,
                                  });
                                  if (!r.isConfirmed && r.dismiss !== Swal.DismissReason.cancel) return;
                                  const resumido = r.isConfirmed === true;
                                  PDFOC(
                                    a.numero,
                                    a.cliente,
                                    a.fecha,
                                    a.fechaCancelacion,
                                    a.pedido,
                                    a.idPedidos,
                                    a.articuloCodigo,
                                    a.articuloDescripcion,
                                    a.idArticulo,
                                    a.total_piezas,
                                    a.observaciones,
                                    a._id,
                                    a.marca,
                                    a.monarch,
                                    resumido,
                                    // L43 (2026-06) — vendedor del pedido
                                    a.nombreFirma,
                                    // L97 (2026-06) — número interno
                                    a.numeroInterno
                                  );
                                }}
                              >
                                <i class="far fa-file-pdf"></i>
                              </Button>
                              )} */}
                              {/* (2026-08) PDFOC azul anterior — se deja comentado,
                                  ahora se usa la Orden de Producción de abajo
                              {user.ocp_pdfNumInt && (
                              <Button
  color="info"
  id="PDFNumeroInterno"
  size="sm"
  onClick={async () => {
    // L27 (2026-06) — mismo prompt para el PDF número interno
    const r = await Swal.fire({
      title: "¿PDF resumido?",
      text: "Sí = junta cantidades por talla y color de todas las áreas. No = sale detallado por área.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, resumido",
      cancelButtonText: "No, detallado",
      reverseButtons: true,
    });
    if (!r.isConfirmed && r.dismiss !== Swal.DismissReason.cancel) return;
    PDFOCNumeroInterno(a, r.isConfirmed === true);
  }}
  title="PDF número interno"
>
  <i className="far fa-file-pdf"></i>
</Button>
                              )} */}
                              {/* (2026-08) Orden de Producción con el formato del cliente */}
                              {user.ocp_pdfNumInt && (
                                <Button
                                  color="dark"
                                  id="PDFOrdenProduccion"
                                  size="sm"
                                  onClick={() => PDFOrdenProduccion(a)}
                                  title="Orden de Producción"
                                >
                                  <i className="far fa-file-pdf"></i>
                                </Button>
                              )}
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) => requisicion(a._id, a.numero)}
                              >
                                <i class="fas fa-tag"></i>
                              </Button>
                              {/* (2026-08) Autorizada => no se editan los artículos */}
                              {user.ocp_editar && !estaAutorizada(a) && (
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) => jalaEdit(a._id, a.numero)}
                              >
                                <i class="fas fa-cart-plus"></i>
                              </Button>
                              )}

                              {user.ocp_autorizar && (
                                <Button
                                  color={estaAutorizada(a) ? "success" : "secondary"}
                                  size="sm"
                                  title={
                                    estaAutorizada(a)
                                      ? `Autorizada${
                                          a.autorizacionUser
                                            ? ` por ${a.autorizacionUser} ${a.autorizacionFecha}`
                                            : ""
                                        } — clic para quitar`
                                      : "Autorizar orden (bloquea editar artículos)"
                                  }
                                  onClick={(e) => toggleAutorizacion(a)}
                                >
                                  <i
                                    className={
                                      estaAutorizada(a)
                                        ? "fas fa-lock"
                                        : "fas fa-lock-open"
                                    }
                                  ></i>
                                </Button>
                              )}

                              {user.ocp_observaciones && (
                              <Button
                                size="sm"
                                className="btn"
                                color="info"
                                onClick={(e) =>
                                  editOrden(a._id, a.observaciones, a.numeroInterno, a.subArea, a)
                                }
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                              )}

                              {user.ocp_cortar && (a.cortado == "No" ? (
                                <span>
                                  <Button
                                    color="primary"
                                    id="Cerrar"
                                    onClick={(e) => cortado(a._id)}
                                    size="sm"
                                  >
                                    <i class="fas fa-cut"></i>
                                  </Button>
                                </span>
                              ) : (
                                <span>
                                  <Button
                                    color="danger"
                                    onClick={(e) => noCortado(a._id)}
                                    size="sm"
                                  >
                                    <i class="fas fa-cut"></i>
                                  </Button>
                                </span>
                              ))}

                              {user.ocp_autMolde && (a.autorizacionMolde == "No" ? (
                                <span>
                                  <Button
                                    color="danger"
                                    id="Cerrar"
                                    onClick={(e) => autorizacionMolde(a._id)}
                                    size="sm"
                                  >
                                    <i class="fas fa-shirt"></i>
                                  </Button>
                                </span>
                              ) : (
                                <span>
                                  <Button
                                    color="primary"
                                    onClick={(e) => noAutorizacionMolde(a._id)}
                                    size="sm"
                                  >
                                    <i class="fas fa-shirt"></i>
                                  </Button>
                                </span>
                              ))}
                              <BajaMultiple
                                idStatus={a._id}
                                is_active={a.is_active}
                                URL_BAJA={
                                  process.env.REACT_APP_URL_ORDENES_CORTE
                                }
                                hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE}/baja`}
                                onDone={() => refrescarDatos()}
                              />
                            </>
                          ) : (
                            <BajaMultiple
                              idStatus={a._id}
                              is_active={a.is_active}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_CORTE}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE}/baja`}
                              onDone={() => refrescarDatos()}
                            />
                          )}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <>
                              {/*<Button
                              color="info"
                              id="Telas"
                              size="sm"
                              onClick={(e) =>
                                telasCortesConsumo(a._id, a.numero)
                              }
                            >
                              <i class="fas fa-ruler-combined"></i>
                            </Button>*/}
                              <Button
                                color="info"
                                id="Telas"
                                size="sm"
                                onClick={(e) => telasCortes(a._id, a.numero)}
                              >
                                <i class="fas fa-cart-plus"></i>
                              </Button>
                              <Button
                                color="success"
                                id="TelasDev"
                                size="sm"
                                onClick={(e) => telasCortesDev(a._id, a.numero)}
                              >
                                <i class="fas fa-undo-alt"></i>
                              </Button>
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={(e) =>
                                  PDFTelas(
                                    a.numero,
                                    a.fecha,
                                    a.pedido,
                                    a._id,
                                    a.total_piezas,
                                    a.cliente,
                                    a.articulo,
                                    a.observacionesStatusTela,
                                    // , a.patronista
                                  )
                                }
                              >
                                <i class="far fa-file-pdf"></i>
                              </Button>

                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={(e) =>
                                  PDFTelasDetalles(
                                    a.numero,
                                    a.fecha,
                                    a.pedido,
                                    a._id,
                                    a.total_piezas,
                                    a.cliente,
                                    a.articulo,
                                    // , a.patronista
                                  )
                                }
                              >
                                <i class="fas fa-tape"></i>
                              </Button>
                            </>
                          ) : undefined}
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              statusEdit(
                                a._id,
                                a.statusTela,
                                a.observacionesStatusTela,
                              )
                            }
                          >
                            <i class="fas fa-edit"></i>
                          </Button>
                        </td>
                        {/* {a.corteExterno == "Si" ? (
                                            <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="success"
                          onClick={(e) =>
                            jalaHabilitacion(
                              a.id,
                              a.idArticulo,
                              a.idPedidos,
                              a._id
                            )
                          }
                        >
                          <i class="fas fa-tag"></i>
                        </Button>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => {
                            jalaHabilitacionEdit(a._id);
                          }}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFOCHab(
                              a.numero,
                                a.cliente,
                                a.fecha,
                                a.pedido,
                                a.idPedidos,
                                a.articuloCodigo,
                                a.articuloDescripcion,
                                a.idArticulo,
                                a.total_piezas,
                                a.observaciones,
                                a._id
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button>
                      </td>
                      ) : (
                        <td></td>)} */}
                      <td style={{ minWidth: 220, whiteSpace: "nowrap" }}>
                        {(() => {
                          const lista = Array.isArray(a.recibidos)
                            ? a.recibidos
                            : [];
                          const yaMarcado = lista.some(
                            (r) => String(r.userId || "") === String(user.id)
                          );
                          return (
                            <Button
                              color={yaMarcado ? "primary" : "danger"}
                              size="sm"
                              title={
                                yaMarcado
                                  ? "Quitar mi recibido"
                                  : "Marcar como recibido"
                              }
                              onClick={() =>
                                toggleRecibido(a._id, a.recibidos)
                              }
                            >
                              <i className="fa-solid fa-check"></i>
                            </Button>
                          );
                        })()}
                        {Array.isArray(a.recibidos) && a.recibidos.length > 0 ? (
                          <div className="mt-1">
                            {a.recibidos.map((r, i) => (
                              <div key={i} style={{ whiteSpace: "nowrap" }}>
                                <span style={{ color: "#000", fontSize: 13 }}>
                                  {r.nombre || "Usuario"}
                                  {r.fecha ? ` (${r.fecha})` : ""}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* (2026-10) Gráfica del recuadro: Por Cortar → por cliente,
          En Proceso de Confección → por taller (la de Procesos Pendientes) */}
      <Modal
        size="xl"
        isOpen={!!graficaKpi}
        toggle={() => setGraficaKpi(null)}
      >
        <ModalHeader toggle={() => setGraficaKpi(null)}>
          {graficaKpi === "porCortar"
            ? "Por Cortar · piezas por cliente"
            : "En Proceso de Confección · prendas por taller"}
        </ModalHeader>
        <ModalBody>
          {cargandoDetalleKpis || !detalleKpis ? (
            <div style={{ textAlign: "center", padding: 48 }}>
              <Spinner color="primary" />
            </div>
          ) : graficaKpi === "porCortar" ? (
            <GraficaPorCortarCliente filas={detalleKpis.porCortar} hoy={endDate} />
          ) : (
            <GraficaPendientesTaller
              filas={detalleKpis.enProceso}
              hoy={endDate}
              subtitulo="De mayor a menor · Sólo el proceso de taller (confección), como el recuadro · Haz clic en un taller para ver sus salidas"
              onSelectTaller={verSalidasTaller}
            />
          )}
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelas} toggle={toggleTelas}>
        <ModalHeader toggle={toggleTelas}>
          <h4>
            Entrega de Tela de la Orden de Produccion {selectedOrdenCorteNumero}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelas}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Responsable
                </Label>
                <Input
                  type="text"
                  placeholder="Responsable"
                  value={responsableTelas}
                  required
                  onChange={(e) => {
                    setResponsableTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {inputFieldsAnterior != "" ? (
              <>
                <Label>Tela Asignada</Label>
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Tela</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Unidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                </Row>

                {inputFieldsAnterior.map((inputFieldAnt) => (
                  <div key={inputFieldAnt.id}>
                    <Row>
                      <Col md={2}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.articulo}
                          disabled
                        />
                      </Col>
                      <Col md={3}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.telaNombre}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.color}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.unidad}
                          disabled
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.cantidad}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            ) : undefined}
            <br />

            <Label>Asignar Tela</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1,
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRollo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputField.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasDev} toggle={toggleTelasDev}>
        <ModalHeader toggle={toggleTelasDev}>
          <h4>
            Devolucion de Tela de la Orden de Produccion{" "}
            {selectedOrdenCorteNumeroDev}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasDev}>
            {/* <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
            {/* <br />

            <Label>Devolver Tela</Label> */}
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad Original</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant a Devolver</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRolloDev(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="tela"
                      type="text"
                      value={inputField.telas}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidadOriginal}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotalesDev} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>Explosion</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Material</th>
              <th>Color</th>
              <th>Cantidad</th>
              <th>Total Cant</th>
            </tr>
            {explosion.map((a) => (
              <tr>
                <td>{a.articulosCodigo}</td>
                <td>{a.material}</td>
                <td>{a.coloresName}</td>
                <td>{a.cantidad}</td>
                <td>{a.cantidadTotal}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Color</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Talla</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
          </Row>
          {sortedArticulosEdit.map((inputField) => (
            <div key={inputField._id}>
              <Row>
                <Col md={3}>
                  <Input
                    // bsSize="sm"
                    name="articulo"
                    type="text"
                    value={inputField.articulo}
                    disabled
                  ></Input>
                </Col>
                <Col md={2}>
                  {/* (2026-10) cambiar el color; el renglón del pedido lo sigue */}
                  <Input
                    // bsSize="sm"
                    name="color"
                    type="select"
                    value={inputField.idColor}
                    disabled={Number(inputField.cortado || 0) > 0}
                    onChange={(e) => cambiaColorEdit(inputField, e.target.value)}
                  >
                    {!agregarColores.some((c) => String(c._id) === String(inputField.idColor)) ? (
                      <option value={inputField.idColor}>{inputField.color}</option>
                    ) : null}
                    {agregarColores.map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="talla"
                    type="text"
                    value={inputField.talla}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="tela"
                    type="text"
                    value={inputField.cantidad}
                    onChange={(event) =>
                      handleChangeInputCantidadEdit(inputField._id, event)
                    }
                  ></Input>
                </Col>
              </Row>
            </div>
          ))}

          {/* L110 — Agregar talla/color del MISMO artículo (no se puede elegir uno nuevo) */}
          <hr />
          <Row>
            <Col md={12}>
              <Label className="mr-sm-2">
                <b>Agregar talla / color (mismo artículo)</b>
              </Label>
            </Col>
          </Row>
          <Row className="align-items-end">
            <Col md={3}>
              <Label className="mr-sm-2">Artículo</Label>
              <Input
                type="select"
                value={agregarArticulo}
                onChange={(e) => cargaCatalogoArticuloAgregar(e.target.value)}
              >
                <option value="">Selecciona</option>
                {articulosUnicosEdit.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.nombre}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Color</Label>
              <Input
                type="select"
                value={agregarColor}
                disabled={!agregarArticulo}
                onChange={(e) => setAgregarColor(e.target.value)}
              >
                <option value="">Selecciona</option>
                {agregarColores.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Talla</Label>
              <Input
                type="select"
                value={agregarTalla}
                disabled={!agregarArticulo}
                onChange={(e) => setAgregarTalla(e.target.value)}
              >
                <option value="">Selecciona</option>
                {agregarTallas.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.name}
                    {t.variantesTallas?.[0]?.name
                      ? " " + t.variantesTallas[0].name
                      : ""}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Cantidad</Label>
              <Input
                type="number"
                min="0"
                value={agregarCantidad}
                onChange={(e) => setAgregarCantidad(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Button
                color="primary"
                size="sm"
                onClick={agregarTallaColorEdit}
                disabled={!agregarArticulo}
              >
                Agregar
              </Button>
            </Col>
          </Row>
          <hr />

          <Row>
            <Col md={5}></Col>
            <Col md={1}>
              <Label>Total Piezas</Label>
            </Col>
            <Col md={1}>
              <Label>{total_piezas}</Label>
            </Col>
          </Row>
          {validaBoton ? (
            <Button
              type="submit"
              className="btn btn-success"
              onClick={saveEdit}
            >
              Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalStatusEdit} toggle={toggleStatusEdit}>
        <ModalHeader toggle={toggleStatusEdit}>
          <h3>Editar Status</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveStatusEdit}>
            <Row>
              <Col md={12}>
                <Label>Status</Label>
                <Input
                  type="select"
                  value={statusTelaEdit}
                  required
                  onChange={(e) => {
                    setStatusTelaEdit(e.target.value);
                  }}
                >
                  <option value="Pendiente">Pendiente</option>
                  <option value="Completo">Completo</option>
                  <option value="Incompleto">Incompleto</option>
                </Input>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="textarea"
                  value={observacionesStatusTelaEdit}
                  required
                  onChange={(e) => {
                    setObservacionesStatusTelaEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row></Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal
        size="sm"
        isOpen={modalObservacionesEdit}
        toggle={toggleObservacionesEdit}
      >
        <ModalHeader toggle={toggleObservacionesEdit}>
          <h3>Editar Orden</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveObservacionesEdit}>
            <Row>
              <Col md={12}>
                <Label>Numero Interno</Label>
                <Input
                  type="text"
                  value={numeroInternoEdit}
                  onChange={(e) => {
                    setNumeroInternoEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            {/* (2026-10) fechas */}
            <Row>
              <Col md={6}>
                <Label>Fecha de la orden</Label>
                <Input
                  type="date"
                  value={fechaOrdenEdit}
                  onChange={(e) => {
                    setFechaOrdenEdit(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label>Fecha de entrega</Label>
                <Input
                  type="date"
                  value={fechaEntregaEdit}
                  disabled={!pedidoEdit.id}
                  onChange={(e) => {
                    setFechaEntregaEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            {fechaEntregaEdit !== fechaEntregaOriginal && pedidoEdit.id ? (
              <small className="text-muted">
                Se cambia en el pedido {pedidoEdit.numero} (aplica a todas sus órdenes).
              </small>
            ) : null}
            <Row>
              <Col md={12}>
                <Label>Subárea</Label>
                <Input
                  type="text"
                  value={subAreaEdit}
                  onChange={(e) => {
                    setSubAreaEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="textarea"
                  value={observacionesEdit}
                  required
                  onChange={(e) => {
                    setObservacionesEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row></Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
        <ModalHeader toggle={toggleHabilitacion}>
          <h3>Entregar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacion}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={fechaHab}
                  onChange={(event) => {
                    setFechaHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFieldsHabilitacion.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="idHabilitacion"
                      type="select"
                      value={inputField.idHabilitacion}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {habilitacion
                        .sort((a, b) =>
                          a.descripcion > b.descripcion ? 1 : -1,
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.descripcion} {a.nombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsHabilitacion.length === 1}
                      onClick={() =>
                        handleRemoveFieldsHabilitaccion(inputField.id)
                      }
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHabilitacion}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
        <ModalHeader toggle={toggleEditHab}>
          <h3>Editar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacionEdit}>
            <Row>
              <Col md={9}>
                <Label>Observaiones</Label>
                <Input
                  bsSize="sm"
                  type="text"
                  value={observacionesHab}
                  onChange={(event) => {
                    setObservacionesHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Anterior</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Nueva</Label>
              </Col>
            </Row>

            {editHab.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="nombre"
                      type="string"
                      value={a.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidadAnterior}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacionEdit(a.id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasConsumo} toggle={toggleTelasConsumo}>
        <ModalHeader toggle={toggleTelasConsumo}>
          <h4>Agregar Consumo {selectedOrdenCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasConsumo}>
            <Label>Tela Asignada</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Consumo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
            </Row>

            {inputFieldsAnteriorConsumo.map((inputFieldAnt) => (
              <div key={inputFieldAnt.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.articulo}
                      disabled
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.color}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.unidad}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.cantidad}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="consumo"
                      type="number"
                      value={inputFieldAnt.consumo}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="piezas"
                      type="number"
                      value={inputFieldAnt.piezas}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoOrdenesCorte;
